/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function (e, t) { "use strict"; "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function (e) { if (!e.document) throw new Error("jQuery requires a window with a document"); return t(e) } : t(e) }("undefined" != typeof window ? window : this, function (C, e) { "use strict"; var t = [], r = Object.getPrototypeOf, s = t.slice, g = t.flat ? function (e) { return t.flat.call(e) } : function (e) { return t.concat.apply([], e) }, u = t.push, i = t.indexOf, n = {}, o = n.toString, v = n.hasOwnProperty, a = v.toString, l = a.call(Object), y = {}, m = function (e) { return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item }, x = function (e) { return null != e && e === e.window }, E = C.document, c = { type: !0, src: !0, nonce: !0, noModule: !0 }; function b(e, t, n) { var r, i, o = (n = n || E).createElement("script"); if (o.text = e, t) for (r in c) (i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i); n.head.appendChild(o).parentNode.removeChild(o) } function w(e) { return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? n[o.call(e)] || "object" : typeof e } var f = "3.6.0", S = function (e, t) { return new S.fn.init(e, t) }; function p(e) { var t = !!e && "length" in e && e.length, n = w(e); return !m(e) && !x(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e) } S.fn = S.prototype = { jquery: f, constructor: S, length: 0, toArray: function () { return s.call(this) }, get: function (e) { return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e] }, pushStack: function (e) { var t = S.merge(this.constructor(), e); return t.prevObject = this, t }, each: function (e) { return S.each(this, e) }, map: function (n) { return this.pushStack(S.map(this, function (e, t) { return n.call(e, t, e) })) }, slice: function () { return this.pushStack(s.apply(this, arguments)) }, first: function () { return this.eq(0) }, last: function () { return this.eq(-1) }, even: function () { return this.pushStack(S.grep(this, function (e, t) { return (t + 1) % 2 })) }, odd: function () { return this.pushStack(S.grep(this, function (e, t) { return t % 2 })) }, eq: function (e) { var t = this.length, n = +e + (e < 0 ? t : 0); return this.pushStack(0 <= n && n < t ? [this[n]] : []) }, end: function () { return this.prevObject || this.constructor() }, push: u, sort: t.sort, splice: t.splice }, S.extend = S.fn.extend = function () { var e, t, n, r, i, o, a = arguments[0] || {}, s = 1, u = arguments.length, l = !1; for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == typeof a || m(a) || (a = {}), s === u && (a = this, s--); s < u; s++)if (null != (e = arguments[s])) for (t in e) r = e[t], "__proto__" !== t && a !== r && (l && r && (S.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[t], o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}, i = !1, a[t] = S.extend(l, o, r)) : void 0 !== r && (a[t] = r)); return a }, S.extend({ expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (e) { throw new Error(e) }, noop: function () { }, isPlainObject: function (e) { var t, n; return !(!e || "[object Object]" !== o.call(e)) && (!(t = r(e)) || "function" == typeof (n = v.call(t, "constructor") && t.constructor) && a.call(n) === l) }, isEmptyObject: function (e) { var t; for (t in e) return !1; return !0 }, globalEval: function (e, t, n) { b(e, { nonce: t && t.nonce }, n) }, each: function (e, t) { var n, r = 0; if (p(e)) { for (n = e.length; r < n; r++)if (!1 === t.call(e[r], r, e[r])) break } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break; return e }, makeArray: function (e, t) { var n = t || []; return null != e && (p(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n }, inArray: function (e, t, n) { return null == t ? -1 : i.call(t, e, n) }, merge: function (e, t) { for (var n = +t.length, r = 0, i = e.length; r < n; r++)e[i++] = t[r]; return e.length = i, e }, grep: function (e, t, n) { for (var r = [], i = 0, o = e.length, a = !n; i < o; i++)!t(e[i], i) !== a && r.push(e[i]); return r }, map: function (e, t, n) { var r, i, o = 0, a = []; if (p(e)) for (r = e.length; o < r; o++)null != (i = t(e[o], o, n)) && a.push(i); else for (o in e) null != (i = t(e[o], o, n)) && a.push(i); return g(a) }, guid: 1, support: y }), "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]), S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) { n["[object " + t + "]"] = t.toLowerCase() }); var d = function (n) { var e, d, b, o, i, h, f, g, w, u, l, T, C, a, E, v, s, c, y, S = "sizzle" + 1 * new Date, p = n.document, k = 0, r = 0, m = ue(), x = ue(), A = ue(), N = ue(), j = function (e, t) { return e === t && (l = !0), 0 }, D = {}.hasOwnProperty, t = [], q = t.pop, L = t.push, H = t.push, O = t.slice, P = function (e, t) { for (var n = 0, r = e.length; n < r; n++)if (e[n] === t) return n; return -1 }, R = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", M = "[\\x20\\t\\r\\n\\f]", I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", W = "\\[" + M + "*(" + I + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + M + "*\\]", F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)", B = new RegExp(M + "+", "g"), $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"), _ = new RegExp("^" + M + "*," + M + "*"), z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"), U = new RegExp(M + "|>"), X = new RegExp(F), V = new RegExp("^" + I + "$"), G = { ID: new RegExp("^#(" + I + ")"), CLASS: new RegExp("^\\.(" + I + ")"), TAG: new RegExp("^(" + I + "|[*])"), ATTR: new RegExp("^" + W), PSEUDO: new RegExp("^" + F), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"), bool: new RegExp("^(?:" + R + ")$", "i"), needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i") }, Y = /HTML$/i, Q = /^(?:input|select|textarea|button)$/i, J = /^h\d$/i, K = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ee = /[+~]/, te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"), ne = function (e, t) { var n = "0x" + e.slice(1) - 65536; return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320)) }, re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ie = function (e, t) { return t ? "\0" === e ? "\ufffd" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e }, oe = function () { T() }, ae = be(function (e) { return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase() }, { dir: "parentNode", next: "legend" }); try { H.apply(t = O.call(p.childNodes), p.childNodes), t[p.childNodes.length].nodeType } catch (e) { H = { apply: t.length ? function (e, t) { L.apply(e, O.call(t)) } : function (e, t) { var n = e.length, r = 0; while (e[n++] = t[r++]); e.length = n - 1 } } } function se(t, e, n, r) { var i, o, a, s, u, l, c, f = e && e.ownerDocument, p = e ? e.nodeType : 9; if (n = n || [], "string" != typeof t || !t || 1 !== p && 9 !== p && 11 !== p) return n; if (!r && (T(e), e = e || C, E)) { if (11 !== p && (u = Z.exec(t))) if (i = u[1]) { if (9 === p) { if (!(a = e.getElementById(i))) return n; if (a.id === i) return n.push(a), n } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i) return n.push(a), n } else { if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n; if ((i = u[3]) && d.getElementsByClassName && e.getElementsByClassName) return H.apply(n, e.getElementsByClassName(i)), n } if (d.qsa && !N[t + " "] && (!v || !v.test(t)) && (1 !== p || "object" !== e.nodeName.toLowerCase())) { if (c = t, f = e, 1 === p && (U.test(t) || z.test(t))) { (f = ee.test(t) && ye(e.parentNode) || e) === e && d.scope || ((s = e.getAttribute("id")) ? s = s.replace(re, ie) : e.setAttribute("id", s = S)), o = (l = h(t)).length; while (o--) l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]); c = l.join(",") } try { return H.apply(n, f.querySelectorAll(c)), n } catch (e) { N(t, !0) } finally { s === S && e.removeAttribute("id") } } } return g(t.replace($, "$1"), e, n, r) } function ue() { var r = []; return function e(t, n) { return r.push(t + " ") > b.cacheLength && delete e[r.shift()], e[t + " "] = n } } function le(e) { return e[S] = !0, e } function ce(e) { var t = C.createElement("fieldset"); try { return !!e(t) } catch (e) { return !1 } finally { t.parentNode && t.parentNode.removeChild(t), t = null } } function fe(e, t) { var n = e.split("|"), r = n.length; while (r--) b.attrHandle[n[r]] = t } function pe(e, t) { var n = t && e, r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex; if (r) return r; if (n) while (n = n.nextSibling) if (n === t) return -1; return e ? 1 : -1 } function de(t) { return function (e) { return "input" === e.nodeName.toLowerCase() && e.type === t } } function he(n) { return function (e) { var t = e.nodeName.toLowerCase(); return ("input" === t || "button" === t) && e.type === n } } function ge(t) { return function (e) { return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && ae(e) === t : e.disabled === t : "label" in e && e.disabled === t } } function ve(a) { return le(function (o) { return o = +o, le(function (e, t) { var n, r = a([], e.length, o), i = r.length; while (i--) e[n = r[i]] && (e[n] = !(t[n] = e[n])) }) }) } function ye(e) { return e && "undefined" != typeof e.getElementsByTagName && e } for (e in d = se.support = {}, i = se.isXML = function (e) { var t = e && e.namespaceURI, n = e && (e.ownerDocument || e).documentElement; return !Y.test(t || n && n.nodeName || "HTML") }, T = se.setDocument = function (e) { var t, n, r = e ? e.ownerDocument || e : p; return r != C && 9 === r.nodeType && r.documentElement && (a = (C = r).documentElement, E = !i(C), p != C && (n = C.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", oe, !1) : n.attachEvent && n.attachEvent("onunload", oe)), d.scope = ce(function (e) { return a.appendChild(e).appendChild(C.createElement("div")), "undefined" != typeof e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length }), d.attributes = ce(function (e) { return e.className = "i", !e.getAttribute("className") }), d.getElementsByTagName = ce(function (e) { return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length }), d.getElementsByClassName = K.test(C.getElementsByClassName), d.getById = ce(function (e) { return a.appendChild(e).id = S, !C.getElementsByName || !C.getElementsByName(S).length }), d.getById ? (b.filter.ID = function (e) { var t = e.replace(te, ne); return function (e) { return e.getAttribute("id") === t } }, b.find.ID = function (e, t) { if ("undefined" != typeof t.getElementById && E) { var n = t.getElementById(e); return n ? [n] : [] } }) : (b.filter.ID = function (e) { var n = e.replace(te, ne); return function (e) { var t = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id"); return t && t.value === n } }, b.find.ID = function (e, t) { if ("undefined" != typeof t.getElementById && E) { var n, r, i, o = t.getElementById(e); if (o) { if ((n = o.getAttributeNode("id")) && n.value === e) return [o]; i = t.getElementsByName(e), r = 0; while (o = i[r++]) if ((n = o.getAttributeNode("id")) && n.value === e) return [o] } return [] } }), b.find.TAG = d.getElementsByTagName ? function (e, t) { return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : d.qsa ? t.querySelectorAll(e) : void 0 } : function (e, t) { var n, r = [], i = 0, o = t.getElementsByTagName(e); if ("*" === e) { while (n = o[i++]) 1 === n.nodeType && r.push(n); return r } return o }, b.find.CLASS = d.getElementsByClassName && function (e, t) { if ("undefined" != typeof t.getElementsByClassName && E) return t.getElementsByClassName(e) }, s = [], v = [], (d.qsa = K.test(C.querySelectorAll)) && (ce(function (e) { var t; a.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + M + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || v.push("\\[" + M + "*(?:value|" + R + ")"), e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="), (t = C.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || v.push(":checked"), e.querySelectorAll("a#" + S + "+*").length || v.push(".#.+[+~]"), e.querySelectorAll("\\\f"), v.push("[\\r\\n\\f]") }), ce(function (e) { e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>"; var t = C.createElement("input"); t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && v.push("name" + M + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), a.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), v.push(",.*:") })), (d.matchesSelector = K.test(c = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector)) && ce(function (e) { d.disconnectedMatch = c.call(e, "*"), c.call(e, "[s!='']:x"), s.push("!=", F) }), v = v.length && new RegExp(v.join("|")), s = s.length && new RegExp(s.join("|")), t = K.test(a.compareDocumentPosition), y = t || K.test(a.contains) ? function (e, t) { var n = 9 === e.nodeType ? e.documentElement : e, r = t && t.parentNode; return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))) } : function (e, t) { if (t) while (t = t.parentNode) if (t === e) return !0; return !1 }, j = t ? function (e, t) { if (e === t) return l = !0, 0; var n = !e.compareDocumentPosition - !t.compareDocumentPosition; return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !d.sortDetached && t.compareDocumentPosition(e) === n ? e == C || e.ownerDocument == p && y(p, e) ? -1 : t == C || t.ownerDocument == p && y(p, t) ? 1 : u ? P(u, e) - P(u, t) : 0 : 4 & n ? -1 : 1) } : function (e, t) { if (e === t) return l = !0, 0; var n, r = 0, i = e.parentNode, o = t.parentNode, a = [e], s = [t]; if (!i || !o) return e == C ? -1 : t == C ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0; if (i === o) return pe(e, t); n = e; while (n = n.parentNode) a.unshift(n); n = t; while (n = n.parentNode) s.unshift(n); while (a[r] === s[r]) r++; return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0 }), C }, se.matches = function (e, t) { return se(e, null, null, t) }, se.matchesSelector = function (e, t) { if (T(e), d.matchesSelector && E && !N[t + " "] && (!s || !s.test(t)) && (!v || !v.test(t))) try { var n = c.call(e, t); if (n || d.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n } catch (e) { N(t, !0) } return 0 < se(t, C, null, [e]).length }, se.contains = function (e, t) { return (e.ownerDocument || e) != C && T(e), y(e, t) }, se.attr = function (e, t) { (e.ownerDocument || e) != C && T(e); var n = b.attrHandle[t.toLowerCase()], r = n && D.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0; return void 0 !== r ? r : d.attributes || !E ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null }, se.escape = function (e) { return (e + "").replace(re, ie) }, se.error = function (e) { throw new Error("Syntax error, unrecognized expression: " + e) }, se.uniqueSort = function (e) { var t, n = [], r = 0, i = 0; if (l = !d.detectDuplicates, u = !d.sortStable && e.slice(0), e.sort(j), l) { while (t = e[i++]) t === e[i] && (r = n.push(i)); while (r--) e.splice(n[r], 1) } return u = null, e }, o = se.getText = function (e) { var t, n = "", r = 0, i = e.nodeType; if (i) { if (1 === i || 9 === i || 11 === i) { if ("string" == typeof e.textContent) return e.textContent; for (e = e.firstChild; e; e = e.nextSibling)n += o(e) } else if (3 === i || 4 === i) return e.nodeValue } else while (t = e[r++]) n += o(t); return n }, (b = se.selectors = { cacheLength: 50, createPseudo: le, match: G, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function (e) { return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4) }, CHILD: function (e) { return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e }, PSEUDO: function (e) { var t, n = !e[6] && e[2]; return G.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = h(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3)) } }, filter: { TAG: function (e) { var t = e.replace(te, ne).toLowerCase(); return "*" === e ? function () { return !0 } : function (e) { return e.nodeName && e.nodeName.toLowerCase() === t } }, CLASS: function (e) { var t = m[e + " "]; return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && m(e, function (e) { return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "") }) }, ATTR: function (n, r, i) { return function (e) { var t = se.attr(e, n); return null == t ? "!=" === r : !r || (t += "", "=" === r ? t === i : "!=" === r ? t !== i : "^=" === r ? i && 0 === t.indexOf(i) : "*=" === r ? i && -1 < t.indexOf(i) : "$=" === r ? i && t.slice(-i.length) === i : "~=" === r ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i) : "|=" === r && (t === i || t.slice(0, i.length + 1) === i + "-")) } }, CHILD: function (h, e, t, g, v) { var y = "nth" !== h.slice(0, 3), m = "last" !== h.slice(-4), x = "of-type" === e; return 1 === g && 0 === v ? function (e) { return !!e.parentNode } : function (e, t, n) { var r, i, o, a, s, u, l = y !== m ? "nextSibling" : "previousSibling", c = e.parentNode, f = x && e.nodeName.toLowerCase(), p = !n && !x, d = !1; if (c) { if (y) { while (l) { a = e; while (a = a[l]) if (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) return !1; u = l = "only" === h && !u && "nextSibling" } return !0 } if (u = [m ? c.firstChild : c.lastChild], m && p) { d = (s = (r = (i = (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]) && r[2], a = s && c.childNodes[s]; while (a = ++s && a && a[l] || (d = s = 0) || u.pop()) if (1 === a.nodeType && ++d && a === e) { i[h] = [k, s, d]; break } } else if (p && (d = s = (r = (i = (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]), !1 === d) while (a = ++s && a && a[l] || (d = s = 0) || u.pop()) if ((x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) && ++d && (p && ((i = (o = a[S] || (a[S] = {}))[a.uniqueID] || (o[a.uniqueID] = {}))[h] = [k, d]), a === e)) break; return (d -= v) === g || d % g == 0 && 0 <= d / g } } }, PSEUDO: function (e, o) { var t, a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e); return a[S] ? a(o) : 1 < a.length ? (t = [e, e, "", o], b.setFilters.hasOwnProperty(e.toLowerCase()) ? le(function (e, t) { var n, r = a(e, o), i = r.length; while (i--) e[n = P(e, r[i])] = !(t[n] = r[i]) }) : function (e) { return a(e, 0, t) }) : a } }, pseudos: { not: le(function (e) { var r = [], i = [], s = f(e.replace($, "$1")); return s[S] ? le(function (e, t, n, r) { var i, o = s(e, null, r, []), a = e.length; while (a--) (i = o[a]) && (e[a] = !(t[a] = i)) }) : function (e, t, n) { return r[0] = e, s(r, null, n, i), r[0] = null, !i.pop() } }), has: le(function (t) { return function (e) { return 0 < se(t, e).length } }), contains: le(function (t) { return t = t.replace(te, ne), function (e) { return -1 < (e.textContent || o(e)).indexOf(t) } }), lang: le(function (n) { return V.test(n || "") || se.error("unsupported lang: " + n), n = n.replace(te, ne).toLowerCase(), function (e) { var t; do { if (t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-") } while ((e = e.parentNode) && 1 === e.nodeType); return !1 } }), target: function (e) { var t = n.location && n.location.hash; return t && t.slice(1) === e.id }, root: function (e) { return e === a }, focus: function (e) { return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex) }, enabled: ge(!1), disabled: ge(!0), checked: function (e) { var t = e.nodeName.toLowerCase(); return "input" === t && !!e.checked || "option" === t && !!e.selected }, selected: function (e) { return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected }, empty: function (e) { for (e = e.firstChild; e; e = e.nextSibling)if (e.nodeType < 6) return !1; return !0 }, parent: function (e) { return !b.pseudos.empty(e) }, header: function (e) { return J.test(e.nodeName) }, input: function (e) { return Q.test(e.nodeName) }, button: function (e) { var t = e.nodeName.toLowerCase(); return "input" === t && "button" === e.type || "button" === t }, text: function (e) { var t; return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase()) }, first: ve(function () { return [0] }), last: ve(function (e, t) { return [t - 1] }), eq: ve(function (e, t, n) { return [n < 0 ? n + t : n] }), even: ve(function (e, t) { for (var n = 0; n < t; n += 2)e.push(n); return e }), odd: ve(function (e, t) { for (var n = 1; n < t; n += 2)e.push(n); return e }), lt: ve(function (e, t, n) { for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r;)e.push(r); return e }), gt: ve(function (e, t, n) { for (var r = n < 0 ? n + t : n; ++r < t;)e.push(r); return e }) } }).pseudos.nth = b.pseudos.eq, { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) b.pseudos[e] = de(e); for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e); function me() { } function xe(e) { for (var t = 0, n = e.length, r = ""; t < n; t++)r += e[t].value; return r } function be(s, e, t) { var u = e.dir, l = e.next, c = l || u, f = t && "parentNode" === c, p = r++; return e.first ? function (e, t, n) { while (e = e[u]) if (1 === e.nodeType || f) return s(e, t, n); return !1 } : function (e, t, n) { var r, i, o, a = [k, p]; if (n) { while (e = e[u]) if ((1 === e.nodeType || f) && s(e, t, n)) return !0 } else while (e = e[u]) if (1 === e.nodeType || f) if (i = (o = e[S] || (e[S] = {}))[e.uniqueID] || (o[e.uniqueID] = {}), l && l === e.nodeName.toLowerCase()) e = e[u] || e; else { if ((r = i[c]) && r[0] === k && r[1] === p) return a[2] = r[2]; if ((i[c] = a)[2] = s(e, t, n)) return !0 } return !1 } } function we(i) { return 1 < i.length ? function (e, t, n) { var r = i.length; while (r--) if (!i[r](e, t, n)) return !1; return !0 } : i[0] } function Te(e, t, n, r, i) { for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)(o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s))); return a } function Ce(d, h, g, v, y, e) { return v && !v[S] && (v = Ce(v)), y && !y[S] && (y = Ce(y, e)), le(function (e, t, n, r) { var i, o, a, s = [], u = [], l = t.length, c = e || function (e, t, n) { for (var r = 0, i = t.length; r < i; r++)se(e, t[r], n); return n }(h || "*", n.nodeType ? [n] : n, []), f = !d || !e && h ? c : Te(c, s, d, n, r), p = g ? y || (e ? d : l || v) ? [] : t : f; if (g && g(f, p, n, r), v) { i = Te(p, u), v(i, [], n, r), o = i.length; while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a)) } if (e) { if (y || d) { if (y) { i = [], o = p.length; while (o--) (a = p[o]) && i.push(f[o] = a); y(null, p = [], i, r) } o = p.length; while (o--) (a = p[o]) && -1 < (i = y ? P(e, a) : s[o]) && (e[i] = !(t[i] = a)) } } else p = Te(p === t ? p.splice(l, p.length) : p), y ? y(null, t, p, r) : H.apply(t, p) }) } function Ee(e) { for (var i, t, n, r = e.length, o = b.relative[e[0].type], a = o || b.relative[" "], s = o ? 1 : 0, u = be(function (e) { return e === i }, a, !0), l = be(function (e) { return -1 < P(i, e) }, a, !0), c = [function (e, t, n) { var r = !o && (n || t !== w) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n)); return i = null, r }]; s < r; s++)if (t = b.relative[e[s].type]) c = [be(we(c), t)]; else { if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) { for (n = ++s; n < r; n++)if (b.relative[e[n].type]) break; return Ce(1 < s && we(c), 1 < s && xe(e.slice(0, s - 1).concat({ value: " " === e[s - 2].type ? "*" : "" })).replace($, "$1"), t, s < n && Ee(e.slice(s, n)), n < r && Ee(e = e.slice(n)), n < r && xe(e)) } c.push(t) } return we(c) } return me.prototype = b.filters = b.pseudos, b.setFilters = new me, h = se.tokenize = function (e, t) { var n, r, i, o, a, s, u, l = x[e + " "]; if (l) return t ? 0 : l.slice(0); a = e, s = [], u = b.preFilter; while (a) { for (o in n && !(r = _.exec(a)) || (r && (a = a.slice(r[0].length) || a), s.push(i = [])), n = !1, (r = z.exec(a)) && (n = r.shift(), i.push({ value: n, type: r[0].replace($, " ") }), a = a.slice(n.length)), b.filter) !(r = G[o].exec(a)) || u[o] && !(r = u[o](r)) || (n = r.shift(), i.push({ value: n, type: o, matches: r }), a = a.slice(n.length)); if (!n) break } return t ? a.length : a ? se.error(e) : x(e, s).slice(0) }, f = se.compile = function (e, t) { var n, v, y, m, x, r, i = [], o = [], a = A[e + " "]; if (!a) { t || (t = h(e)), n = t.length; while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a); (a = A(e, (v = o, m = 0 < (y = i).length, x = 0 < v.length, r = function (e, t, n, r, i) { var o, a, s, u = 0, l = "0", c = e && [], f = [], p = w, d = e || x && b.find.TAG("*", i), h = k += null == p ? 1 : Math.random() || .1, g = d.length; for (i && (w = t == C || t || i); l !== g && null != (o = d[l]); l++) { if (x && o) { a = 0, t || o.ownerDocument == C || (T(o), n = !E); while (s = v[a++]) if (s(o, t || C, n)) { r.push(o); break } i && (k = h) } m && ((o = !s && o) && u--, e && c.push(o)) } if (u += l, m && l !== u) { a = 0; while (s = y[a++]) s(c, f, t, n); if (e) { if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r)); f = Te(f) } H.apply(r, f), i && !e && 0 < f.length && 1 < u + y.length && se.uniqueSort(r) } return i && (k = h, w = p), c }, m ? le(r) : r))).selector = e } return a }, g = se.select = function (e, t, n, r) { var i, o, a, s, u, l = "function" == typeof e && e, c = !r && h(e = l.selector || e); if (n = n || [], 1 === c.length) { if (2 < (o = c[0] = c[0].slice(0)).length && "ID" === (a = o[0]).type && 9 === t.nodeType && E && b.relative[o[1].type]) { if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0])) return n; l && (t = t.parentNode), e = e.slice(o.shift().value.length) } i = G.needsContext.test(e) ? 0 : o.length; while (i--) { if (a = o[i], b.relative[s = a.type]) break; if ((u = b.find[s]) && (r = u(a.matches[0].replace(te, ne), ee.test(o[0].type) && ye(t.parentNode) || t))) { if (o.splice(i, 1), !(e = r.length && xe(o))) return H.apply(n, r), n; break } } } return (l || f(e, c))(r, t, !E, n, !t || ee.test(e) && ye(t.parentNode) || t), n }, d.sortStable = S.split("").sort(j).join("") === S, d.detectDuplicates = !!l, T(), d.sortDetached = ce(function (e) { return 1 & e.compareDocumentPosition(C.createElement("fieldset")) }), ce(function (e) { return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href") }) || fe("type|href|height|width", function (e, t, n) { if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2) }), d.attributes && ce(function (e) { return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value") }) || fe("value", function (e, t, n) { if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue }), ce(function (e) { return null == e.getAttribute("disabled") }) || fe(R, function (e, t, n) { var r; if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null }), se }(C); S.find = d, S.expr = d.selectors, S.expr[":"] = S.expr.pseudos, S.uniqueSort = S.unique = d.uniqueSort, S.text = d.getText, S.isXMLDoc = d.isXML, S.contains = d.contains, S.escapeSelector = d.escape; var h = function (e, t, n) { var r = [], i = void 0 !== n; while ((e = e[t]) && 9 !== e.nodeType) if (1 === e.nodeType) { if (i && S(e).is(n)) break; r.push(e) } return r }, T = function (e, t) { for (var n = []; e; e = e.nextSibling)1 === e.nodeType && e !== t && n.push(e); return n }, k = S.expr.match.needsContext; function A(e, t) { return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase() } var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i; function j(e, n, r) { return m(n) ? S.grep(e, function (e, t) { return !!n.call(e, t, e) !== r }) : n.nodeType ? S.grep(e, function (e) { return e === n !== r }) : "string" != typeof n ? S.grep(e, function (e) { return -1 < i.call(n, e) !== r }) : S.filter(n, e, r) } S.filter = function (e, t, n) { var r = t[0]; return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? S.find.matchesSelector(r, e) ? [r] : [] : S.find.matches(e, S.grep(t, function (e) { return 1 === e.nodeType })) }, S.fn.extend({ find: function (e) { var t, n, r = this.length, i = this; if ("string" != typeof e) return this.pushStack(S(e).filter(function () { for (t = 0; t < r; t++)if (S.contains(i[t], this)) return !0 })); for (n = this.pushStack([]), t = 0; t < r; t++)S.find(e, i[t], n); return 1 < r ? S.uniqueSort(n) : n }, filter: function (e) { return this.pushStack(j(this, e || [], !1)) }, not: function (e) { return this.pushStack(j(this, e || [], !0)) }, is: function (e) { return !!j(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1).length } }); var D, q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/; (S.fn.init = function (e, t, n) { var r, i; if (!e) return this; if (n = n || D, "string" == typeof e) { if (!(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : q.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e); if (r[1]) { if (t = t instanceof S ? t[0] : t, S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)), N.test(r[1]) && S.isPlainObject(t)) for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]); return this } return (i = E.getElementById(r[2])) && (this[0] = i, this.length = 1), this } return e.nodeType ? (this[0] = e, this.length = 1, this) : m(e) ? void 0 !== n.ready ? n.ready(e) : e(S) : S.makeArray(e, this) }).prototype = S.fn, D = S(E); var L = /^(?:parents|prev(?:Until|All))/, H = { children: !0, contents: !0, next: !0, prev: !0 }; function O(e, t) { while ((e = e[t]) && 1 !== e.nodeType); return e } S.fn.extend({ has: function (e) { var t = S(e, this), n = t.length; return this.filter(function () { for (var e = 0; e < n; e++)if (S.contains(this, t[e])) return !0 }) }, closest: function (e, t) { var n, r = 0, i = this.length, o = [], a = "string" != typeof e && S(e); if (!k.test(e)) for (; r < i; r++)for (n = this[r]; n && n !== t; n = n.parentNode)if (n.nodeType < 11 && (a ? -1 < a.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))) { o.push(n); break } return this.pushStack(1 < o.length ? S.uniqueSort(o) : o) }, index: function (e) { return e ? "string" == typeof e ? i.call(S(e), this[0]) : i.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1 }, add: function (e, t) { return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t)))) }, addBack: function (e) { return this.add(null == e ? this.prevObject : this.prevObject.filter(e)) } }), S.each({ parent: function (e) { var t = e.parentNode; return t && 11 !== t.nodeType ? t : null }, parents: function (e) { return h(e, "parentNode") }, parentsUntil: function (e, t, n) { return h(e, "parentNode", n) }, next: function (e) { return O(e, "nextSibling") }, prev: function (e) { return O(e, "previousSibling") }, nextAll: function (e) { return h(e, "nextSibling") }, prevAll: function (e) { return h(e, "previousSibling") }, nextUntil: function (e, t, n) { return h(e, "nextSibling", n) }, prevUntil: function (e, t, n) { return h(e, "previousSibling", n) }, siblings: function (e) { return T((e.parentNode || {}).firstChild, e) }, children: function (e) { return T(e.firstChild) }, contents: function (e) { return null != e.contentDocument && r(e.contentDocument) ? e.contentDocument : (A(e, "template") && (e = e.content || e), S.merge([], e.childNodes)) } }, function (r, i) { S.fn[r] = function (e, t) { var n = S.map(this, i, e); return "Until" !== r.slice(-5) && (t = e), t && "string" == typeof t && (n = S.filter(t, n)), 1 < this.length && (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()), this.pushStack(n) } }); var P = /[^\x20\t\r\n\f]+/g; function R(e) { return e } function M(e) { throw e } function I(e, t, n, r) { var i; try { e && m(i = e.promise) ? i.call(e).done(t).fail(n) : e && m(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r)) } catch (e) { n.apply(void 0, [e]) } } S.Callbacks = function (r) { var e, n; r = "string" == typeof r ? (e = r, n = {}, S.each(e.match(P) || [], function (e, t) { n[t] = !0 }), n) : S.extend({}, r); var i, t, o, a, s = [], u = [], l = -1, c = function () { for (a = a || r.once, o = i = !0; u.length; l = -1) { t = u.shift(); while (++l < s.length) !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && (l = s.length, t = !1) } r.memory || (t = !1), i = !1, a && (s = t ? [] : "") }, f = { add: function () { return s && (t && !i && (l = s.length - 1, u.push(t)), function n(e) { S.each(e, function (e, t) { m(t) ? r.unique && f.has(t) || s.push(t) : t && t.length && "string" !== w(t) && n(t) }) }(arguments), t && !i && c()), this }, remove: function () { return S.each(arguments, function (e, t) { var n; while (-1 < (n = S.inArray(t, s, n))) s.splice(n, 1), n <= l && l-- }), this }, has: function (e) { return e ? -1 < S.inArray(e, s) : 0 < s.length }, empty: function () { return s && (s = []), this }, disable: function () { return a = u = [], s = t = "", this }, disabled: function () { return !s }, lock: function () { return a = u = [], t || i || (s = t = ""), this }, locked: function () { return !!a }, fireWith: function (e, t) { return a || (t = [e, (t = t || []).slice ? t.slice() : t], u.push(t), i || c()), this }, fire: function () { return f.fireWith(this, arguments), this }, fired: function () { return !!o } }; return f }, S.extend({ Deferred: function (e) { var o = [["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2], ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"]], i = "pending", a = { state: function () { return i }, always: function () { return s.done(arguments).fail(arguments), this }, "catch": function (e) { return a.then(null, e) }, pipe: function () { var i = arguments; return S.Deferred(function (r) { S.each(o, function (e, t) { var n = m(i[t[4]]) && i[t[4]]; s[t[1]](function () { var e = n && n.apply(this, arguments); e && m(e.promise) ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject) : r[t[0] + "With"](this, n ? [e] : arguments) }) }), i = null }).promise() }, then: function (t, n, r) { var u = 0; function l(i, o, a, s) { return function () { var n = this, r = arguments, e = function () { var e, t; if (!(i < u)) { if ((e = a.apply(n, r)) === o.promise()) throw new TypeError("Thenable self-resolution"); t = e && ("object" == typeof e || "function" == typeof e) && e.then, m(t) ? s ? t.call(e, l(u, o, R, s), l(u, o, M, s)) : (u++, t.call(e, l(u, o, R, s), l(u, o, M, s), l(u, o, R, o.notifyWith))) : (a !== R && (n = void 0, r = [e]), (s || o.resolveWith)(n, r)) } }, t = s ? e : function () { try { e() } catch (e) { S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace), u <= i + 1 && (a !== M && (n = void 0, r = [e]), o.rejectWith(n, r)) } }; i ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()), C.setTimeout(t)) } } return S.Deferred(function (e) { o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)), o[1][3].add(l(0, e, m(t) ? t : R)), o[2][3].add(l(0, e, m(n) ? n : M)) }).promise() }, promise: function (e) { return null != e ? S.extend(e, a) : a } }, s = {}; return S.each(o, function (e, t) { var n = t[2], r = t[5]; a[t[1]] = n.add, r && n.add(function () { i = r }, o[3 - e][2].disable, o[3 - e][3].disable, o[0][2].lock, o[0][3].lock), n.add(t[3].fire), s[t[0]] = function () { return s[t[0] + "With"](this === s ? void 0 : this, arguments), this }, s[t[0] + "With"] = n.fireWith }), a.promise(s), e && e.call(s, s), s }, when: function (e) { var n = arguments.length, t = n, r = Array(t), i = s.call(arguments), o = S.Deferred(), a = function (t) { return function (e) { r[t] = this, i[t] = 1 < arguments.length ? s.call(arguments) : e, --n || o.resolveWith(r, i) } }; if (n <= 1 && (I(e, o.done(a(t)).resolve, o.reject, !n), "pending" === o.state() || m(i[t] && i[t].then))) return o.then(); while (t--) I(i[t], a(t), o.reject); return o.promise() } }); var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/; S.Deferred.exceptionHook = function (e, t) { C.console && C.console.warn && e && W.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t) }, S.readyException = function (e) { C.setTimeout(function () { throw e }) }; var F = S.Deferred(); function B() { E.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), S.ready() } S.fn.ready = function (e) { return F.then(e)["catch"](function (e) { S.readyException(e) }), this }, S.extend({ isReady: !1, readyWait: 1, ready: function (e) { (!0 === e ? --S.readyWait : S.isReady) || (S.isReady = !0) !== e && 0 < --S.readyWait || F.resolveWith(E, [S]) } }), S.ready.then = F.then, "complete" === E.readyState || "loading" !== E.readyState && !E.documentElement.doScroll ? C.setTimeout(S.ready) : (E.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B)); var $ = function (e, t, n, r, i, o, a) { var s = 0, u = e.length, l = null == n; if ("object" === w(n)) for (s in i = !0, n) $(e, t, s, n[s], !0, o, a); else if (void 0 !== r && (i = !0, m(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function (e, t, n) { return l.call(S(e), n) })), t)) for (; s < u; s++)t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n))); return i ? e : l ? t.call(e) : u ? t(e[0], n) : o }, _ = /^-ms-/, z = /-([a-z])/g; function U(e, t) { return t.toUpperCase() } function X(e) { return e.replace(_, "ms-").replace(z, U) } var V = function (e) { return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType }; function G() { this.expando = S.expando + G.uid++ } G.uid = 1, G.prototype = { cache: function (e) { var t = e[this.expando]; return t || (t = {}, V(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t }, set: function (e, t, n) { var r, i = this.cache(e); if ("string" == typeof t) i[X(t)] = n; else for (r in t) i[X(r)] = t[r]; return i }, get: function (e, t) { return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)] }, access: function (e, t, n) { return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t) }, remove: function (e, t) { var n, r = e[this.expando]; if (void 0 !== r) { if (void 0 !== t) { n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(P) || []).length; while (n--) delete r[t[n]] } (void 0 === t || S.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]) } }, hasData: function (e) { var t = e[this.expando]; return void 0 !== t && !S.isEmptyObject(t) } }; var Y = new G, Q = new G, J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, K = /[A-Z]/g; function Z(e, t, n) { var r, i; if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(K, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) { try { n = "true" === (i = n) || "false" !== i && ("null" === i ? null : i === +i + "" ? +i : J.test(i) ? JSON.parse(i) : i) } catch (e) { } Q.set(e, t, n) } else n = void 0; return n } S.extend({ hasData: function (e) { return Q.hasData(e) || Y.hasData(e) }, data: function (e, t, n) { return Q.access(e, t, n) }, removeData: function (e, t) { Q.remove(e, t) }, _data: function (e, t, n) { return Y.access(e, t, n) }, _removeData: function (e, t) { Y.remove(e, t) } }), S.fn.extend({ data: function (n, e) { var t, r, i, o = this[0], a = o && o.attributes; if (void 0 === n) { if (this.length && (i = Q.get(o), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) { t = a.length; while (t--) a[t] && 0 === (r = a[t].name).indexOf("data-") && (r = X(r.slice(5)), Z(o, r, i[r])); Y.set(o, "hasDataAttrs", !0) } return i } return "object" == typeof n ? this.each(function () { Q.set(this, n) }) : $(this, function (e) { var t; if (o && void 0 === e) return void 0 !== (t = Q.get(o, n)) ? t : void 0 !== (t = Z(o, n)) ? t : void 0; this.each(function () { Q.set(this, n, e) }) }, null, e, 1 < arguments.length, null, !0) }, removeData: function (e) { return this.each(function () { Q.remove(this, e) }) } }), S.extend({ queue: function (e, t, n) { var r; if (e) return t = (t || "fx") + "queue", r = Y.get(e, t), n && (!r || Array.isArray(n) ? r = Y.access(e, t, S.makeArray(n)) : r.push(n)), r || [] }, dequeue: function (e, t) { t = t || "fx"; var n = S.queue(e, t), r = n.length, i = n.shift(), o = S._queueHooks(e, t); "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () { S.dequeue(e, t) }, o)), !r && o && o.empty.fire() }, _queueHooks: function (e, t) { var n = t + "queueHooks"; return Y.get(e, n) || Y.access(e, n, { empty: S.Callbacks("once memory").add(function () { Y.remove(e, [t + "queue", n]) }) }) } }), S.fn.extend({ queue: function (t, n) { var e = 2; return "string" != typeof t && (n = t, t = "fx", e--), arguments.length < e ? S.queue(this[0], t) : void 0 === n ? this : this.each(function () { var e = S.queue(this, t, n); S._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t) }) }, dequeue: function (e) { return this.each(function () { S.dequeue(this, e) }) }, clearQueue: function (e) { return this.queue(e || "fx", []) }, promise: function (e, t) { var n, r = 1, i = S.Deferred(), o = this, a = this.length, s = function () { --r || i.resolveWith(o, [o]) }; "string" != typeof e && (t = e, e = void 0), e = e || "fx"; while (a--) (n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s)); return s(), i.promise(t) } }); var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"), ne = ["Top", "Right", "Bottom", "Left"], re = E.documentElement, ie = function (e) { return S.contains(e.ownerDocument, e) }, oe = { composed: !0 }; re.getRootNode && (ie = function (e) { return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument }); var ae = function (e, t) { return "none" === (e = t || e).style.display || "" === e.style.display && ie(e) && "none" === S.css(e, "display") }; function se(e, t, n, r) { var i, o, a = 20, s = r ? function () { return r.cur() } : function () { return S.css(e, t, "") }, u = s(), l = n && n[3] || (S.cssNumber[t] ? "" : "px"), c = e.nodeType && (S.cssNumber[t] || "px" !== l && +u) && te.exec(S.css(e, t)); if (c && c[3] !== l) { u /= 2, l = l || c[3], c = +u || 1; while (a--) S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o; c *= 2, S.style(e, t, c + l), n = n || [] } return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i } var ue = {}; function le(e, t) { for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)(r = e[c]).style && (n = r.style.display, t ? ("none" === n && (l[c] = Y.get(r, "display") || null, l[c] || (r.style.display = "")), "" === r.style.display && ae(r) && (l[c] = (u = a = o = void 0, a = (i = r).ownerDocument, s = i.nodeName, (u = ue[s]) || (o = a.body.appendChild(a.createElement(s)), u = S.css(o, "display"), o.parentNode.removeChild(o), "none" === u && (u = "block"), ue[s] = u)))) : "none" !== n && (l[c] = "none", Y.set(r, "display", n))); for (c = 0; c < f; c++)null != l[c] && (e[c].style.display = l[c]); return e } S.fn.extend({ show: function () { return le(this, !0) }, hide: function () { return le(this) }, toggle: function (e) { return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () { ae(this) ? S(this).show() : S(this).hide() }) } }); var ce, fe, pe = /^(?:checkbox|radio)$/i, de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, he = /^$|^module$|\/(?:java|ecma)script/i; ce = E.createDocumentFragment().appendChild(E.createElement("div")), (fe = E.createElement("input")).setAttribute("type", "radio"), fe.setAttribute("checked", "checked"), fe.setAttribute("name", "t"), ce.appendChild(fe), y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked, ce.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue, ce.innerHTML = "<option></option>", y.option = !!ce.lastChild; var ge = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] }; function ve(e, t) { var n; return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && A(e, t) ? S.merge([e], n) : n } function ye(e, t) { for (var n = 0, r = e.length; n < r; n++)Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval")) } ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td, y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]); var me = /<|&#?\w+;/; function xe(e, t, n, r, i) { for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)if ((o = e[d]) || 0 === o) if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o); else if (me.test(o)) { a = a || f.appendChild(t.createElement("div")), s = (de.exec(o) || ["", ""])[1].toLowerCase(), u = ge[s] || ge._default, a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2], c = u[0]; while (c--) a = a.lastChild; S.merge(p, a.childNodes), (a = f.firstChild).textContent = "" } else p.push(t.createTextNode(o)); f.textContent = "", d = 0; while (o = p[d++]) if (r && -1 < S.inArray(o, r)) i && i.push(o); else if (l = ie(o), a = ve(f.appendChild(o), "script"), l && ye(a), n) { c = 0; while (o = a[c++]) he.test(o.type || "") && n.push(o) } return f } var be = /^([^.]*)(?:\.(.+)|)/; function we() { return !0 } function Te() { return !1 } function Ce(e, t) { return e === function () { try { return E.activeElement } catch (e) { } }() == ("focus" === t) } function Ee(e, t, n, r, i, o) { var a, s; if ("object" == typeof t) { for (s in "string" != typeof n && (r = r || n, n = void 0), t) Ee(e, s, n, r, t[s], o); return e } if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Te; else if (!i) return e; return 1 === o && (a = i, (i = function (e) { return S().off(e), a.apply(this, arguments) }).guid = a.guid || (a.guid = S.guid++)), e.each(function () { S.event.add(this, t, i, r, n) }) } function Se(e, i, o) { o ? (Y.set(e, i, !1), S.event.add(e, i, { namespace: !1, handler: function (e) { var t, n, r = Y.get(this, i); if (1 & e.isTrigger && this[i]) { if (r.length) (S.event.special[i] || {}).delegateType && e.stopPropagation(); else if (r = s.call(arguments), Y.set(this, i, r), t = o(this, i), this[i](), r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : n = {}, r !== n) return e.stopImmediatePropagation(), e.preventDefault(), n && n.value } else r.length && (Y.set(this, i, { value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation()) } })) : void 0 === Y.get(e, i) && S.event.add(e, i, we) } S.event = { global: {}, add: function (t, e, n, r, i) { var o, a, s, u, l, c, f, p, d, h, g, v = Y.get(t); if (V(t)) { n.handler && (n = (o = n).handler, i = o.selector), i && S.find.matchesSelector(re, i), n.guid || (n.guid = S.guid++), (u = v.events) || (u = v.events = Object.create(null)), (a = v.handle) || (a = v.handle = function (e) { return "undefined" != typeof S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0 }), l = (e = (e || "").match(P) || [""]).length; while (l--) d = g = (s = be.exec(e[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = S.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = S.event.special[d] || {}, c = S.extend({ type: d, origType: g, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && S.expr.match.needsContext.test(i), namespace: h.join(".") }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(t, r, h, a) || t.addEventListener && t.addEventListener(d, a)), f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), S.event.global[d] = !0) } }, remove: function (e, t, n, r, i) { var o, a, s, u, l, c, f, p, d, h, g, v = Y.hasData(e) && Y.get(e); if (v && (u = v.events)) { l = (t = (t || "").match(P) || [""]).length; while (l--) if (d = g = (s = be.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d) { f = S.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; while (o--) c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c)); a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || S.removeEvent(e, d, v.handle), delete u[d]) } else for (d in u) S.event.remove(e, d + t[l], n, r, !0); S.isEmptyObject(u) && Y.remove(e, "handle events") } }, dispatch: function (e) { var t, n, r, i, o, a, s = new Array(arguments.length), u = S.event.fix(e), l = (Y.get(this, "events") || Object.create(null))[u.type] || [], c = S.event.special[u.type] || {}; for (s[0] = u, t = 1; t < arguments.length; t++)s[t] = arguments[t]; if (u.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, u)) { a = S.event.handlers.call(this, u, l), t = 0; while ((i = a[t++]) && !u.isPropagationStopped()) { u.currentTarget = i.elem, n = 0; while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped()) u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o, u.data = o.data, void 0 !== (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = r) && (u.preventDefault(), u.stopPropagation())) } return c.postDispatch && c.postDispatch.call(this, u), u.result } }, handlers: function (e, t) { var n, r, i, o, a, s = [], u = t.delegateCount, l = e.target; if (u && l.nodeType && !("click" === e.type && 1 <= e.button)) for (; l !== this; l = l.parentNode || this)if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) { for (o = [], a = {}, n = 0; n < u; n++)void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? -1 < S(i, this).index(l) : S.find(i, this, null, [l]).length), a[i] && o.push(r); o.length && s.push({ elem: l, handlers: o }) } return l = this, u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s }, addProp: function (t, e) { Object.defineProperty(S.Event.prototype, t, { enumerable: !0, configurable: !0, get: m(e) ? function () { if (this.originalEvent) return e(this.originalEvent) } : function () { if (this.originalEvent) return this.originalEvent[t] }, set: function (e) { Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) } }) }, fix: function (e) { return e[S.expando] ? e : new S.Event(e) }, special: { load: { noBubble: !0 }, click: { setup: function (e) { var t = this || e; return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click", we), !1 }, trigger: function (e) { var t = this || e; return pe.test(t.type) && t.click && A(t, "input") && Se(t, "click"), !0 }, _default: function (e) { var t = e.target; return pe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click") || A(t, "a") } }, beforeunload: { postDispatch: function (e) { void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result) } } } }, S.removeEvent = function (e, t, n) { e.removeEventListener && e.removeEventListener(t, n) }, S.Event = function (e, t) { if (!(this instanceof S.Event)) return new S.Event(e, t); e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? we : Te, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && S.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[S.expando] = !0 }, S.Event.prototype = { constructor: S.Event, isDefaultPrevented: Te, isPropagationStopped: Te, isImmediatePropagationStopped: Te, isSimulated: !1, preventDefault: function () { var e = this.originalEvent; this.isDefaultPrevented = we, e && !this.isSimulated && e.preventDefault() }, stopPropagation: function () { var e = this.originalEvent; this.isPropagationStopped = we, e && !this.isSimulated && e.stopPropagation() }, stopImmediatePropagation: function () { var e = this.originalEvent; this.isImmediatePropagationStopped = we, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation() } }, S.each({ altKey: !0, bubbles: !0, cancelable: !0, changedTouches: !0, ctrlKey: !0, detail: !0, eventPhase: !0, metaKey: !0, pageX: !0, pageY: !0, shiftKey: !0, view: !0, "char": !0, code: !0, charCode: !0, key: !0, keyCode: !0, button: !0, buttons: !0, clientX: !0, clientY: !0, offsetX: !0, offsetY: !0, pointerId: !0, pointerType: !0, screenX: !0, screenY: !0, targetTouches: !0, toElement: !0, touches: !0, which: !0 }, S.event.addProp), S.each({ focus: "focusin", blur: "focusout" }, function (e, t) { S.event.special[e] = { setup: function () { return Se(this, e, Ce), !1 }, trigger: function () { return Se(this, e), !0 }, _default: function () { return !0 }, delegateType: t } }), S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, i) { S.event.special[e] = { delegateType: i, bindType: i, handle: function (e) { var t, n = e.relatedTarget, r = e.handleObj; return n && (n === this || S.contains(this, n)) || (e.type = r.origType, t = r.handler.apply(this, arguments), e.type = i), t } } }), S.fn.extend({ on: function (e, t, n, r) { return Ee(this, e, t, n, r) }, one: function (e, t, n, r) { return Ee(this, e, t, n, r, 1) }, off: function (e, t, n) { var r, i; if (e && e.preventDefault && e.handleObj) return r = e.handleObj, S(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this; if ("object" == typeof e) { for (i in e) this.off(i, t, e[i]); return this } return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Te), this.each(function () { S.event.remove(this, e, n, t) }) } }); var ke = /<script|<style|<link/i, Ae = /checked\s*(?:[^=]|=\s*.checked.)/i, Ne = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g; function je(e, t) { return A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0] || e } function De(e) { return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e } function qe(e) { return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e } function Le(e, t) { var n, r, i, o, a, s; if (1 === t.nodeType) { if (Y.hasData(e) && (s = Y.get(e).events)) for (i in Y.remove(t, "handle events"), s) for (n = 0, r = s[i].length; n < r; n++)S.event.add(t, i, s[i][n]); Q.hasData(e) && (o = Q.access(e), a = S.extend({}, o), Q.set(t, a)) } } function He(n, r, i, o) { r = g(r); var e, t, a, s, u, l, c = 0, f = n.length, p = f - 1, d = r[0], h = m(d); if (h || 1 < f && "string" == typeof d && !y.checkClone && Ae.test(d)) return n.each(function (e) { var t = n.eq(e); h && (r[0] = d.call(this, e, t.html())), He(t, r, i, o) }); if (f && (t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild, 1 === e.childNodes.length && (e = t), t || o)) { for (s = (a = S.map(ve(e, "script"), De)).length; c < f; c++)u = e, c !== p && (u = S.clone(u, !0, !0), s && S.merge(a, ve(u, "script"))), i.call(n[c], u, c); if (s) for (l = a[a.length - 1].ownerDocument, S.map(a, qe), c = 0; c < s; c++)u = a[c], he.test(u.type || "") && !Y.access(u, "globalEval") && S.contains(l, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? S._evalUrl && !u.noModule && S._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, l) : b(u.textContent.replace(Ne, ""), u, l)) } return n } function Oe(e, t, n) { for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++)n || 1 !== r.nodeType || S.cleanData(ve(r)), r.parentNode && (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r)); return e } S.extend({ htmlPrefilter: function (e) { return e }, clone: function (e, t, n) { var r, i, o, a, s, u, l, c = e.cloneNode(!0), f = ie(e); if (!(y.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || S.isXMLDoc(e))) for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)s = o[r], u = a[r], void 0, "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type) ? u.checked = s.checked : "input" !== l && "textarea" !== l || (u.defaultValue = s.defaultValue); if (t) if (n) for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++)Le(o[r], a[r]); else Le(e, c); return 0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c }, cleanData: function (e) { for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)if (V(n)) { if (t = n[Y.expando]) { if (t.events) for (r in t.events) i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle); n[Y.expando] = void 0 } n[Q.expando] && (n[Q.expando] = void 0) } } }), S.fn.extend({ detach: function (e) { return Oe(this, e, !0) }, remove: function (e) { return Oe(this, e) }, text: function (e) { return $(this, function (e) { return void 0 === e ? S.text(this) : this.empty().each(function () { 1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e) }) }, null, e, arguments.length) }, append: function () { return He(this, arguments, function (e) { 1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || je(this, e).appendChild(e) }) }, prepend: function () { return He(this, arguments, function (e) { if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) { var t = je(this, e); t.insertBefore(e, t.firstChild) } }) }, before: function () { return He(this, arguments, function (e) { this.parentNode && this.parentNode.insertBefore(e, this) }) }, after: function () { return He(this, arguments, function (e) { this.parentNode && this.parentNode.insertBefore(e, this.nextSibling) }) }, empty: function () { for (var e, t = 0; null != (e = this[t]); t++)1 === e.nodeType && (S.cleanData(ve(e, !1)), e.textContent = ""); return this }, clone: function (e, t) { return e = null != e && e, t = null == t ? e : t, this.map(function () { return S.clone(this, e, t) }) }, html: function (e) { return $(this, function (e) { var t = this[0] || {}, n = 0, r = this.length; if (void 0 === e && 1 === t.nodeType) return t.innerHTML; if ("string" == typeof e && !ke.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) { e = S.htmlPrefilter(e); try { for (; n < r; n++)1 === (t = this[n] || {}).nodeType && (S.cleanData(ve(t, !1)), t.innerHTML = e); t = 0 } catch (e) { } } t && this.empty().append(e) }, null, e, arguments.length) }, replaceWith: function () { var n = []; return He(this, arguments, function (e) { var t = this.parentNode; S.inArray(this, n) < 0 && (S.cleanData(ve(this)), t && t.replaceChild(e, this)) }, n) } }), S.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, a) { S.fn[e] = function (e) { for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++)t = o === i ? this : this.clone(!0), S(r[o])[a](t), u.apply(n, t.get()); return this.pushStack(n) } }); var Pe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"), Re = function (e) { var t = e.ownerDocument.defaultView; return t && t.opener || (t = C), t.getComputedStyle(e) }, Me = function (e, t, n) { var r, i, o = {}; for (i in t) o[i] = e.style[i], e.style[i] = t[i]; for (i in r = n.call(e), t) e.style[i] = o[i]; return r }, Ie = new RegExp(ne.join("|"), "i"); function We(e, t, n) { var r, i, o, a, s = e.style; return (n = n || Re(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || ie(e) || (a = S.style(e, t)), !y.pixelBoxStyles() && Pe.test(a) && Ie.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a } function Fe(e, t) { return { get: function () { if (!e()) return (this.get = t).apply(this, arguments); delete this.get } } } !function () { function e() { if (l) { u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", re.appendChild(u).appendChild(l); var e = C.getComputedStyle(l); n = "1%" !== e.top, s = 12 === t(e.marginLeft), l.style.right = "60%", o = 36 === t(e.right), r = 36 === t(e.width), l.style.position = "absolute", i = 12 === t(l.offsetWidth / 3), re.removeChild(u), l = null } } function t(e) { return Math.round(parseFloat(e)) } var n, r, i, o, a, s, u = E.createElement("div"), l = E.createElement("div"); l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = "content-box" === l.style.backgroundClip, S.extend(y, { boxSizingReliable: function () { return e(), r }, pixelBoxStyles: function () { return e(), o }, pixelPosition: function () { return e(), n }, reliableMarginLeft: function () { return e(), s }, scrollboxSize: function () { return e(), i }, reliableTrDimensions: function () { var e, t, n, r; return null == a && (e = E.createElement("table"), t = E.createElement("tr"), n = E.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", t.style.cssText = "border:1px solid", t.style.height = "1px", n.style.height = "9px", n.style.display = "block", re.appendChild(e).appendChild(t).appendChild(n), r = C.getComputedStyle(t), a = parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) === t.offsetHeight, re.removeChild(e)), a } })) }(); var Be = ["Webkit", "Moz", "ms"], $e = E.createElement("div").style, _e = {}; function ze(e) { var t = S.cssProps[e] || _e[e]; return t || (e in $e ? e : _e[e] = function (e) { var t = e[0].toUpperCase() + e.slice(1), n = Be.length; while (n--) if ((e = Be[n] + t) in $e) return e }(e) || e) } var Ue = /^(none|table(?!-c[ea]).+)/, Xe = /^--/, Ve = { position: "absolute", visibility: "hidden", display: "block" }, Ge = { letterSpacing: "0", fontWeight: "400" }; function Ye(e, t, n) { var r = te.exec(t); return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t } function Qe(e, t, n, r, i, o) { var a = "width" === t ? 1 : 0, s = 0, u = 0; if (n === (r ? "border" : "content")) return 0; for (; a < 4; a += 2)"margin" === n && (u += S.css(e, n + ne[a], !0, i)), r ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)), "margin" !== n && (u -= S.css(e, "border" + ne[a] + "Width", !0, i))) : (u += S.css(e, "padding" + ne[a], !0, i), "padding" !== n ? u += S.css(e, "border" + ne[a] + "Width", !0, i) : s += S.css(e, "border" + ne[a] + "Width", !0, i)); return !r && 0 <= o && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u } function Je(e, t, n) { var r = Re(e), i = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r), o = i, a = We(e, t, r), s = "offset" + t[0].toUpperCase() + t.slice(1); if (Pe.test(a)) { if (!n) return a; a = "auto" } return (!y.boxSizingReliable() && i || !y.reliableTrDimensions() && A(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === S.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === S.css(e, "boxSizing", !1, r), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + Qe(e, t, n || (i ? "border" : "content"), o, r, a) + "px" } function Ke(e, t, n, r, i) { return new Ke.prototype.init(e, t, n, r, i) } S.extend({ cssHooks: { opacity: { get: function (e, t) { if (t) { var n = We(e, "opacity"); return "" === n ? "1" : n } } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, gridArea: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnStart: !0, gridRow: !0, gridRowEnd: !0, gridRowStart: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: {}, style: function (e, t, n, r) { if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) { var i, o, a, s = X(t), u = Xe.test(t), l = e.style; if (u || (t = ze(s)), a = S.cssHooks[t] || S.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t]; "string" === (o = typeof n) && (i = te.exec(n)) && i[1] && (n = se(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (S.cssNumber[s] ? "" : "px")), y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n)) } }, css: function (e, t, n, r) { var i, o, a, s = X(t); return Xe.test(t) || (t = ze(s)), (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = We(e, t, r)), "normal" === i && t in Ge && (i = Ge[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i } }), S.each(["height", "width"], function (e, u) { S.cssHooks[u] = { get: function (e, t, n) { if (t) return !Ue.test(S.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Je(e, u, n) : Me(e, Ve, function () { return Je(e, u, n) }) }, set: function (e, t, n) { var r, i = Re(e), o = !y.scrollboxSize() && "absolute" === i.position, a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i), s = n ? Qe(e, u, n, a, i) : 0; return a && o && (s -= Math.ceil(e["offset" + u[0].toUpperCase() + u.slice(1)] - parseFloat(i[u]) - Qe(e, u, "border", !1, i) - .5)), s && (r = te.exec(t)) && "px" !== (r[3] || "px") && (e.style[u] = t, t = S.css(e, u)), Ye(0, t, s) } } }), S.cssHooks.marginLeft = Fe(y.reliableMarginLeft, function (e, t) { if (t) return (parseFloat(We(e, "marginLeft")) || e.getBoundingClientRect().left - Me(e, { marginLeft: 0 }, function () { return e.getBoundingClientRect().left })) + "px" }), S.each({ margin: "", padding: "", border: "Width" }, function (i, o) { S.cssHooks[i + o] = { expand: function (e) { for (var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++)n[i + ne[t] + o] = r[t] || r[t - 2] || r[0]; return n } }, "margin" !== i && (S.cssHooks[i + o].set = Ye) }), S.fn.extend({ css: function (e, t) { return $(this, function (e, t, n) { var r, i, o = {}, a = 0; if (Array.isArray(t)) { for (r = Re(e), i = t.length; a < i; a++)o[t[a]] = S.css(e, t[a], !1, r); return o } return void 0 !== n ? S.style(e, t, n) : S.css(e, t) }, e, t, 1 < arguments.length) } }), ((S.Tween = Ke).prototype = { constructor: Ke, init: function (e, t, n, r, i, o) { this.elem = e, this.prop = n, this.easing = i || S.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (S.cssNumber[n] ? "" : "px") }, cur: function () { var e = Ke.propHooks[this.prop]; return e && e.get ? e.get(this) : Ke.propHooks._default.get(this) }, run: function (e) { var t, n = Ke.propHooks[this.prop]; return this.options.duration ? this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Ke.propHooks._default.set(this), this } }).init.prototype = Ke.prototype, (Ke.propHooks = { _default: { get: function (e) { var t; return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0 }, set: function (e) { S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !S.cssHooks[e.prop] && null == e.elem.style[ze(e.prop)] ? e.elem[e.prop] = e.now : S.style(e.elem, e.prop, e.now + e.unit) } } }).scrollTop = Ke.propHooks.scrollLeft = { set: function (e) { e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now) } }, S.easing = { linear: function (e) { return e }, swing: function (e) { return .5 - Math.cos(e * Math.PI) / 2 }, _default: "swing" }, S.fx = Ke.prototype.init, S.fx.step = {}; var Ze, et, tt, nt, rt = /^(?:toggle|show|hide)$/, it = /queueHooks$/; function ot() { et && (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(ot) : C.setTimeout(ot, S.fx.interval), S.fx.tick()) } function at() { return C.setTimeout(function () { Ze = void 0 }), Ze = Date.now() } function st(e, t) { var n, r = 0, i = { height: e }; for (t = t ? 1 : 0; r < 4; r += 2 - t)i["margin" + (n = ne[r])] = i["padding" + n] = e; return t && (i.opacity = i.width = e), i } function ut(e, t, n) { for (var r, i = (lt.tweeners[t] || []).concat(lt.tweeners["*"]), o = 0, a = i.length; o < a; o++)if (r = i[o].call(n, t, e)) return r } function lt(o, e, t) { var n, a, r = 0, i = lt.prefilters.length, s = S.Deferred().always(function () { delete u.elem }), u = function () { if (a) return !1; for (var e = Ze || at(), t = Math.max(0, l.startTime + l.duration - e), n = 1 - (t / l.duration || 0), r = 0, i = l.tweens.length; r < i; r++)l.tweens[r].run(n); return s.notifyWith(o, [l, n, t]), n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1) }, l = s.promise({ elem: o, props: S.extend({}, e), opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t), originalProperties: e, originalOptions: t, startTime: Ze || at(), duration: t.duration, tweens: [], createTween: function (e, t) { var n = S.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing); return l.tweens.push(n), n }, stop: function (e) { var t = 0, n = e ? l.tweens.length : 0; if (a) return this; for (a = !0; t < n; t++)l.tweens[t].run(1); return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this } }), c = l.props; for (!function (e, t) { var n, r, i, o, a; for (n in e) if (i = t[r = X(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = S.cssHooks[r]) && "expand" in a) for (n in o = a.expand(o), delete e[r], o) n in e || (e[n] = o[n], t[n] = i); else t[r] = i }(c, l.opts.specialEasing); r < i; r++)if (n = lt.prefilters[r].call(l, o, c, l.opts)) return m(n.stop) && (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n; return S.map(c, ut, l), m(l.opts.start) && l.opts.start.call(o, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })), l } S.Animation = S.extend(lt, { tweeners: { "*": [function (e, t) { var n = this.createTween(e, t); return se(n.elem, e, te.exec(t), n), n }] }, tweener: function (e, t) { m(e) ? (t = e, e = ["*"]) : e = e.match(P); for (var n, r = 0, i = e.length; r < i; r++)n = e[r], lt.tweeners[n] = lt.tweeners[n] || [], lt.tweeners[n].unshift(t) }, prefilters: [function (e, t, n) { var r, i, o, a, s, u, l, c, f = "width" in t || "height" in t, p = this, d = {}, h = e.style, g = e.nodeType && ae(e), v = Y.get(e, "fxshow"); for (r in n.queue || (null == (a = S._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () { a.unqueued || s() }), a.unqueued++, p.always(function () { p.always(function () { a.unqueued--, S.queue(e, "fx").length || a.empty.fire() }) })), t) if (i = t[r], rt.test(i)) { if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) { if ("show" !== i || !v || void 0 === v[r]) continue; g = !0 } d[r] = v && v[r] || S.style(e, r) } if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d)) for (r in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (l = v && v.display) && (l = Y.get(e, "display")), "none" === (c = S.css(e, "display")) && (l ? c = l : (le([e], !0), l = e.style.display || l, c = S.css(e, "display"), le([e]))), ("inline" === c || "inline-block" === c && null != l) && "none" === S.css(e, "float") && (u || (p.done(function () { h.display = l }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function () { h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2] })), u = !1, d) u || (v ? "hidden" in v && (g = v.hidden) : v = Y.access(e, "fxshow", { display: l }), o && (v.hidden = !g), g && le([e], !0), p.done(function () { for (r in g || le([e]), Y.remove(e, "fxshow"), d) S.style(e, r, d[r]) })), u = ut(g ? v[r] : 0, r, p), r in v || (v[r] = u.start, g && (u.end = u.start, u.start = 0)) }], prefilter: function (e, t) { t ? lt.prefilters.unshift(e) : lt.prefilters.push(e) } }), S.speed = function (e, t, n) { var r = e && "object" == typeof e ? S.extend({}, e) : { complete: n || !n && t || m(e) && e, duration: e, easing: n && t || t && !m(t) && t }; return S.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in S.fx.speeds ? r.duration = S.fx.speeds[r.duration] : r.duration = S.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () { m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue) }, r }, S.fn.extend({ fadeTo: function (e, t, n, r) { return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r) }, animate: function (t, e, n, r) { var i = S.isEmptyObject(t), o = S.speed(e, n, r), a = function () { var e = lt(this, S.extend({}, t), o); (i || Y.get(this, "finish")) && e.stop(!0) }; return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a) }, stop: function (i, e, o) { var a = function (e) { var t = e.stop; delete e.stop, t(o) }; return "string" != typeof i && (o = e, e = i, i = void 0), e && this.queue(i || "fx", []), this.each(function () { var e = !0, t = null != i && i + "queueHooks", n = S.timers, r = Y.get(this); if (t) r[t] && r[t].stop && a(r[t]); else for (t in r) r[t] && r[t].stop && it.test(t) && a(r[t]); for (t = n.length; t--;)n[t].elem !== this || null != i && n[t].queue !== i || (n[t].anim.stop(o), e = !1, n.splice(t, 1)); !e && o || S.dequeue(this, i) }) }, finish: function (a) { return !1 !== a && (a = a || "fx"), this.each(function () { var e, t = Y.get(this), n = t[a + "queue"], r = t[a + "queueHooks"], i = S.timers, o = n ? n.length : 0; for (t.finish = !0, S.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length; e--;)i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1)); for (e = 0; e < o; e++)n[e] && n[e].finish && n[e].finish.call(this); delete t.finish }) } }), S.each(["toggle", "show", "hide"], function (e, r) { var i = S.fn[r]; S.fn[r] = function (e, t, n) { return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(st(r, !0), e, t, n) } }), S.each({ slideDown: st("show"), slideUp: st("hide"), slideToggle: st("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, r) { S.fn[e] = function (e, t, n) { return this.animate(r, e, t, n) } }), S.timers = [], S.fx.tick = function () { var e, t = 0, n = S.timers; for (Ze = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1); n.length || S.fx.stop(), Ze = void 0 }, S.fx.timer = function (e) { S.timers.push(e), S.fx.start() }, S.fx.interval = 13, S.fx.start = function () { et || (et = !0, ot()) }, S.fx.stop = function () { et = null }, S.fx.speeds = { slow: 600, fast: 200, _default: 400 }, S.fn.delay = function (r, e) { return r = S.fx && S.fx.speeds[r] || r, e = e || "fx", this.queue(e, function (e, t) { var n = C.setTimeout(e, r); t.stop = function () { C.clearTimeout(n) } }) }, tt = E.createElement("input"), nt = E.createElement("select").appendChild(E.createElement("option")), tt.type = "checkbox", y.checkOn = "" !== tt.value, y.optSelected = nt.selected, (tt = E.createElement("input")).value = "t", tt.type = "radio", y.radioValue = "t" === tt.value; var ct, ft = S.expr.attrHandle; S.fn.extend({ attr: function (e, t) { return $(this, S.attr, e, t, 1 < arguments.length) }, removeAttr: function (e) { return this.each(function () { S.removeAttr(this, e) }) } }), S.extend({ attr: function (e, t, n) { var r, i, o = e.nodeType; if (3 !== o && 8 !== o && 2 !== o) return "undefined" == typeof e.getAttribute ? S.prop(e, t, n) : (1 === o && S.isXMLDoc(e) || (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? ct : void 0)), void 0 !== n ? null === n ? void S.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = S.find.attr(e, t)) ? void 0 : r) }, attrHooks: { type: { set: function (e, t) { if (!y.radioValue && "radio" === t && A(e, "input")) { var n = e.value; return e.setAttribute("type", t), n && (e.value = n), t } } } }, removeAttr: function (e, t) { var n, r = 0, i = t && t.match(P); if (i && 1 === e.nodeType) while (n = i[r++]) e.removeAttribute(n) } }), ct = { set: function (e, t, n) { return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n } }, S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) { var a = ft[t] || S.find.attr; ft[t] = function (e, t, n) { var r, i, o = t.toLowerCase(); return n || (i = ft[o], ft[o] = r, r = null != a(e, t, n) ? o : null, ft[o] = i), r } }); var pt = /^(?:input|select|textarea|button)$/i, dt = /^(?:a|area)$/i; function ht(e) { return (e.match(P) || []).join(" ") } function gt(e) { return e.getAttribute && e.getAttribute("class") || "" } function vt(e) { return Array.isArray(e) ? e : "string" == typeof e && e.match(P) || [] } S.fn.extend({ prop: function (e, t) { return $(this, S.prop, e, t, 1 < arguments.length) }, removeProp: function (e) { return this.each(function () { delete this[S.propFix[e] || e] }) } }), S.extend({ prop: function (e, t, n) { var r, i, o = e.nodeType; if (3 !== o && 8 !== o && 2 !== o) return 1 === o && S.isXMLDoc(e) || (t = S.propFix[t] || t, i = S.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t] }, propHooks: { tabIndex: { get: function (e) { var t = S.find.attr(e, "tabindex"); return t ? parseInt(t, 10) : pt.test(e.nodeName) || dt.test(e.nodeName) && e.href ? 0 : -1 } } }, propFix: { "for": "htmlFor", "class": "className" } }), y.optSelected || (S.propHooks.selected = { get: function (e) { var t = e.parentNode; return t && t.parentNode && t.parentNode.selectedIndex, null }, set: function (e) { var t = e.parentNode; t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex) } }), S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () { S.propFix[this.toLowerCase()] = this }), S.fn.extend({ addClass: function (t) { var e, n, r, i, o, a, s, u = 0; if (m(t)) return this.each(function (e) { S(this).addClass(t.call(this, e, gt(this))) }); if ((e = vt(t)).length) while (n = this[u++]) if (i = gt(n), r = 1 === n.nodeType && " " + ht(i) + " ") { a = 0; while (o = e[a++]) r.indexOf(" " + o + " ") < 0 && (r += o + " "); i !== (s = ht(r)) && n.setAttribute("class", s) } return this }, removeClass: function (t) { var e, n, r, i, o, a, s, u = 0; if (m(t)) return this.each(function (e) { S(this).removeClass(t.call(this, e, gt(this))) }); if (!arguments.length) return this.attr("class", ""); if ((e = vt(t)).length) while (n = this[u++]) if (i = gt(n), r = 1 === n.nodeType && " " + ht(i) + " ") { a = 0; while (o = e[a++]) while (-1 < r.indexOf(" " + o + " ")) r = r.replace(" " + o + " ", " "); i !== (s = ht(r)) && n.setAttribute("class", s) } return this }, toggleClass: function (i, t) { var o = typeof i, a = "string" === o || Array.isArray(i); return "boolean" == typeof t && a ? t ? this.addClass(i) : this.removeClass(i) : m(i) ? this.each(function (e) { S(this).toggleClass(i.call(this, e, gt(this), t), t) }) : this.each(function () { var e, t, n, r; if (a) { t = 0, n = S(this), r = vt(i); while (e = r[t++]) n.hasClass(e) ? n.removeClass(e) : n.addClass(e) } else void 0 !== i && "boolean" !== o || ((e = gt(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === i ? "" : Y.get(this, "__className__") || "")) }) }, hasClass: function (e) { var t, n, r = 0; t = " " + e + " "; while (n = this[r++]) if (1 === n.nodeType && -1 < (" " + ht(gt(n)) + " ").indexOf(t)) return !0; return !1 } }); var yt = /\r/g; S.fn.extend({ val: function (n) { var r, e, i, t = this[0]; return arguments.length ? (i = m(n), this.each(function (e) { var t; 1 === this.nodeType && (null == (t = i ? n.call(this, e, S(this).val()) : n) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = S.map(t, function (e) { return null == e ? "" : e + "" })), (r = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in r && void 0 !== r.set(this, t, "value") || (this.value = t)) })) : t ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) && "get" in r && void 0 !== (e = r.get(t, "value")) ? e : "string" == typeof (e = t.value) ? e.replace(yt, "") : null == e ? "" : e : void 0 } }), S.extend({ valHooks: { option: { get: function (e) { var t = S.find.attr(e, "value"); return null != t ? t : ht(S.text(e)) } }, select: { get: function (e) { var t, n, r, i = e.options, o = e.selectedIndex, a = "select-one" === e.type, s = a ? null : [], u = a ? o + 1 : i.length; for (r = o < 0 ? u : a ? o : 0; r < u; r++)if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) { if (t = S(n).val(), a) return t; s.push(t) } return s }, set: function (e, t) { var n, r, i = e.options, o = S.makeArray(t), a = i.length; while (a--) ((r = i[a]).selected = -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0); return n || (e.selectedIndex = -1), o } } } }), S.each(["radio", "checkbox"], function () { S.valHooks[this] = { set: function (e, t) { if (Array.isArray(t)) return e.checked = -1 < S.inArray(S(e).val(), t) } }, y.checkOn || (S.valHooks[this].get = function (e) { return null === e.getAttribute("value") ? "on" : e.value }) }), y.focusin = "onfocusin" in C; var mt = /^(?:focusinfocus|focusoutblur)$/, xt = function (e) { e.stopPropagation() }; S.extend(S.event, { trigger: function (e, t, n, r) { var i, o, a, s, u, l, c, f, p = [n || E], d = v.call(e, "type") ? e.type : e, h = v.call(e, "namespace") ? e.namespace.split(".") : []; if (o = f = a = n = n || E, 3 !== n.nodeType && 8 !== n.nodeType && !mt.test(d + S.event.triggered) && (-1 < d.indexOf(".") && (d = (h = d.split(".")).shift(), h.sort()), u = d.indexOf(":") < 0 && "on" + d, (e = e[S.expando] ? e : new S.Event(d, "object" == typeof e && e)).isTrigger = r ? 2 : 3, e.namespace = h.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : S.makeArray(t, [e]), c = S.event.special[d] || {}, r || !c.trigger || !1 !== c.trigger.apply(n, t))) { if (!r && !c.noBubble && !x(n)) { for (s = c.delegateType || d, mt.test(s + d) || (o = o.parentNode); o; o = o.parentNode)p.push(o), a = o; a === (n.ownerDocument || E) && p.push(a.defaultView || a.parentWindow || C) } i = 0; while ((o = p[i++]) && !e.isPropagationStopped()) f = o, e.type = 1 < i ? s : c.bindType || d, (l = (Y.get(o, "events") || Object.create(null))[e.type] && Y.get(o, "handle")) && l.apply(o, t), (l = u && o[u]) && l.apply && V(o) && (e.result = l.apply(o, t), !1 === e.result && e.preventDefault()); return e.type = d, r || e.isDefaultPrevented() || c._default && !1 !== c._default.apply(p.pop(), t) || !V(n) || u && m(n[d]) && !x(n) && ((a = n[u]) && (n[u] = null), S.event.triggered = d, e.isPropagationStopped() && f.addEventListener(d, xt), n[d](), e.isPropagationStopped() && f.removeEventListener(d, xt), S.event.triggered = void 0, a && (n[u] = a)), e.result } }, simulate: function (e, t, n) { var r = S.extend(new S.Event, n, { type: e, isSimulated: !0 }); S.event.trigger(r, null, t) } }), S.fn.extend({ trigger: function (e, t) { return this.each(function () { S.event.trigger(e, t, this) }) }, triggerHandler: function (e, t) { var n = this[0]; if (n) return S.event.trigger(e, t, n, !0) } }), y.focusin || S.each({ focus: "focusin", blur: "focusout" }, function (n, r) { var i = function (e) { S.event.simulate(r, e.target, S.event.fix(e)) }; S.event.special[r] = { setup: function () { var e = this.ownerDocument || this.document || this, t = Y.access(e, r); t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1) }, teardown: function () { var e = this.ownerDocument || this.document || this, t = Y.access(e, r) - 1; t ? Y.access(e, r, t) : (e.removeEventListener(n, i, !0), Y.remove(e, r)) } } }); var bt = C.location, wt = { guid: Date.now() }, Tt = /\?/; S.parseXML = function (e) { var t, n; if (!e || "string" != typeof e) return null; try { t = (new C.DOMParser).parseFromString(e, "text/xml") } catch (e) { } return n = t && t.getElementsByTagName("parsererror")[0], t && !n || S.error("Invalid XML: " + (n ? S.map(n.childNodes, function (e) { return e.textContent }).join("\n") : e)), t }; var Ct = /\[\]$/, Et = /\r?\n/g, St = /^(?:submit|button|image|reset|file)$/i, kt = /^(?:input|select|textarea|keygen)/i; function At(n, e, r, i) { var t; if (Array.isArray(e)) S.each(e, function (e, t) { r || Ct.test(n) ? i(n, t) : At(n + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, r, i) }); else if (r || "object" !== w(e)) i(n, e); else for (t in e) At(n + "[" + t + "]", e[t], r, i) } S.param = function (e, t) { var n, r = [], i = function (e, t) { var n = m(t) ? t() : t; r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n) }; if (null == e) return ""; if (Array.isArray(e) || e.jquery && !S.isPlainObject(e)) S.each(e, function () { i(this.name, this.value) }); else for (n in e) At(n, e[n], t, i); return r.join("&") }, S.fn.extend({ serialize: function () { return S.param(this.serializeArray()) }, serializeArray: function () { return this.map(function () { var e = S.prop(this, "elements"); return e ? S.makeArray(e) : this }).filter(function () { var e = this.type; return this.name && !S(this).is(":disabled") && kt.test(this.nodeName) && !St.test(e) && (this.checked || !pe.test(e)) }).map(function (e, t) { var n = S(this).val(); return null == n ? null : Array.isArray(n) ? S.map(n, function (e) { return { name: t.name, value: e.replace(Et, "\r\n") } }) : { name: t.name, value: n.replace(Et, "\r\n") } }).get() } }); var Nt = /%20/g, jt = /#.*$/, Dt = /([?&])_=[^&]*/, qt = /^(.*?):[ \t]*([^\r\n]*)$/gm, Lt = /^(?:GET|HEAD)$/, Ht = /^\/\//, Ot = {}, Pt = {}, Rt = "*/".concat("*"), Mt = E.createElement("a"); function It(o) { return function (e, t) { "string" != typeof e && (t = e, e = "*"); var n, r = 0, i = e.toLowerCase().match(P) || []; if (m(t)) while (n = i[r++]) "+" === n[0] ? (n = n.slice(1) || "*", (o[n] = o[n] || []).unshift(t)) : (o[n] = o[n] || []).push(t) } } function Wt(t, i, o, a) { var s = {}, u = t === Pt; function l(e) { var r; return s[e] = !0, S.each(t[e] || [], function (e, t) { var n = t(i, o, a); return "string" != typeof n || u || s[n] ? u ? !(r = n) : void 0 : (i.dataTypes.unshift(n), l(n), !1) }), r } return l(i.dataTypes[0]) || !s["*"] && l("*") } function Ft(e, t) { var n, r, i = S.ajaxSettings.flatOptions || {}; for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]); return r && S.extend(!0, e, r), e } Mt.href = bt.href, S.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: bt.href, type: "GET", isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(bt.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Rt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function (e, t) { return t ? Ft(Ft(e, S.ajaxSettings), t) : Ft(S.ajaxSettings, e) }, ajaxPrefilter: It(Ot), ajaxTransport: It(Pt), ajax: function (e, t) { "object" == typeof e && (t = e, e = void 0), t = t || {}; var c, f, p, n, d, r, h, g, i, o, v = S.ajaxSetup({}, t), y = v.context || v, m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event, x = S.Deferred(), b = S.Callbacks("once memory"), w = v.statusCode || {}, a = {}, s = {}, u = "canceled", T = { readyState: 0, getResponseHeader: function (e) { var t; if (h) { if (!n) { n = {}; while (t = qt.exec(p)) n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]) } t = n[e.toLowerCase() + " "] } return null == t ? null : t.join(", ") }, getAllResponseHeaders: function () { return h ? p : null }, setRequestHeader: function (e, t) { return null == h && (e = s[e.toLowerCase()] = s[e.toLowerCase()] || e, a[e] = t), this }, overrideMimeType: function (e) { return null == h && (v.mimeType = e), this }, statusCode: function (e) { var t; if (e) if (h) T.always(e[T.status]); else for (t in e) w[t] = [w[t], e[t]]; return this }, abort: function (e) { var t = e || u; return c && c.abort(t), l(0, t), this } }; if (x.promise(T), v.url = ((e || v.url || bt.href) + "").replace(Ht, bt.protocol + "//"), v.type = t.method || t.type || v.method || v.type, v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""], null == v.crossDomain) { r = E.createElement("a"); try { r.href = v.url, r.href = r.href, v.crossDomain = Mt.protocol + "//" + Mt.host != r.protocol + "//" + r.host } catch (e) { v.crossDomain = !0 } } if (v.data && v.processData && "string" != typeof v.data && (v.data = S.param(v.data, v.traditional)), Wt(Ot, v, t, T), h) return T; for (i in (g = S.event && v.global) && 0 == S.active++ && S.event.trigger("ajaxStart"), v.type = v.type.toUpperCase(), v.hasContent = !Lt.test(v.type), f = v.url.replace(jt, ""), v.hasContent ? v.data && v.processData && 0 === (v.contentType || "").indexOf("application/x-www-form-urlencoded") && (v.data = v.data.replace(Nt, "+")) : (o = v.url.slice(f.length), v.data && (v.processData || "string" == typeof v.data) && (f += (Tt.test(f) ? "&" : "?") + v.data, delete v.data), !1 === v.cache && (f = f.replace(Dt, "$1"), o = (Tt.test(f) ? "&" : "?") + "_=" + wt.guid++ + o), v.url = f + o), v.ifModified && (S.lastModified[f] && T.setRequestHeader("If-Modified-Since", S.lastModified[f]), S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])), (v.data && v.hasContent && !1 !== v.contentType || t.contentType) && T.setRequestHeader("Content-Type", v.contentType), T.setRequestHeader("Accept", v.dataTypes[0] && v.accepts[v.dataTypes[0]] ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + Rt + "; q=0.01" : "") : v.accepts["*"]), v.headers) T.setRequestHeader(i, v.headers[i]); if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h)) return T.abort(); if (u = "abort", b.add(v.complete), T.done(v.success), T.fail(v.error), c = Wt(Pt, v, t, T)) { if (T.readyState = 1, g && m.trigger("ajaxSend", [T, v]), h) return T; v.async && 0 < v.timeout && (d = C.setTimeout(function () { T.abort("timeout") }, v.timeout)); try { h = !1, c.send(a, l) } catch (e) { if (h) throw e; l(-1, e) } } else l(-1, "No Transport"); function l(e, t, n, r) { var i, o, a, s, u, l = t; h || (h = !0, d && C.clearTimeout(d), c = void 0, p = r || "", T.readyState = 0 < e ? 4 : 0, i = 200 <= e && e < 300 || 304 === e, n && (s = function (e, t, n) { var r, i, o, a, s = e.contents, u = e.dataTypes; while ("*" === u[0]) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type")); if (r) for (i in s) if (s[i] && s[i].test(r)) { u.unshift(i); break } if (u[0] in n) o = u[0]; else { for (i in n) { if (!u[0] || e.converters[i + " " + u[0]]) { o = i; break } a || (a = i) } o = o || a } if (o) return o !== u[0] && u.unshift(o), n[o] }(v, T, n)), !i && -1 < S.inArray("script", v.dataTypes) && S.inArray("json", v.dataTypes) < 0 && (v.converters["text script"] = function () { }), s = function (e, t, n, r) { var i, o, a, s, u, l = {}, c = e.dataTypes.slice(); if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a]; o = c.shift(); while (o) if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u; else if ("*" !== u && u !== o) { if (!(a = l[u + " " + o] || l["* " + o])) for (i in l) if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) { !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1])); break } if (!0 !== a) if (a && e["throws"]) t = a(t); else try { t = a(t) } catch (e) { return { state: "parsererror", error: a ? e : "No conversion from " + u + " to " + o } } } return { state: "success", data: t } }(v, s, T, i), i ? (v.ifModified && ((u = T.getResponseHeader("Last-Modified")) && (S.lastModified[f] = u), (u = T.getResponseHeader("etag")) && (S.etag[f] = u)), 204 === e || "HEAD" === v.type ? l = "nocontent" : 304 === e ? l = "notmodified" : (l = s.state, o = s.data, i = !(a = s.error))) : (a = l, !e && l || (l = "error", e < 0 && (e = 0))), T.status = e, T.statusText = (t || l) + "", i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]), T.statusCode(w), w = void 0, g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]), b.fireWith(y, [T, l]), g && (m.trigger("ajaxComplete", [T, v]), --S.active || S.event.trigger("ajaxStop"))) } return T }, getJSON: function (e, t, n) { return S.get(e, t, n, "json") }, getScript: function (e, t) { return S.get(e, void 0, t, "script") } }), S.each(["get", "post"], function (e, i) { S[i] = function (e, t, n, r) { return m(t) && (r = r || n, n = t, t = void 0), S.ajax(S.extend({ url: e, type: i, dataType: r, data: t, success: n }, S.isPlainObject(e) && e)) } }), S.ajaxPrefilter(function (e) { var t; for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "") }), S._evalUrl = function (e, t, n) { return S.ajax({ url: e, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, converters: { "text script": function () { } }, dataFilter: function (e) { S.globalEval(e, t, n) } }) }, S.fn.extend({ wrapAll: function (e) { var t; return this[0] && (m(e) && (e = e.call(this[0])), t = S(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () { var e = this; while (e.firstElementChild) e = e.firstElementChild; return e }).append(this)), this }, wrapInner: function (n) { return m(n) ? this.each(function (e) { S(this).wrapInner(n.call(this, e)) }) : this.each(function () { var e = S(this), t = e.contents(); t.length ? t.wrapAll(n) : e.append(n) }) }, wrap: function (t) { var n = m(t); return this.each(function (e) { S(this).wrapAll(n ? t.call(this, e) : t) }) }, unwrap: function (e) { return this.parent(e).not("body").each(function () { S(this).replaceWith(this.childNodes) }), this } }), S.expr.pseudos.hidden = function (e) { return !S.expr.pseudos.visible(e) }, S.expr.pseudos.visible = function (e) { return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length) }, S.ajaxSettings.xhr = function () { try { return new C.XMLHttpRequest } catch (e) { } }; var Bt = { 0: 200, 1223: 204 }, $t = S.ajaxSettings.xhr(); y.cors = !!$t && "withCredentials" in $t, y.ajax = $t = !!$t, S.ajaxTransport(function (i) { var o, a; if (y.cors || $t && !i.crossDomain) return { send: function (e, t) { var n, r = i.xhr(); if (r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields) for (n in i.xhrFields) r[n] = i.xhrFields[n]; for (n in i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType), i.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e) r.setRequestHeader(n, e[n]); o = function (e) { return function () { o && (o = a = r.onload = r.onerror = r.onabort = r.ontimeout = r.onreadystatechange = null, "abort" === e ? r.abort() : "error" === e ? "number" != typeof r.status ? t(0, "error") : t(r.status, r.statusText) : t(Bt[r.status] || r.status, r.statusText, "text" !== (r.responseType || "text") || "string" != typeof r.responseText ? { binary: r.response } : { text: r.responseText }, r.getAllResponseHeaders())) } }, r.onload = o(), a = r.onerror = r.ontimeout = o("error"), void 0 !== r.onabort ? r.onabort = a : r.onreadystatechange = function () { 4 === r.readyState && C.setTimeout(function () { o && a() }) }, o = o("abort"); try { r.send(i.hasContent && i.data || null) } catch (e) { if (o) throw e } }, abort: function () { o && o() } } }), S.ajaxPrefilter(function (e) { e.crossDomain && (e.contents.script = !1) }), S.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function (e) { return S.globalEval(e), e } } }), S.ajaxPrefilter("script", function (e) { void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET") }), S.ajaxTransport("script", function (n) { var r, i; if (n.crossDomain || n.scriptAttrs) return { send: function (e, t) { r = S("<script>").attr(n.scriptAttrs || {}).prop({ charset: n.scriptCharset, src: n.url }).on("load error", i = function (e) { r.remove(), i = null, e && t("error" === e.type ? 404 : 200, e.type) }), E.head.appendChild(r[0]) }, abort: function () { i && i() } } }); var _t, zt = [], Ut = /(=)\?(?=&|$)|\?\?/; S.ajaxSetup({ jsonp: "callback", jsonpCallback: function () { var e = zt.pop() || S.expando + "_" + wt.guid++; return this[e] = !0, e } }), S.ajaxPrefilter("json jsonp", function (e, t, n) { var r, i, o, a = !1 !== e.jsonp && (Ut.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ut.test(e.data) && "data"); if (a || "jsonp" === e.dataTypes[0]) return r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Ut, "$1" + r) : !1 !== e.jsonp && (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () { return o || S.error(r + " was not called"), o[0] }, e.dataTypes[0] = "json", i = C[r], C[r] = function () { o = arguments }, n.always(function () { void 0 === i ? S(C).removeProp(r) : C[r] = i, e[r] && (e.jsonpCallback = t.jsonpCallback, zt.push(r)), o && m(i) && i(o[0]), o = i = void 0 }), "script" }), y.createHTMLDocument = ((_t = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === _t.childNodes.length), S.parseHTML = function (e, t, n) { return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (y.createHTMLDocument ? ((r = (t = E.implementation.createHTMLDocument("")).createElement("base")).href = E.location.href, t.head.appendChild(r)) : t = E), o = !n && [], (i = N.exec(e)) ? [t.createElement(i[1])] : (i = xe([e], t, o), o && o.length && S(o).remove(), S.merge([], i.childNodes))); var r, i, o }, S.fn.load = function (e, t, n) { var r, i, o, a = this, s = e.indexOf(" "); return -1 < s && (r = ht(e.slice(s)), e = e.slice(0, s)), m(t) ? (n = t, t = void 0) : t && "object" == typeof t && (i = "POST"), 0 < a.length && S.ajax({ url: e, type: i || "GET", dataType: "html", data: t }).done(function (e) { o = arguments, a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e) }).always(n && function (e, t) { a.each(function () { n.apply(this, o || [e.responseText, t, e]) }) }), this }, S.expr.pseudos.animated = function (t) { return S.grep(S.timers, function (e) { return t === e.elem }).length }, S.offset = { setOffset: function (e, t, n) { var r, i, o, a, s, u, l = S.css(e, "position"), c = S(e), f = {}; "static" === l && (e.style.position = "relative"), s = c.offset(), o = S.css(e, "top"), u = S.css(e, "left"), ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto") ? (a = (r = c.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), m(t) && (t = t.call(e, n, S.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : c.css(f) } }, S.fn.extend({ offset: function (t) { if (arguments.length) return void 0 === t ? this : this.each(function (e) { S.offset.setOffset(this, t, e) }); var e, n, r = this[0]; return r ? r.getClientRects().length ? (e = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset }) : { top: 0, left: 0 } : void 0 }, position: function () { if (this[0]) { var e, t, n, r = this[0], i = { top: 0, left: 0 }; if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect(); else { t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; while (e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position")) e = e.parentNode; e && e !== r && 1 === e.nodeType && ((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0), i.left += S.css(e, "borderLeftWidth", !0)) } return { top: t.top - i.top - S.css(r, "marginTop", !0), left: t.left - i.left - S.css(r, "marginLeft", !0) } } }, offsetParent: function () { return this.map(function () { var e = this.offsetParent; while (e && "static" === S.css(e, "position")) e = e.offsetParent; return e || re }) } }), S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, i) { var o = "pageYOffset" === i; S.fn[t] = function (e) { return $(this, function (e, t, n) { var r; if (x(e) ? r = e : 9 === e.nodeType && (r = e.defaultView), void 0 === n) return r ? r[i] : e[t]; r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : e[t] = n }, t, e, arguments.length) } }), S.each(["top", "left"], function (e, n) { S.cssHooks[n] = Fe(y.pixelPosition, function (e, t) { if (t) return t = We(e, n), Pe.test(t) ? S(e).position()[n] + "px" : t }) }), S.each({ Height: "height", Width: "width" }, function (a, s) { S.each({ padding: "inner" + a, content: s, "": "outer" + a }, function (r, o) { S.fn[o] = function (e, t) { var n = arguments.length && (r || "boolean" != typeof e), i = r || (!0 === e || !0 === t ? "margin" : "border"); return $(this, function (e, t, n) { var r; return x(e) ? 0 === o.indexOf("outer") ? e["inner" + a] : e.document.documentElement["client" + a] : 9 === e.nodeType ? (r = e.documentElement, Math.max(e.body["scroll" + a], r["scroll" + a], e.body["offset" + a], r["offset" + a], r["client" + a])) : void 0 === n ? S.css(e, t, i) : S.style(e, t, n, i) }, s, n ? e : void 0, n) } }) }), S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) { S.fn[t] = function (e) { return this.on(t, e) } }), S.fn.extend({ bind: function (e, t, n) { return this.on(e, null, t, n) }, unbind: function (e, t) { return this.off(e, null, t) }, delegate: function (e, t, n, r) { return this.on(t, e, n, r) }, undelegate: function (e, t, n) { return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n) }, hover: function (e, t) { return this.mouseenter(e).mouseleave(t || e) } }), S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, n) { S.fn[n] = function (e, t) { return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n) } }); var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g; S.proxy = function (e, t) { var n, r, i; if ("string" == typeof t && (n = e[t], t = e, e = n), m(e)) return r = s.call(arguments, 2), (i = function () { return e.apply(t || this, r.concat(s.call(arguments))) }).guid = e.guid = e.guid || S.guid++, i }, S.holdReady = function (e) { e ? S.readyWait++ : S.ready(!0) }, S.isArray = Array.isArray, S.parseJSON = JSON.parse, S.nodeName = A, S.isFunction = m, S.isWindow = x, S.camelCase = X, S.type = w, S.now = Date.now, S.isNumeric = function (e) { var t = S.type(e); return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e)) }, S.trim = function (e) { return null == e ? "" : (e + "").replace(Xt, "") }, "function" == typeof define && define.amd && define("jquery", [], function () { return S }); var Vt = C.jQuery, Gt = C.$; return S.noConflict = function (e) { return C.$ === S && (C.$ = Gt), e && C.jQuery === S && (C.jQuery = Vt), S }, "undefined" == typeof e && (C.jQuery = C.$ = S), S });
jQuery.migrateMute = true;


/*!
 * jQuery Migrate - v3.3.1 - 2020-06-25T01:07Z
 * Copyright OpenJS Foundation and other contributors
 */
(function (factory) {
	"use strict";

	if (typeof define === "function" && define.amd) {

		// AMD. Register as an anonymous module.
		define(["jquery"], function (jQuery) {
			return factory(jQuery, window);
		});
	} else if (typeof module === "object" && module.exports) {

		// Node/CommonJS
		// eslint-disable-next-line no-undef
		module.exports = factory(require("jquery"), window);
	} else {

		// Browser globals
		factory(jQuery, window);
	}
})(function (jQuery, window) {
	"use strict";

	jQuery.migrateVersion = "3.3.1";

	// Returns 0 if v1 == v2, -1 if v1 < v2, 1 if v1 > v2
	function compareVersions(v1, v2) {
		var i,
			rVersionParts = /^(\d+)\.(\d+)\.(\d+)/,
			v1p = rVersionParts.exec(v1) || [],
			v2p = rVersionParts.exec(v2) || [];

		for (i = 1; i <= 3; i++) {
			if (+v1p[i] > +v2p[i]) {
				return 1;
			}
			if (+v1p[i] < +v2p[i]) {
				return -1;
			}
		}
		return 0;
	}

	function jQueryVersionSince(version) {
		return compareVersions(jQuery.fn.jquery, version) >= 0;
	}

	(function () {

		// Support: IE9 only
		// IE9 only creates console object when dev tools are first opened
		// IE9 console is a host object, callable but doesn't have .apply()
		if (!window.console || !window.console.log) {
			return;
		}

		// Need jQuery 3.0.0+ and no older Migrate loaded
		if (!jQuery || !jQueryVersionSince("3.0.0")) {
			window.console.log("JQMIGRATE: jQuery 3.0.0+ REQUIRED");
		}
		if (jQuery.migrateWarnings) {
			window.console.log("JQMIGRATE: Migrate plugin loaded multiple times");
		}

		// Show a message on the console so devs know we're active
		//window.console.log("JQMIGRATE: Migrate is installed" +
		//	(jQuery.migrateMute ? "" : " with logging active") +
		//	", version " + jQuery.migrateVersion);

	})();

	var warnedAbout = {};

	// By default each warning is only reported once.
	jQuery.migrateDeduplicateWarnings = true;

	// List of warnings already given; public read only
	jQuery.migrateWarnings = [];

	// Set to false to disable traces that appear with warnings
	if (jQuery.migrateTrace === undefined) {
		jQuery.migrateTrace = true;
	}

	// Forget any warnings we've already given; public
	jQuery.migrateReset = function () {
		warnedAbout = {};
		jQuery.migrateWarnings.length = 0;
	};

	function migrateWarn(msg) {
		var console = window.console;
		if (!jQuery.migrateDeduplicateWarnings || !warnedAbout[msg]) {
			warnedAbout[msg] = true;
			jQuery.migrateWarnings.push(msg);
			if (console && console.warn && !jQuery.migrateMute) {
				console.warn("JQMIGRATE: " + msg);
				if (jQuery.migrateTrace && console.trace) {
					console.trace();
				}
			}
		}
	}

	function migrateWarnProp(obj, prop, value, msg) {
		Object.defineProperty(obj, prop, {
			configurable: true,
			enumerable: true,
			get: function () {
				migrateWarn(msg);
				return value;
			},
			set: function (newValue) {
				migrateWarn(msg);
				value = newValue;
			}
		});
	}

	function migrateWarnFunc(obj, prop, newFunc, msg) {
		obj[prop] = function () {
			migrateWarn(msg);
			return newFunc.apply(this, arguments);
		};
	}

	if (window.document.compatMode === "BackCompat") {

		// JQuery has never supported or tested Quirks Mode
		migrateWarn("jQuery is not compatible with Quirks Mode");
	}

	var findProp,
		class2type = {},
		oldInit = jQuery.fn.init,
		oldFind = jQuery.find,

		rattrHashTest = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
		rattrHashGlob = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,

		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	jQuery.fn.init = function (arg1) {
		var args = Array.prototype.slice.call(arguments);

		if (typeof arg1 === "string" && arg1 === "#") {

			// JQuery( "#" ) is a bogus ID selector, but it returned an empty set before jQuery 3.0
			migrateWarn("jQuery( '#' ) is not a valid selector");
			args[0] = [];
		}

		return oldInit.apply(this, args);
	};
	jQuery.fn.init.prototype = jQuery.fn;

	jQuery.find = function (selector) {
		var args = Array.prototype.slice.call(arguments);

		// Support: PhantomJS 1.x
		// String#match fails to match when used with a //g RegExp, only on some strings
		if (typeof selector === "string" && rattrHashTest.test(selector)) {

			// The nonstandard and undocumented unquoted-hash was removed in jQuery 1.12.0
			// First see if qS thinks it's a valid selector, if so avoid a false positive
			try {
				window.document.querySelector(selector);
			} catch (err1) {

				// Didn't *look* valid to qSA, warn and try quoting what we think is the value
				selector = selector.replace(rattrHashGlob, function (_, attr, op, value) {
					return "[" + attr + op + "\"" + value + "\"]";
				});

				// If the regexp *may* have created an invalid selector, don't update it
				// Note that there may be false alarms if selector uses jQuery extensions
				try {
					window.document.querySelector(selector);
					migrateWarn("Attribute selector with '#' must be quoted: " + args[0]);
					args[0] = selector;
				} catch (err2) {
					migrateWarn("Attribute selector with '#' was not fixed: " + args[0]);
				}
			}
		}

		return oldFind.apply(this, args);
	};

	// Copy properties attached to original jQuery.find method (e.g. .attr, .isXML)
	for (findProp in oldFind) {
		if (Object.prototype.hasOwnProperty.call(oldFind, findProp)) {
			jQuery.find[findProp] = oldFind[findProp];
		}
	}

	// The number of elements contained in the matched element set
	migrateWarnFunc(jQuery.fn, "size", function () {
		return this.length;
	},
		"jQuery.fn.size() is deprecated and removed; use the .length property");

	migrateWarnFunc(jQuery, "parseJSON", function () {
		return JSON.parse.apply(null, arguments);
	},
		"jQuery.parseJSON is deprecated; use JSON.parse");

	migrateWarnFunc(jQuery, "holdReady", jQuery.holdReady,
		"jQuery.holdReady is deprecated");

	migrateWarnFunc(jQuery, "unique", jQuery.uniqueSort,
		"jQuery.unique is deprecated; use jQuery.uniqueSort");

	// Now jQuery.expr.pseudos is the standard incantation
	migrateWarnProp(jQuery.expr, "filters", jQuery.expr.pseudos,
		"jQuery.expr.filters is deprecated; use jQuery.expr.pseudos");
	migrateWarnProp(jQuery.expr, ":", jQuery.expr.pseudos,
		"jQuery.expr[':'] is deprecated; use jQuery.expr.pseudos");

	// Prior to jQuery 3.1.1 there were internal refs so we don't warn there
	if (jQueryVersionSince("3.1.1")) {
		migrateWarnFunc(jQuery, "trim", function (text) {
			return text == null ?
				"" :
				(text + "").replace(rtrim, "");
		},
			"jQuery.trim is deprecated; use String.prototype.trim");
	}

	// Prior to jQuery 3.2 there were internal refs so we don't warn there
	if (jQueryVersionSince("3.2.0")) {
		migrateWarnFunc(jQuery, "nodeName", function (elem, name) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
			"jQuery.nodeName is deprecated");
	}

	if (jQueryVersionSince("3.3.0")) {

		migrateWarnFunc(jQuery, "isNumeric", function (obj) {

			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = typeof obj;
			return (type === "number" || type === "string") &&

				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, e.g. hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN(obj - parseFloat(obj));
		},
			"jQuery.isNumeric() is deprecated"
		);

		// Populate the class2type map
		jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".
			split(" "),
			function (_, name) {
				class2type["[object " + name + "]"] = name.toLowerCase();
			});

		migrateWarnFunc(jQuery, "type", function (obj) {
			if (obj == null) {
				return obj + "";
			}

			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[Object.prototype.toString.call(obj)] || "object" :
				typeof obj;
		},
			"jQuery.type is deprecated");

		migrateWarnFunc(jQuery, "isFunction",
			function (obj) {
				return typeof obj === "function";
			},
			"jQuery.isFunction() is deprecated");

		migrateWarnFunc(jQuery, "isWindow",
			function (obj) {
				return obj != null && obj === obj.window;
			},
			"jQuery.isWindow() is deprecated"
		);

		migrateWarnFunc(jQuery, "isArray", Array.isArray,
			"jQuery.isArray is deprecated; use Array.isArray"
		);
	}

	// Support jQuery slim which excludes the ajax module
	if (jQuery.ajax) {

		var oldAjax = jQuery.ajax;

		jQuery.ajax = function () {
			var jQXHR = oldAjax.apply(this, arguments);

			// Be sure we got a jQXHR (e.g., not sync)
			if (jQXHR.promise) {
				migrateWarnFunc(jQXHR, "success", jQXHR.done,
					"jQXHR.success is deprecated and removed");
				migrateWarnFunc(jQXHR, "error", jQXHR.fail,
					"jQXHR.error is deprecated and removed");
				migrateWarnFunc(jQXHR, "complete", jQXHR.always,
					"jQXHR.complete is deprecated and removed");
			}

			return jQXHR;
		};

	}

	var oldRemoveAttr = jQuery.fn.removeAttr,
		oldToggleClass = jQuery.fn.toggleClass,
		rmatchNonSpace = /\S+/g;

	jQuery.fn.removeAttr = function (name) {
		var self = this;

		jQuery.each(name.match(rmatchNonSpace), function (_i, attr) {
			if (jQuery.expr.match.bool.test(attr)) {
				migrateWarn("jQuery.fn.removeAttr no longer sets boolean properties: " + attr);
				self.prop(attr, false);
			}
		});

		return oldRemoveAttr.apply(this, arguments);
	};

	jQuery.fn.toggleClass = function (state) {

		// Only deprecating no-args or single boolean arg
		if (state !== undefined && typeof state !== "boolean") {
			return oldToggleClass.apply(this, arguments);
		}

		migrateWarn("jQuery.fn.toggleClass( boolean ) is deprecated");

		// Toggle entire class name of each element
		return this.each(function () {
			var className = this.getAttribute && this.getAttribute("class") || "";

			if (className) {
				jQuery.data(this, "__className__", className);
			}

			// If the element has a class name or if we're passed `false`,
			// then remove the whole classname (if there was one, the above saved it).
			// Otherwise bring back whatever was previously saved (if anything),
			// falling back to the empty string if nothing was stored.
			if (this.setAttribute) {
				this.setAttribute("class",
					className || state === false ?
						"" :
						jQuery.data(this, "__className__") || ""
				);
			}
		});
	};

	function camelCase(string) {
		return string.replace(/-([a-z])/g, function (_, letter) {
			return letter.toUpperCase();
		});
	}

	var oldFnCss,
		internalSwapCall = false,
		ralphaStart = /^[a-z]/,

		// The regex visualized:
		//
		//                         /----------\
		//                        |            |    /-------\
		//                        |  / Top  \  |   |         |
		//         /--- Border ---+-| Right  |-+---+- Width -+---\
		//        |                 | Bottom |                    |
		//        |                  \ Left /                     |
		//        |                                               |
		//        |                              /----------\     |
		//        |          /-------------\    |            |    |- END
		//        |         |               |   |  / Top  \  |    |
		//        |         |  / Margin  \  |   | | Right  | |    |
		//        |---------+-|           |-+---+-| Bottom |-+----|
		//        |            \ Padding /         \ Left /       |
		// BEGIN -|                                               |
		//        |                /---------\                    |
		//        |               |           |                   |
		//        |               |  / Min \  |    / Width  \     |
		//         \--------------+-|       |-+---|          |---/
		//                           \ Max /       \ Height /
		rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;

	// If this version of jQuery has .swap(), don't false-alarm on internal uses
	if (jQuery.swap) {
		jQuery.each(["height", "width", "reliableMarginRight"], function (_, name) {
			var oldHook = jQuery.cssHooks[name] && jQuery.cssHooks[name].get;

			if (oldHook) {
				jQuery.cssHooks[name].get = function () {
					var ret;

					internalSwapCall = true;
					ret = oldHook.apply(this, arguments);
					internalSwapCall = false;
					return ret;
				};
			}
		});
	}

	jQuery.swap = function (elem, options, callback, args) {
		var ret, name,
			old = {};

		if (!internalSwapCall) {
			migrateWarn("jQuery.swap() is undocumented and deprecated");
		}

		// Remember the old values, and insert the new ones
		for (name in options) {
			old[name] = elem.style[name];
			elem.style[name] = options[name];
		}

		ret = callback.apply(elem, args || []);

		// Revert the old values
		for (name in options) {
			elem.style[name] = old[name];
		}

		return ret;
	};

	if (jQueryVersionSince("3.4.0") && typeof Proxy !== "undefined") {

		jQuery.cssProps = new Proxy(jQuery.cssProps || {}, {
			set: function () {
				migrateWarn("JQMIGRATE: jQuery.cssProps is deprecated");
				return Reflect.set.apply(this, arguments);
			}
		});
	}

	// Create a dummy jQuery.cssNumber if missing. It won't be used by jQuery but
	// it will prevent code adding new keys to it unconditionally from crashing.
	if (!jQuery.cssNumber) {
		jQuery.cssNumber = {};
	}

	function isAutoPx(prop) {

		// The first test is used to ensure that:
		// 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
		// 2. The prop is not empty.
		return ralphaStart.test(prop) &&
			rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
	}

	oldFnCss = jQuery.fn.css;

	jQuery.fn.css = function (name, value) {
		var camelName,
			origThis = this;
		if (name && typeof name === "object" && !Array.isArray(name)) {
			jQuery.each(name, function (n, v) {
				jQuery.fn.css.call(origThis, n, v);
			});
		}
		if (typeof value === "number") {
			camelName = camelCase(name);
			if (!isAutoPx(camelName) && !jQuery.cssNumber[camelName]) {
				migrateWarn("Number-typed values are deprecated for jQuery.fn.css( \"" +
					name + "\", value )");
			}
		}

		return oldFnCss.apply(this, arguments);
	};

	var oldData = jQuery.data;

	jQuery.data = function (elem, name, value) {
		var curData, sameKeys, key;

		// Name can be an object, and each entry in the object is meant to be set as data
		if (name && typeof name === "object" && arguments.length === 2) {
			curData = jQuery.hasData(elem) && oldData.call(this, elem);
			sameKeys = {};
			for (key in name) {
				if (key !== camelCase(key)) {
					migrateWarn("jQuery.data() always sets/gets camelCased names: " + key);
					curData[key] = name[key];
				} else {
					sameKeys[key] = name[key];
				}
			}

			oldData.call(this, elem, sameKeys);

			return name;
		}

		// If the name is transformed, look for the un-transformed name in the data object
		if (name && typeof name === "string" && name !== camelCase(name)) {
			curData = jQuery.hasData(elem) && oldData.call(this, elem);
			if (curData && name in curData) {
				migrateWarn("jQuery.data() always sets/gets camelCased names: " + name);
				if (arguments.length > 2) {
					curData[name] = value;
				}
				return curData[name];
			}
		}

		return oldData.apply(this, arguments);
	};

	// Support jQuery slim which excludes the effects module
	if (jQuery.fx) {

		var intervalValue, intervalMsg,
			oldTweenRun = jQuery.Tween.prototype.run,
			linearEasing = function (pct) {
				return pct;
			};

		jQuery.Tween.prototype.run = function () {
			if (jQuery.easing[this.easing].length > 1) {
				migrateWarn(
					"'jQuery.easing." + this.easing.toString() + "' should use only one argument"
				);

				jQuery.easing[this.easing] = linearEasing;
			}

			oldTweenRun.apply(this, arguments);
		};

		intervalValue = jQuery.fx.interval || 13;
		intervalMsg = "jQuery.fx.interval is deprecated";

		// Support: IE9, Android <=4.4
		// Avoid false positives on browsers that lack rAF
		// Don't warn if document is hidden, jQuery uses setTimeout (#292)
		if (window.requestAnimationFrame) {
			Object.defineProperty(jQuery.fx, "interval", {
				configurable: true,
				enumerable: true,
				get: function () {
					if (!window.document.hidden) {
						migrateWarn(intervalMsg);
					}
					return intervalValue;
				},
				set: function (newValue) {
					migrateWarn(intervalMsg);
					intervalValue = newValue;
				}
			});
		}

	}

	var oldLoad = jQuery.fn.load,
		oldEventAdd = jQuery.event.add,
		originalFix = jQuery.event.fix;

	jQuery.event.props = [];
	jQuery.event.fixHooks = {};

	migrateWarnProp(jQuery.event.props, "concat", jQuery.event.props.concat,
		"jQuery.event.props.concat() is deprecated and removed");

	jQuery.event.fix = function (originalEvent) {
		var event,
			type = originalEvent.type,
			fixHook = this.fixHooks[type],
			props = jQuery.event.props;

		if (props.length) {
			migrateWarn("jQuery.event.props are deprecated and removed: " + props.join());
			while (props.length) {
				jQuery.event.addProp(props.pop());
			}
		}

		if (fixHook && !fixHook._migrated_) {
			fixHook._migrated_ = true;
			migrateWarn("jQuery.event.fixHooks are deprecated and removed: " + type);
			if ((props = fixHook.props) && props.length) {
				while (props.length) {
					jQuery.event.addProp(props.pop());
				}
			}
		}

		event = originalFix.call(this, originalEvent);

		return fixHook && fixHook.filter ? fixHook.filter(event, originalEvent) : event;
	};

	jQuery.event.add = function (elem, types) {

		// This misses the multiple-types case but that seems awfully rare
		if (elem === window && types === "load" && window.document.readyState === "complete") {
			migrateWarn("jQuery(window).on('load'...) called after load event occurred");
		}
		return oldEventAdd.apply(this, arguments);
	};

	jQuery.each(["load", "unload", "error"], function (_, name) {

		jQuery.fn[name] = function () {
			var args = Array.prototype.slice.call(arguments, 0);

			// If this is an ajax load() the first arg should be the string URL;
			// technically this could also be the "Anything" arg of the event .load()
			// which just goes to show why this dumb signature has been deprecated!
			// jQuery custom builds that exclude the Ajax module justifiably die here.
			if (name === "load" && typeof args[0] === "string") {
				return oldLoad.apply(this, args);
			}

			migrateWarn("jQuery.fn." + name + "() is deprecated");

			args.splice(0, 0, name);
			if (arguments.length) {
				return this.on.apply(this, args);
			}

			// Use .triggerHandler here because:
			// - load and unload events don't need to bubble, only applied to window or image
			// - error event should not bubble to window, although it does pre-1.7
			// See http://bugs.jquery.com/ticket/11820
			this.triggerHandler.apply(this, args);
			return this;
		};

	});

	jQuery.each(("blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu").split(" "),
		function (_i, name) {

			// Handle event binding
			jQuery.fn[name] = function (data, fn) {
				migrateWarn("jQuery.fn." + name + "() event shorthand is deprecated");
				return arguments.length > 0 ?
					this.on(name, null, data, fn) :
					this.trigger(name);
			};
		});

	// Trigger "ready" event only once, on document ready
	jQuery(function () {
		jQuery(window.document).triggerHandler("ready");
	});

	jQuery.event.special.ready = {
		setup: function () {
			if (this === window.document) {
				migrateWarn("'ready' event is deprecated");
			}
		}
	};

	jQuery.fn.extend({

		bind: function (types, data, fn) {
			migrateWarn("jQuery.fn.bind() is deprecated");
			return this.on(types, null, data, fn);
		},
		unbind: function (types, fn) {
			migrateWarn("jQuery.fn.unbind() is deprecated");
			return this.off(types, null, fn);
		},
		delegate: function (selector, types, data, fn) {
			migrateWarn("jQuery.fn.delegate() is deprecated");
			return this.on(types, selector, data, fn);
		},
		undelegate: function (selector, types, fn) {
			migrateWarn("jQuery.fn.undelegate() is deprecated");
			return arguments.length === 1 ?
				this.off(selector, "**") :
				this.off(types, selector || "**", fn);
		},
		hover: function (fnOver, fnOut) {
			migrateWarn("jQuery.fn.hover() is deprecated");
			return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
		}
	});

	var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
		origHtmlPrefilter = jQuery.htmlPrefilter,
		makeMarkup = function (html) {
			var doc = window.document.implementation.createHTMLDocument("");
			doc.body.innerHTML = html;
			return doc.body && doc.body.innerHTML;
		},
		warnIfChanged = function (html) {
			var changed = html.replace(rxhtmlTag, "<$1></$2>");
			if (changed !== html && makeMarkup(html) !== makeMarkup(changed)) {
				migrateWarn("HTML tags must be properly nested and closed: " + html);
			}
		};

	jQuery.UNSAFE_restoreLegacyHtmlPrefilter = function () {
		jQuery.htmlPrefilter = function (html) {
			warnIfChanged(html);
			return html.replace(rxhtmlTag, "<$1></$2>");
		};
	};

	jQuery.htmlPrefilter = function (html) {
		warnIfChanged(html);
		return origHtmlPrefilter(html);
	};

	var oldOffset = jQuery.fn.offset;

	jQuery.fn.offset = function () {
		var elem = this[0];

		if (elem && (!elem.nodeType || !elem.getBoundingClientRect)) {
			migrateWarn("jQuery.fn.offset() requires a valid DOM element");
			return arguments.length ? this : undefined;
		}

		return oldOffset.apply(this, arguments);
	};

	// Support jQuery slim which excludes the ajax module
	// The jQuery.param patch is about respecting `jQuery.ajaxSettings.traditional`
	// so it doesn't make sense for the slim build.
	if (jQuery.ajax) {

		var oldParam = jQuery.param;

		jQuery.param = function (data, traditional) {
			var ajaxTraditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;

			if (traditional === undefined && ajaxTraditional) {

				migrateWarn("jQuery.param() no longer uses jQuery.ajaxSettings.traditional");
				traditional = ajaxTraditional;
			}

			return oldParam.call(this, data, traditional);
		};

	}

	var oldSelf = jQuery.fn.andSelf || jQuery.fn.addBack;

	jQuery.fn.andSelf = function () {
		migrateWarn("jQuery.fn.andSelf() is deprecated and removed, use jQuery.fn.addBack()");
		return oldSelf.apply(this, arguments);
	};

	// Support jQuery slim which excludes the deferred module in jQuery 4.0+
	if (jQuery.Deferred) {

		var oldDeferred = jQuery.Deferred,
			tuples = [

				// Action, add listener, callbacks, .then handlers, final state
				["resolve", "done", jQuery.Callbacks("once memory"),
					jQuery.Callbacks("once memory"), "resolved"],
				["reject", "fail", jQuery.Callbacks("once memory"),
					jQuery.Callbacks("once memory"), "rejected"],
				["notify", "progress", jQuery.Callbacks("memory"),
					jQuery.Callbacks("memory")]
			];

		jQuery.Deferred = function (func) {
			var deferred = oldDeferred(),
				promise = deferred.promise();

			deferred.pipe = promise.pipe = function ( /* fnDone, fnFail, fnProgress */) {
				var fns = arguments;

				migrateWarn("deferred.pipe() is deprecated");

				return jQuery.Deferred(function (newDefer) {
					jQuery.each(tuples, function (i, tuple) {
						var fn = typeof fns[i] === "function" && fns[i];

						// Deferred.done(function() { bind to newDefer or newDefer.resolve })
						// deferred.fail(function() { bind to newDefer or newDefer.reject })
						// deferred.progress(function() { bind to newDefer or newDefer.notify })
						deferred[tuple[1]](function () {
							var returned = fn && fn.apply(this, arguments);
							if (returned && typeof returned.promise === "function") {
								returned.promise()
									.done(newDefer.resolve)
									.fail(newDefer.reject)
									.progress(newDefer.notify);
							} else {
								newDefer[tuple[0] + "With"](
									this === promise ? newDefer.promise() : this,
									fn ? [returned] : arguments
								);
							}
						});
					});
					fns = null;
				}).promise();

			};

			if (func) {
				func.call(deferred, deferred);
			}

			return deferred;
		};

		// Preserve handler of uncaught exceptions in promise chains
		jQuery.Deferred.exceptionHook = oldDeferred.exceptionHook;

	}

	return jQuery;
});

var utils = function () {

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function each(items, fn, context) {

		for (var i = 0; i < items.length; i++) { (function (i) { fn(items[i], i, context); }).call(this, i); }

	}

	function supportsSticky() {

		var prop = 'position:';
		var value = 'sticky';
		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

		var el = document.createElement('a');
		var mStyle = el.style;
		mStyle.cssText = prop + prefixes.join(value + ';' + prop).slice(0, - prop.length);

		return mStyle.position.indexOf(value) !== -1;

	}

	function checkOnScreen(elm) {

		var rect = elm.getBoundingClientRect();
		var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		return !(rect.bottom < 0 || rect.top - viewHeight >= 0);

	}

	// https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
	function getBrowser() {

		var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if (/trident/i.test(M[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
			return { name: 'IE', version: (tem[1] || '') };
		}
		if (M[1] === 'Chrome') {
			tem = ua.match(/\bOPR|Edge\/(\d+)/)
			if (tem != null) { return { name: 'Opera', version: tem[1] }; }
		}
		M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
		if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
		return {
			name: M[0],
			version: M[1]
		};

	};

	return {
		debounce: debounce,
		each: each,
		supportsSticky: supportsSticky,
		checkOnScreen: checkOnScreen,
		getBrowser: getBrowser
	};

}();

// https://github.com/kraaden/autocomplete

!function (e, t) { "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).autocomplete = t() }(this, (function () { "use strict"; return function (e) { var t, n, o = document, i = o.createElement("div"), r = i.style, f = navigator.userAgent, l = -1 !== f.indexOf("Firefox") && -1 !== f.indexOf("Mobile"), u = e.debounceWaitMs || 0, a = e.preventSubmit || !1, s = e.disableAutoSelect || !1, d = l ? "input" : "keyup", c = [], p = "", v = 2, m = e.showOnFocus, g = 0; if (void 0 !== e.minLength && (v = e.minLength), !e.input) throw new Error("input undefined"); var h = e.input; function E() { n && window.clearTimeout(n) } function w() { return !!i.parentNode } function L() { var e; g++, c = [], p = "", t = void 0, (e = i.parentNode) && e.removeChild(i) } function b() { for (; i.firstChild;)i.removeChild(i.firstChild); var n = function (e, t) { var n = o.createElement("div"); return n.textContent = e.label || "", n }; e.render && (n = e.render); var f = function (e, t) { var n = o.createElement("div"); return n.textContent = e, n }; e.renderGroup && (f = e.renderGroup); var l = o.createDocumentFragment(), u = "#9?$"; if (c.forEach((function (o) { if (o.group && o.group !== u) { u = o.group; var i = f(o.group, p); i && (i.className += " group", l.appendChild(i)) } var r = n(o, p); r && (r.addEventListener("click", (function (t) { e.onSelect(o, h), L(), t.preventDefault(), t.stopPropagation() })), o === t && (r.className += " selected"), l.appendChild(r)) })), i.appendChild(l), c.length < 1) { if (!e.emptyMsg) return void L(); var a = o.createElement("div"); a.className = "empty", a.textContent = e.emptyMsg, i.appendChild(a) } i.parentNode || o.body.appendChild(i), function () { if (w()) { r.height = "auto", r.width = h.offsetWidth + "px"; var t, n = 0; f(), f(), e.customize && t && e.customize(h, t, i, n) } function f() { var e = o.documentElement, i = e.clientTop || o.body.clientTop || 0, f = e.clientLeft || o.body.clientLeft || 0, l = window.pageYOffset || e.scrollTop, u = window.pageXOffset || e.scrollLeft, a = (t = h.getBoundingClientRect()).top + h.offsetHeight + l - i, s = t.left + u - f; r.top = a + "px", r.left = s + "px", (n = window.innerHeight - (t.top + h.offsetHeight)) < 0 && (n = 0), r.top = a + "px", r.bottom = "", r.left = s + "px", r.maxHeight = n + "px" } }(), function () { var e = i.getElementsByClassName("selected"); if (e.length > 0) { var t = e[0], n = t.previousElementSibling; if (n && -1 !== n.className.indexOf("group") && !n.previousElementSibling && (t = n), t.offsetTop < i.scrollTop) i.scrollTop = t.offsetTop; else { var o = t.offsetTop + t.offsetHeight, r = i.scrollTop + i.offsetHeight; o > r && (i.scrollTop += o - r) } } }() } function y() { w() && b() } function x() { y() } function C(e) { e.target !== i ? y() : e.preventDefault() } function T(e) { for (var t = e.which || e.keyCode || 0, n = 0, o = [38, 13, 27, 39, 37, 16, 17, 18, 20, 91, 9]; n < o.length; n++) { if (t === o[n]) return } t >= 112 && t <= 123 || 40 === t && w() || D(0) } function N(n) { var o = n.which || n.keyCode || 0; if (38 === o || 40 === o || 27 === o) { var i = w(); if (27 === o) L(); else { if (!i || c.length < 1) return; 38 === o ? function () { if (c.length < 1) t = void 0; else if (t === c[0]) t = c[c.length - 1]; else for (var e = c.length - 1; e > 0; e--)if (t === c[e] || 1 === e) { t = c[e - 1]; break } }() : function () { if (c.length < 1 && (t = void 0), t && t !== c[c.length - 1]) { for (var e = 0; e < c.length - 1; e++)if (t === c[e]) { t = c[e + 1]; break } } else t = c[0] }(), b() } return n.preventDefault(), void (i && n.stopPropagation()) } 13 === o && (t && (e.onSelect(t, h), L()), a && n.preventDefault()) } function k() { m && D(1) } function D(o) { var i = ++g, r = h.value; r.length >= v || 1 === o ? (E(), n = window.setTimeout((function () { e.fetch(r, (function (e) { g === i && e && (p = r, t = (c = e).length < 1 || s ? void 0 : c[0], b()) }), o) }), 0 === o ? u : 0)) : L() } function H() { setTimeout((function () { o.activeElement !== h && L() }), 200) } return i.className = "autocomplete " + (e.className || ""), r.position = "absolute", i.addEventListener("mousedown", (function (e) { e.stopPropagation(), e.preventDefault() })), i.addEventListener("focus", (function () { return h.focus() })), h.addEventListener("keydown", N), h.addEventListener(d, T), h.addEventListener("blur", H), h.addEventListener("focus", k), window.addEventListener("resize", x), o.addEventListener("scroll", C, !0), { destroy: function () { h.removeEventListener("focus", k), h.removeEventListener("keydown", N), h.removeEventListener(d, T), h.removeEventListener("blur", H), window.removeEventListener("resize", x), o.removeEventListener("scroll", C, !0), E(), L() } } } }));
function setCookie(n,t,i){var r=new Date,u;r.setDate(r.getDate()+i);u=escape(t)+(i===null?"":";  expires="+r.toUTCString()+";path=/");document.cookie=n+"="+u}function getCookie(n){var t=document.cookie,i=t.indexOf(" "+n+"="),r;return i===-1&&(i=t.indexOf(n+"=")),i==-1?t=null:(i=t.indexOf("=",i)+1,r=t.indexOf(";",i),r==-1&&(r=t.length),t=unescape(t.substring(i,r))),t}function unsetCookie(n){getCookie(n)&&(document.cookie=n+"=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/")}
/**
 * Applies the :focus-visible polyfill at the given scope.
 * A scope in this case is either the top-level Document or a Shadow Root.
 *
 * @param {(Document|ShadowRoot)} scope
 * @see https://github.com/WICG/focus-visible
 */
function applyFocusVisiblePolyfill(scope) {
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;

	var inputTypesWhitelist = {
		text: true,
		search: true,
		url: true,
		tel: true,
		email: true,
		password: true,
		number: true,
		date: true,
		month: true,
		week: true,
		time: true,
		datetime: true,
		'datetime-local': true
	};

  /**
   * Helper function for legacy browsers and iframes which sometimes focus
   * elements like document, body, and non-interactive SVG.
   * @param {Element} el
   */
	function isValidFocusTarget(el) {
		if (
			el &&
			el !== document &&
			el.nodeName !== 'HTML' &&
			el.nodeName !== 'BODY' &&
			'classList' in el &&
			'contains' in el.classList
		) {
			return true;
		}
		return false;
	}

  /**
   * Computes whether the given element should automatically trigger the
   * `focus-visible` class being added, i.e. whether it should always match
   * `:focus-visible` when focused.
   * @param {Element} el
   * @return {boolean}
   */
	function focusTriggersKeyboardModality(el) {
		var type = el.type;
		var tagName = el.tagName;

		if (tagName === 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) {
			return true;
		}

		if (tagName === 'TEXTAREA' && !el.readOnly) {
			return true;
		}

		if (el.isContentEditable) {
			return true;
		}

		return false;
	}

  /**
   * Add the `focus-visible` class to the given element if it was not added by
   * the author.
   * @param {Element} el
   */
	function addFocusVisibleClass(el) {
		if (el.classList.contains('focus-visible')) {
			return;
		}
		el.classList.add('focus-visible');
		el.setAttribute('data-focus-visible-added', '');
	}

  /**
   * Remove the `focus-visible` class from the given element if it was not
   * originally added by the author.
   * @param {Element} el
   */
	function removeFocusVisibleClass(el) {
		if (!el.hasAttribute('data-focus-visible-added')) {
			return;
		}
		el.classList.remove('focus-visible');
		el.removeAttribute('data-focus-visible-added');
	}

  /**
   * If the most recent user interaction was via the keyboard;
   * and the key press did not include a meta, alt/option, or control key;
   * then the modality is keyboard. Otherwise, the modality is not keyboard.
   * Apply `focus-visible` to any current active element and keep track
   * of our keyboard modality state with `hadKeyboardEvent`.
   * @param {KeyboardEvent} e
   */
	function onKeyDown(e) {
		if (e.metaKey || e.altKey || e.ctrlKey) {
			return;
		}

		if (isValidFocusTarget(scope.activeElement)) {
			addFocusVisibleClass(scope.activeElement);
		}

		hadKeyboardEvent = true;
	}

  /**
   * If at any point a user clicks with a pointing device, ensure that we change
   * the modality away from keyboard.
   * This avoids the situation where a user presses a key on an already focused
   * element, and then clicks on a different element, focusing it with a
   * pointing device, while we still think we're in keyboard modality.
   * @param {Event} e
   */
	function onPointerDown(e) {
		hadKeyboardEvent = false;
	}

  /**
   * On `focus`, add the `focus-visible` class to the target if:
   * - the target received focus as a result of keyboard navigation, or
   * - the event target is an element that will likely require interaction
   *   via the keyboard (e.g. a text box)
   * @param {Event} e
   */
	function onFocus(e) {
		// Prevent IE from focusing the document or HTML element.
		if (!isValidFocusTarget(e.target)) {
			return;
		}

		if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
			addFocusVisibleClass(e.target);
		}
	}

  /**
   * On `blur`, remove the `focus-visible` class from the target.
   * @param {Event} e
   */
	function onBlur(e) {
		if (!isValidFocusTarget(e.target)) {
			return;
		}

		if (
			e.target.classList.contains('focus-visible') ||
			e.target.hasAttribute('data-focus-visible-added')
		) {
			// To detect a tab/window switch, we look for a blur event followed
			// rapidly by a visibility change.
			// If we don't see a visibility change within 100ms, it's probably a
			// regular focus change.
			hadFocusVisibleRecently = true;
			window.clearTimeout(hadFocusVisibleRecentlyTimeout);
			hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
				hadFocusVisibleRecently = false;
			}, 100);
			removeFocusVisibleClass(e.target);
		}
	}

  /**
   * If the user changes tabs, keep track of whether or not the previously
   * focused element had .focus-visible.
   * @param {Event} e
   */
	function onVisibilityChange(e) {
		if (document.visibilityState === 'hidden') {
			// If the tab becomes active again, the browser will handle calling focus
			// on the element (Safari actually calls it twice).
			// If this tab change caused a blur on an element with focus-visible,
			// re-apply the class when the user switches back to the tab.
			if (hadFocusVisibleRecently) {
				hadKeyboardEvent = true;
			}
			addInitialPointerMoveListeners();
		}
	}

  /**
   * Add a group of listeners to detect usage of any pointing devices.
   * These listeners will be added when the polyfill first loads, and anytime
   * the window is blurred, so that they are active when the window regains
   * focus.
   */
	function addInitialPointerMoveListeners() {
		document.addEventListener('mousemove', onInitialPointerMove);
		document.addEventListener('mousedown', onInitialPointerMove);
		document.addEventListener('mouseup', onInitialPointerMove);
		document.addEventListener('pointermove', onInitialPointerMove);
		document.addEventListener('pointerdown', onInitialPointerMove);
		document.addEventListener('pointerup', onInitialPointerMove);
		document.addEventListener('touchmove', onInitialPointerMove);
		document.addEventListener('touchstart', onInitialPointerMove);
		document.addEventListener('touchend', onInitialPointerMove);
	}

	function removeInitialPointerMoveListeners() {
		document.removeEventListener('mousemove', onInitialPointerMove);
		document.removeEventListener('mousedown', onInitialPointerMove);
		document.removeEventListener('mouseup', onInitialPointerMove);
		document.removeEventListener('pointermove', onInitialPointerMove);
		document.removeEventListener('pointerdown', onInitialPointerMove);
		document.removeEventListener('pointerup', onInitialPointerMove);
		document.removeEventListener('touchmove', onInitialPointerMove);
		document.removeEventListener('touchstart', onInitialPointerMove);
		document.removeEventListener('touchend', onInitialPointerMove);
	}

  /**
   * When the polfyill first loads, assume the user is in keyboard modality.
   * If any event is received from a pointing device (e.g. mouse, pointer,
   * touch), turn off keyboard modality.
   * This accounts for situations where focus enters the page from the URL bar.
   * @param {Event} e
   */
	function onInitialPointerMove(e) {
		// Work around a Safari quirk that fires a mousemove on <html> whenever the
		// window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
		if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
			return;
		}

		hadKeyboardEvent = false;
		removeInitialPointerMoveListeners();
	}

	// For some kinds of state, we are interested in changes at the global scope
	// only. For example, global pointer input, global key presses and global
	// visibility change should affect the state at every scope:
	document.addEventListener('keydown', onKeyDown, true);
	document.addEventListener('mousedown', onPointerDown, true);
	document.addEventListener('pointerdown', onPointerDown, true);
	document.addEventListener('touchstart', onPointerDown, true);
	document.addEventListener('visibilitychange', onVisibilityChange, true);

	addInitialPointerMoveListeners();

	// For focus and blur, we specifically care about state changes in the local
	// scope. This is because focus / blur events that originate from within a
	// shadow root are not re-dispatched from the host element if it was already
	// the active element in its own scope:
	scope.addEventListener('focus', onFocus, true);
	scope.addEventListener('blur', onBlur, true);

	// We detect that a node is a ShadowRoot by ensuring that it is a
	// DocumentFragment and also has a host property. This check covers native
	// implementation and polyfill implementation transparently. If we only cared
	// about the native implementation, we could just check if the scope was
	// an instance of a ShadowRoot.
	if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
		// Since a ShadowRoot is a special kind of DocumentFragment, it does not
		// have a root element to add a class to. So, we add this attribute to the
		// host element instead:
		scope.host.setAttribute('data-js-focus-visible', '');
	} else if (scope.nodeType === Node.DOCUMENT_NODE) {
		document.documentElement.classList.add('js-focus-visible');
	}
}

// It is important to wrap all references to global window and document in
// these checks to support server-side rendering use cases
// @see https://github.com/WICG/focus-visible/issues/199
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	// Make the polyfill helper globally available. This can be used as a signal
	// to interested libraries that wish to coordinate with the polyfill for e.g.,
	// applying the polyfill to a shadow root:
	window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

	// Notify interested libraries of the polyfill's presence, in case the
	// polyfill was loaded lazily:
	var event;

	try {
		event = new CustomEvent('focus-visible-polyfill-ready');
	} catch (error) {
		// IE11 does not support using CustomEvent as a constructor directly:
		event = document.createEvent('CustomEvent');
		event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
	}

	window.dispatchEvent(event);
}

if (typeof document !== 'undefined') {
	// Apply the polyfill to the global document, so that no JavaScript
	// coordination is required to use the polyfill in the top-level document:
	applyFocusVisiblePolyfill(document);
}
/**
* @preserve Copyright 2012 Twitter, Inc.
* @license http://www.apache.org/licenses/LICENSE-2.0.txt
*/
var Hogan = {}; !function (t) { function n(t, n, e) { var i; return n && "object" == typeof n && (void 0 !== n[t] ? i = n[t] : e && n.get && "function" == typeof n.get && (i = n.get(t))), i } function e(t, n, e, i, r, s) { function a() { } function o() { } a.prototype = t, o.prototype = t.subs; var u, c = new a; c.subs = new o, c.subsText = {}, c.buf = "", i = i || {}, c.stackSubs = i, c.subsText = s; for (u in n) i[u] || (i[u] = n[u]); for (u in i) c.subs[u] = i[u]; r = r || {}, c.stackPartials = r; for (u in e) r[u] || (r[u] = e[u]); for (u in r) c.partials[u] = r[u]; return c } function i(t) { return String(null === t || void 0 === t ? "" : t) } function r(t) { return t = i(t), l.test(t) ? t.replace(s, "&amp;").replace(a, "&lt;").replace(o, "&gt;").replace(u, "&#39;").replace(c, "&quot;") : t } t.Template = function (t, n, e, i) { t = t || {}, this.r = t.code || this.r, this.c = e, this.options = i || {}, this.text = n || "", this.partials = t.partials || {}, this.subs = t.subs || {}, this.buf = "" }, t.Template.prototype = { r: function () { return "" }, v: r, t: i, render: function (t, n, e) { return this.ri([t], n || {}, e) }, ri: function (t, n, e) { return this.r(t, n, e) }, ep: function (t, n) { var i = this.partials[t], r = n[i.name]; if (i.instance && i.base == r) return i.instance; if ("string" == typeof r) { if (!this.c) throw new Error("No compiler available."); r = this.c.compile(r, this.options) } if (!r) return null; if (this.partials[t].base = r, i.subs) { n.stackText || (n.stackText = {}); for (key in i.subs) n.stackText[key] || (n.stackText[key] = void 0 !== this.activeSub && n.stackText[this.activeSub] ? n.stackText[this.activeSub] : this.text); r = e(r, i.subs, i.partials, this.stackSubs, this.stackPartials, n.stackText) } return this.partials[t].instance = r, r }, rp: function (t, n, e, i) { var r = this.ep(t, e); return r ? r.ri(n, e, i) : "" }, rs: function (t, n, e) { var i = t[t.length - 1]; if (!f(i)) return void e(t, n, this); for (var r = 0; r < i.length; r++) t.push(i[r]), e(t, n, this), t.pop() }, s: function (t, n, e, i, r, s, a) { var o; return f(t) && 0 === t.length ? !1 : ("function" == typeof t && (t = this.ms(t, n, e, i, r, s, a)), o = !!t, !i && o && n && n.push("object" == typeof t ? t : n[n.length - 1]), o) }, d: function (t, e, i, r) { var s, a = t.split("."), o = this.f(a[0], e, i, r), u = this.options.modelGet, c = null; if ("." === t && f(e[e.length - 2])) o = e[e.length - 1]; else for (var l = 1; l < a.length; l++) s = n(a[l], o, u), void 0 !== s ? (c = o, o = s) : o = ""; return r && !o ? !1 : (r || "function" != typeof o || (e.push(c), o = this.mv(o, e, i), e.pop()), o) }, f: function (t, e, i, r) { for (var s = !1, a = null, o = !1, u = this.options.modelGet, c = e.length - 1; c >= 0; c--) if (a = e[c], s = n(t, a, u), void 0 !== s) { o = !0; break } return o ? (r || "function" != typeof s || (s = this.mv(s, e, i)), s) : r ? !1 : "" }, ls: function (t, n, e, r, s) { var a = this.options.delimiters; return this.options.delimiters = s, this.b(this.ct(i(t.call(n, r)), n, e)), this.options.delimiters = a, !1 }, ct: function (t, n, e) { if (this.options.disableLambda) throw new Error("Lambda features disabled."); return this.c.compile(t, this.options).render(n, e) }, b: function (t) { this.buf += t }, fl: function () { var t = this.buf; return this.buf = "", t }, ms: function (t, n, e, i, r, s, a) { var o, u = n[n.length - 1], c = t.call(u); return "function" == typeof c ? i ? !0 : (o = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(c, u, e, o.substring(r, s), a)) : c }, mv: function (t, n, e) { var r = n[n.length - 1], s = t.call(r); return "function" == typeof s ? this.ct(i(s.call(r)), r, e) : s }, sub: function (t, n, e, i) { var r = this.subs[t]; r && (this.activeSub = t, r(n, e, this, i), this.activeSub = !1) } }; var s = /&/g, a = /</g, o = />/g, u = /\'/g, c = /\"/g, l = /[&<>\"\']/, f = Array.isArray || function (t) { return "[object Array]" === Object.prototype.toString.call(t) } }("undefined" != typeof exports ? exports : Hogan), function (t) { function n(t) { "}" === t.n.substr(t.n.length - 1) && (t.n = t.n.substring(0, t.n.length - 1)) } function e(t) { return t.trim ? t.trim() : t.replace(/^\s*|\s*$/g, "") } function i(t, n, e) { if (n.charAt(e) != t.charAt(0)) return !1; for (var i = 1, r = t.length; r > i; i++) if (n.charAt(e + i) != t.charAt(i)) return !1; return !0 } function r(n, e, i, o) { var u = [], c = null, l = null, f = null; for (l = i[i.length - 1]; n.length > 0;) { if (f = n.shift(), l && "<" == l.tag && !(f.tag in k)) throw new Error("Illegal content in < super tag."); if (t.tags[f.tag] <= t.tags.$ || s(f, o)) i.push(f), f.nodes = r(n, f.tag, i, o); else { if ("/" == f.tag) { if (0 === i.length) throw new Error("Closing tag without opener: /" + f.n); if (c = i.pop(), f.n != c.n && !a(f.n, c.n, o)) throw new Error("Nesting error: " + c.n + " vs. " + f.n); return c.end = f.i, u } "\n" == f.tag && (f.last = 0 == n.length || "\n" == n[0].tag) } u.push(f) } if (i.length > 0) throw new Error("missing closing tag: " + i.pop().n); return u } function s(t, n) { for (var e = 0, i = n.length; i > e; e++) if (n[e].o == t.n) return t.tag = "#", !0 } function a(t, n, e) { for (var i = 0, r = e.length; r > i; i++) if (e[i].c == t && e[i].o == n) return !0 } function o(t) { var n = []; for (var e in t) n.push('"' + c(e) + '": function(c,p,t,i) {' + t[e] + "}"); return "{ " + n.join(",") + " }" } function u(t) { var n = []; for (var e in t.partials) n.push('"' + c(e) + '":{name:"' + c(t.partials[e].name) + '", ' + u(t.partials[e]) + "}"); return "partials: {" + n.join(",") + "}, subs: " + o(t.subs) } function c(t) { return t.replace(m, "\\\\").replace(v, '\\"').replace(b, "\\n").replace(d, "\\r").replace(x, "\\u2028").replace(w, "\\u2029") } function l(t) { return ~t.indexOf(".") ? "d" : "f" } function f(t, n) { var e = "<" + (n.prefix || ""), i = e + t.n + y++; return n.partials[i] = { name: t.n, partials: {} }, n.code += 't.b(t.rp("' + c(i) + '",c,p,"' + (t.indent || "") + '"));', i } function h(t, n) { n.code += "t.b(t.t(t." + l(t.n) + '("' + c(t.n) + '",c,p,0)));' } function p(t) { return "t.b(" + t + ");" } var g = /\S/, v = /\"/g, b = /\n/g, d = /\r/g, m = /\\/g, x = /\u2028/, w = /\u2029/; t.tags = { "#": 1, "^": 2, "<": 3, $: 4, "/": 5, "!": 6, ">": 7, "=": 8, _v: 9, "{": 10, "&": 11, _t: 12 }, t.scan = function (r, s) { function a() { m.length > 0 && (x.push({ tag: "_t", text: new String(m) }), m = "") } function o() { for (var n = !0, e = y; e < x.length; e++) if (n = t.tags[x[e].tag] < t.tags._v || "_t" == x[e].tag && null === x[e].text.match(g), !n) return !1; return n } function u(t, n) { if (a(), t && o()) for (var e, i = y; i < x.length; i++) x[i].text && ((e = x[i + 1]) && ">" == e.tag && (e.indent = x[i].text.toString()), x.splice(i, 1)); else n || x.push({ tag: "\n" }); w = !1, y = x.length } function c(t, n) { var i = "=" + S, r = t.indexOf(i, n), s = e(t.substring(t.indexOf("=", n) + 1, r)).split(" "); return T = s[0], S = s[s.length - 1], r + i.length - 1 } var l = r.length, f = 0, h = 1, p = 2, v = f, b = null, d = null, m = "", x = [], w = !1, k = 0, y = 0, T = "{{", S = "}}"; for (s && (s = s.split(" "), T = s[0], S = s[1]), k = 0; l > k; k++) v == f ? i(T, r, k) ? (--k, a(), v = h) : "\n" == r.charAt(k) ? u(w) : m += r.charAt(k) : v == h ? (k += T.length - 1, d = t.tags[r.charAt(k + 1)], b = d ? r.charAt(k + 1) : "_v", "=" == b ? (k = c(r, k), v = f) : (d && k++, v = p), w = k) : i(S, r, k) ? (x.push({ tag: b, n: e(m), otag: T, ctag: S, i: "/" == b ? w - T.length : k + S.length }), m = "", k += S.length - 1, v = f, "{" == b && ("}}" == S ? k++ : n(x[x.length - 1]))) : m += r.charAt(k); return u(w, !0), x }; var k = { _t: !0, "\n": !0, $: !0, "/": !0 }; t.stringify = function (n) { return "{code: function (c,p,i) { " + t.wrapMain(n.code) + " }," + u(n) + "}" }; var y = 0; t.generate = function (n, e, i) { y = 0; var r = { code: "", subs: {}, partials: {} }; return t.walk(n, r), i.asString ? this.stringify(r, e, i) : this.makeTemplate(r, e, i) }, t.wrapMain = function (t) { return 'var t=this;t.b(i=i||"");' + t + "return t.fl();" }, t.template = t.Template, t.makeTemplate = function (t, n, e) { var i = this.makePartials(t); return i.code = new Function("c", "p", "i", this.wrapMain(t.code)), new this.template(i, n, this, e) }, t.makePartials = function (t) { var n, e = { subs: {}, partials: t.partials, name: t.name }; for (n in e.partials) e.partials[n] = this.makePartials(e.partials[n]); for (n in t.subs) e.subs[n] = new Function("c", "p", "t", "i", t.subs[n]); return e }, t.codegen = { "#": function (n, e) { e.code += "if(t.s(t." + l(n.n) + '("' + c(n.n) + '",c,p,1),c,p,0,' + n.i + "," + n.end + ',"' + n.otag + " " + n.ctag + '")){t.rs(c,p,function(c,p,t){', t.walk(n.nodes, e), e.code += "});c.pop();}" }, "^": function (n, e) { e.code += "if(!t.s(t." + l(n.n) + '("' + c(n.n) + '",c,p,1),c,p,1,0,0,"")){', t.walk(n.nodes, e), e.code += "};" }, ">": f, "<": function (n, e) { var i = { partials: {}, code: "", subs: {}, inPartial: !0 }; t.walk(n.nodes, i); var r = e.partials[f(n, e)]; r.subs = i.subs, r.partials = i.partials }, $: function (n, e) { var i = { subs: {}, code: "", partials: e.partials, prefix: n.n }; t.walk(n.nodes, i), e.subs[n.n] = i.code, e.inPartial || (e.code += 't.sub("' + c(n.n) + '",c,p,i);') }, "\n": function (t, n) { n.code += p('"\\n"' + (t.last ? "" : " + i")) }, _v: function (t, n) { n.code += "t.b(t.v(t." + l(t.n) + '("' + c(t.n) + '",c,p,0)));' }, _t: function (t, n) { n.code += p('"' + c(t.text) + '"') }, "{": h, "&": h }, t.walk = function (n, e) { for (var i, r = 0, s = n.length; s > r; r++) i = t.codegen[n[r].tag], i && i(n[r], e); return e }, t.parse = function (t, n, e) { return e = e || {}, r(t, "", [], e.sectionTags || []) }, t.cache = {}, t.cacheKey = function (t, n) { return [t, !!n.asString, !!n.disableLambda, n.delimiters, !!n.modelGet].join("||") }, t.compile = function (n, e) { e = e || {}; var i = t.cacheKey(n, e), r = this.cache[i]; if (r) { var s = r.partials; for (var a in s) delete s[a].instance; return r } return r = this.generate(this.parse(this.scan(n, e.delimiters), n, e), n, e), this.cache[i] = r } }("undefined" != typeof exports ? exports : Hogan);
/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});
var trapFocus = function (element, namespace) {
	var elements = element.find('a, object, :input, iframe, [tabindex]'),
		firstElement = elements.first()[0],
		lastElement = elements.last()[0];

	element.focus().on('keydown.' + namespace, function (e) {
		var isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
		if (!isTabPressed) return;
		if (e.shiftKey) { // shift + tab
			if (document.activeElement === firstElement) {
				lastElement.focus();
				return false;
			}
		}
		else { // tab
			if (document.activeElement === lastElement) {
				firstElement.focus();
				return false;
			}
		}
	});
};

var removeTrapFocus = function (element, namespace) {
	$(element).off('keydown.' + namespace);
};
!function(t){"use strict";var y=/^[a-z]+:/,d=/[-a-z0-9]+(\.[-a-z0-9])*:\d+/i,v=/\/\/(.*?)(?::(.*?))?@/,r=/^win/i,g=/:$/,m=/^\?/,q=/^#/,w=/(.*\/)/,A=/^\/{2,}/,I=/(^\/?)/,e=/'/g,o=/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,n=/%([cd][0-9a-f])%([89ab][0-9a-f])/gi,i=/%([0-7][0-9a-f])/gi,s=/\+/g,a=/^\w:$/,C=/[^/#?]/;var p,S="undefined"==typeof window&&"undefined"!=typeof global&&"function"==typeof require,b=!S&&t.navigator&&t.navigator.userAgent&&~t.navigator.userAgent.indexOf("MSIE"),x=S?t.require:null,j={protocol:"protocol",host:"hostname",port:"port",path:"pathname",query:"search",hash:"hash"},z={ftp:21,gopher:70,http:80,https:443,ws:80,wss:443};function E(){return S?p=p||"file://"+(process.platform.match(r)?"/":"")+x("fs").realpathSync("."):"about:srcdoc"===document.location.href?self.parent.document.location.href:document.location.href}function h(t,r,e){var o,n,i;r=r||E(),S?o=x("url").parse(r):(o=document.createElement("a")).href=r;var a,s,p=(s={path:!0,query:!0,hash:!0},(a=r)&&y.test(a)&&(s.protocol=!0,s.host=!0,d.test(a)&&(s.port=!0),v.test(a)&&(s.user=!0,s.pass=!0)),s);for(n in i=r.match(v)||[],j)p[n]?t[n]=o[j[n]]||"":t[n]="";if(t.protocol=t.protocol.replace(g,""),t.query=t.query.replace(m,""),t.hash=F(t.hash.replace(q,"")),t.user=F(i[1]||""),t.pass=F(i[2]||""),t.port=z[t.protocol]==t.port||0==t.port?"":t.port,!p.protocol&&C.test(r.charAt(0))&&(t.path=r.split("?")[0].split("#")[0]),!p.protocol&&e){var h=new L(E().match(w)[0]),u=h.path.split("/"),c=t.path.split("/"),f=["protocol","user","pass","host","port"],l=f.length;for(u.pop(),n=0;n<l;n++)t[f[n]]=h[f[n]];for(;".."===c[0];)u.pop(),c.shift();t.path=("/"!==r.charAt(0)?u.join("/"):"")+"/"+c.join("/")}t.path=t.path.replace(A,"/"),b&&(t.path=t.path.replace(I,"/")),t.paths(t.paths()),t.query=new U(t.query)}function u(t){return encodeURIComponent(t).replace(e,"%27")}function F(t){return(t=(t=(t=t.replace(s," ")).replace(o,function(t,r,e,o){var n=parseInt(r,16)-224,i=parseInt(e,16)-128;if(0==n&&i<32)return t;var a=(n<<12)+(i<<6)+(parseInt(o,16)-128);return 65535<a?t:String.fromCharCode(a)})).replace(n,function(t,r,e){var o=parseInt(r,16)-192;if(o<2)return t;var n=parseInt(e,16)-128;return String.fromCharCode((o<<6)+n)})).replace(i,function(t,r){return String.fromCharCode(parseInt(r,16))})}function U(t){for(var r=t.split("&"),e=0,o=r.length;e<o;e++){var n=r[e].split("="),i=decodeURIComponent(n[0].replace(s," "));if(i){var a=void 0!==n[1]?F(n[1]):null;void 0===this[i]?this[i]=a:(this[i]instanceof Array||(this[i]=[this[i]]),this[i].push(a))}}}function L(t,r){h(this,t,!r)}U.prototype.toString=function(){var t,r,e="",o=u;for(t in this){var n=this[t];if(!(n instanceof Function||void 0===n))if(n instanceof Array){var i=n.length;if(!i){e+=(e?"&":"")+o(t)+"=";continue}for(r=0;r<i;r++){var a=n[r];void 0!==a&&(e+=e?"&":"",e+=o(t)+(null===a?"":"="+o(a)))}}else e+=e?"&":"",e+=o(t)+(null===n?"":"="+o(n))}return e},L.prototype.clearQuery=function(){for(var t in this.query)this.query[t]instanceof Function||delete this.query[t];return this},L.prototype.queryLength=function(){var t=0;for(var r in this.query)this.query[r]instanceof Function||t++;return t},L.prototype.isEmptyQuery=function(){return 0===this.queryLength()},L.prototype.paths=function(t){var r,e="",o=0;if(t&&t.length&&t+""!==t){for(this.isAbsolute()&&(e="/"),r=t.length;o<r;o++)t[o]=!o&&a.test(t[o])?t[o]:u(t[o]);this.path=e+t.join("/")}for(o=0,r=(t=("/"===this.path.charAt(0)?this.path.slice(1):this.path).split("/")).length;o<r;o++)t[o]=F(t[o]);return t},L.prototype.encode=u,L.prototype.decode=F,L.prototype.isAbsolute=function(){return this.protocol||"/"===this.path.charAt(0)},L.prototype.toString=function(){return(this.protocol&&this.protocol+"://")+(this.user&&u(this.user)+(this.pass&&":"+u(this.pass))+"@")+(this.host&&this.host)+(this.port&&":"+this.port)+(this.path&&this.path)+(this.query.toString()&&"?"+this.query)+(this.hash&&"#"+u(this.hash))},t[t.exports?"exports":"Url"]=L}("undefined"!=typeof module&&module.exports?module:window);

var site = {



	win: $(window),

	doc: $(document),

	html: $('html'),

	body: $('body'),

	pageTop: 0,

	translations: $.parseJSON($('#dictionaryTranslations').html()),



	bp: {

		mobileLarge: 576,

		tablet: 768,

		tabletLarge: 980,

		desktop: 1025,

		desktopLarge: 1200

	},



	init: function () {



		site.addFeatureClasses();



		// clear slow connection timeout

		clearTimeout(slowConnectionTimeout);

		// preload done

		site.body.removeClass('preload');

		// debug

		if (location.href.indexOf('localhost') > -1 || location.href.indexOf('dyson.careers.local') > -1 || location.href.indexOf('dysoncareers.internal.gibedigital.com') > -1) {

			site.body.addClass('debug');

		}

		// continue

		site.setup.init();

		site.nav.init();

		setCookie('UserPreviouslyVisited', true, 7);



	},



	setup: {



		init: function () {

			site.setup.scrolling();

			site.setup.waypoints();

			site.setup.accessibility();

			site.setup.cms();

			site.setup.analytics();

			site.setup.ctas();

		},



		accessibility: function () {



			// move focus

			$('.js-move-focus:not(.js-move-focus-done)').each(function () {

				var link = $(this);

				var element = $(link.attr('href'));



				// click

				link.off('click').on('click', function () {

					// focus

					element.find('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), *[tabindex]').first().focus();

					// scroll

					site.scrollTo(element.offset().top);

					return false;

				});



				// done

				link.addClass('js-move-focus-done');

			});



		},



		waypoints: function () {

			// Disable animations for Selenium tests by checking the user agent

			if (navigator.userAgent.includes('DysonCareersSeleniumTest')) {

				console.log('Selenium test run detected. Disabling animations.');

				

				// Just returning this function is not enough, as the content is never shown if this funciton does not run

				// So the CSS class of 'html--slow-connection' must be used in conjuction to help display these elements

				document.documentElement.classList.add('html--slow-connection');

				return;

			}



			if (document.getElementsByTagName('html')[0].classList.contains('html--slow-connection')) return;



			var fadeInElements = document.querySelectorAll('.js-fade-in:not(.js-fade-in-done)');



			if (fadeInElements.length) {



				var fadeInItemObserver = new IntersectionObserver(function (entries) {



					utils.each(entries, function (entry, i, context) {



						if (entry.intersectionRatio > 0) {



							setTimeout(function () {



								var items = entry.target.querySelectorAll('.js-fade-in-item');

								utils.each(items, function (item, i, context) { item.classList.add('fade-in'); }, this);



							}, 150);



						}



					}, this);



				});



				utils.each(fadeInElements, function (element, i, context) {



					fadeInItemObserver.observe(element);

					element.classList.add('js-fade-in-done');



				}, this);



			}



			var scrollInElements = document.querySelectorAll('.js-scroll-in:not(.js-scroll-in-done)');



			if (scrollInElements.length) {



				var scrollInItemObserver = new IntersectionObserver(function (entries) {



					utils.each(entries, function (entry, i, context) {



						if (entry.intersectionRatio > 0) {



							setTimeout(function () { entry.target.classList.add('scroll-in'); }, 300);



						}



					}, this);



				});



				utils.each(scrollInElements, function (element, i, context) {



					scrollInItemObserver.observe(element);

					element.classList.add('js-scroll-in-done');



				}, this);



			}



		},



		cms: function () {

			$('.cms:not(.js-cms-done)').each(function () {

				var wrapper = $(this);



				// tables

				wrapper.find('table:not(.js-cms-table-done)').wrap('<div class="cms-table" />');



				// images

				wrapper.find('img:not(.js-cms-image-done)').removeAttr('style width height');



				// done

				wrapper.addClass('js-cms-done');

			});

		},



		scrolling: function () {



			site.getScrollWidth = function () {

				var outer = document.createElement("div");

				outer.style.visibility = "hidden";

				outer.style.width = "100px";



				document.body.appendChild(outer);



				var widthNoScroll = outer.offsetWidth;

				// force scrollbars

				outer.style.overflow = "scroll";



				// add innerdiv

				var inner = document.createElement("div");

				inner.style.width = "100%";

				outer.appendChild(inner);



				var widthWithScroll = inner.offsetWidth;



				// remove divs

				outer.parentNode.removeChild(outer);



				return widthNoScroll - widthWithScroll;

			};



			site.scrollTo = function (offset, speed) {

				var value = parseInt(offset, 10);

				var headerOffset = 100;

				value -= headerOffset;

				if (value < -headerOffset && $('html, body').scrollTop !== value) return;

				site.html.add(site.body).animate({

					scrollTop: value, easing: 'linear'

				}, speed || 500);

			};



			site.smoothScroll = function () {

				$('a[href*="#"]:not(.js-scroll-done)').each(function () {

					var link = $(this);

					link.on('click', function () {

						if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

							var target = $(this.hash);

							target = target.length && target || $('[name=' + this.hash.slice(1) + ']');

							if (target.length) {

								var targetOffset = target.offset().top;

								if (site.win.scrollTop != targetOffset) {

									site.scrollTo(targetOffset);

								}

								return false;

							}

						}

					});

					link.addClass('js-scroll-done');

				});

			};



			site.smoothScroll();



			site.enableLockout = function () {

				site.pageTop = site.win.scrollTop();

				site.body.css('margin-top', '-' + site.pageTop + 'px');

				site.html.addClass('lockout');

				site.body.addClass('lockout');

			};



			site.disableLockout = function () {

				site.html.removeClass('lockout');

				site.body.removeClass('lockout').css('margin-top', 0);

				site.html.add(site.body).scrollTop(site.pageTop);

			};



			site.disableScroll = function () {

				site.body.addClass('disable-scroll');

			};



			site.enableScroll = function () {

				site.body.removeClass('disable-scroll');

			};



		},



		analytics: function () {



			site.analytics = {



				init: function () {

					$('a[data-analytics-event]:not(.js-analytics-done)').each(function () {

						var link = $(this);

						var e = link.attr('data-analytics-event').split('|');

						// click

						link.on('click', function () {

							site.analytics.track(e[0], e[1], e[2]);

						});

						// done

						link.addClass('js-analytics-done');

					});

				},



				page: function (url, title) {

					dataLayer.push({

						'virtualPageUrl': url,

						'virtualPageTitle': title,

						'event': 'VirtualPageView'

					});

				},



				track: function (category, action, label) {

					dataLayer.push({

						'eventCategory': category,

						'eventAction': action,

						'eventLabel': label,

						'event': 'EventTracking'

					});

				}



			};



			site.analytics.init();



		},



		ctas: function () {



			$('a.form-button--cta').click(function () {



				var target = $(this);



				if (site.isTouch() && window.matchMedia('(max-width: ' + (site.bp.desktop - 1) + 'px)').matches) {



					$(this).addClass('form-button--cta--hover');

					setTimeout(function () { location.href = target.attr('href'); }, 500);

					return false;



				}



			});



		}



	},



	nav: {



		done: false,

		expanded: false,

		mq: null,

		speed: $('html').hasClass('prefers-reduce-motion') ? 0 : 300,



		init: function () {

			site.nav.mq = '(min-width: ' + site.bp.desktop + 'px)';

			if (site.nav.done) return;

			site.nav.done = true;

			site.nav.toggle();

			site.nav.menus();

		},



		toggle: function () {

			var navToggle = $('#primary-nav-toggle');

			var navMenu = $('#primary-nav');

			var menuItems = navMenu.find('.js-nav-item');

			var allow = true;

			var header = $('.js-site-header');



			// open

			var _open = function (useAnim) {

				if (!allow) return;

				allow = false;

				navToggle.attr('aria-expanded', true);

				navMenu.attr('aria-expanded', true);

				if (useAnim) {

					setTimeout(function () {

						menuItems.addClass('fade-in');

					}, 100);

					navMenu.slideDown(site.nav.speed, function () {

						site.enableLockout();

						site.nav.expanded = true;

						allow = true;

					});

				}

				else {

					site.enableLockout();

					site.nav.expanded = true;

					allow = true;

				}

				trapFocus(header, 'primaryNav');

			};



			// close

			var _close = function (useAnim) {

				if (!allow) return;

				allow = false;

				navToggle.attr('aria-expanded', false);

				navMenu.attr('aria-expanded', false);

				menuItems.removeClass('fade-in');

				if (useAnim) {

					navMenu.slideUp(site.nav.speed, function () {

						site.disableLockout();

						navMenu.find('.js-nav-link[aria-expanded], .js-nav-sub').attr('aria-expanded', false);

						site.nav.expanded = false;

						allow = true;

					});

				}

				else {

					navMenu.hide();

					site.disableLockout();

					navMenu.find('.js-nav-link[aria-expanded], .js-nav-sub').attr('aria-expanded', false);

					site.nav.expanded = false;

					allow = true;

				}

				removeTrapFocus(header, 'primaryNav');

			};



			// toggle click

			navToggle.off('click').on('click', function () {

				if (window.matchMedia(site.nav.mq).matches) return false;

				if (site.nav.expanded) {

					_close(true);

				}

				else {

					_open(true);

				}

				return false;

			});



			// initial aria expanded state



			if (window.matchMedia(site.nav.mq).matches) { navMenu.removeAttr('aria-expanded'); } else { navMenu.attr('aria-expanded', site.nav.expanded); }



			// resize



			var timer;



			site.win.on('resize', function () {

				if (timer) { window.clearTimeout(timer); }

				timer = window.setTimeout(function () {



					if (window.matchMedia(site.nav.mq).matches && site.nav.expanded) {

						_close(false);

					}



					if (window.matchMedia(site.nav.mq).matches) { navMenu.removeAttr('aria-expanded'); } else { navMenu.attr('aria-expanded', site.nav.expanded); }



				}, 500);

			});



		},



		menus: function () {

			var navMenu = $('#primary-nav');

			var menuLinks = navMenu.find('.js-nav-link[aria-expanded]');

			var subMenus = navMenu.find('.js-nav-sub');

			var wasDesktop = window.matchMedia(site.nav.mq).matches;

			var allow = true;



			// cache 2nd level nav items



			var subLinksWithChildren = navMenu.find('.js-nav-sub-link'),

				subSubMenus = navMenu.find('.js-nav-sub-sub');



			// reset 2nd level nav items



			var _resetSecondLevelNav = function () {



				if (window.matchMedia(site.nav.mq).matches) { // desktop



					subLinksWithChildren.removeAttr('aria-expanded').removeAttr('aria-label').removeAttr('role').removeAttr('aria-controls');

					subSubMenus.removeAttr('aria-expanded');

					subSubMenus.show();



				} else { // mobile



					subLinksWithChildren.each(function () {



						var link = $(this),

						label = link.attr('data-label-text'),

						controls = link.attr('data-aria-controls');

						link.attr('aria-expanded', false).attr('aria-label', label).attr('role', 'button').attr('aria-controls', controls);



					});



					subSubMenus.attr('aria-expanded', false);

					subSubMenus.hide();



				}



			};



			_resetSecondLevelNav();



			// click events for 2nd level nav items



			subLinksWithChildren.off('click').on('click', function () {



				if (!window.matchMedia(site.nav.mq).matches) {



					if (!allow) return false;

					allow = false;



					var link = $(this),

						menu = link.nextAll('.js-nav-sub-sub:first');



					if (link.filter('[aria-expanded="true"]').length) {



						link.add(menu).attr('aria-expanded', false);



						menu.slideUp(site.nav.speed, function () {

							allow = true;

						});



					} else {



						link.add(menu).attr('aria-expanded', true);



						menu.slideDown(site.nav.speed, function () {

							allow = true;

						});



					}



					return false;



				}



			});



			// close

			var _closeAll = function () {

				menuLinks.attr('aria-expanded', false);

				subMenus.attr('aria-expanded', false);

				subMenus.hide();

				_resetSecondLevelNav();

			};



			// toggle click

			menuLinks.off('click').on('click', function () {

				if (!allow) return false;

				allow = false;

				var link = $(this);

				var menu = link.nextAll('.js-nav-sub:first');

				var expanded = link.attr('aria-expanded') == 'true' ? true : false;



				// close others

				if (window.matchMedia(site.nav.mq).matches) {

					_closeAll();

				}



				// open this

				link.attr('aria-expanded', !expanded);

				menu.attr('aria-expanded', !expanded);

				if (window.matchMedia(site.nav.mq).matches) {

					if (expanded) {

						menu.hide();

					}

					else {

						menu.show();

					}

					allow = true;

				}

				else {

					if (expanded) {



						menu.slideUp(site.nav.speed, function () {



							menu.find('.js-nav-sub-link').attr('aria-expanded', false);

							menu.find('.js-nav-sub-sub').attr('aria-expanded', false).hide();

							allow = true;



						});



					}

					else {

						menu.slideDown(site.nav.speed, function () {

							allow = true;

						});

					}

				}



				return false;

			});



			// click anywhere

			site.body.on('click', function (e) {

				if ($(e.target).closest(navMenu).length === 0 && window.matchMedia(site.nav.mq).matches) {

					_closeAll();

				}

			});



			// resize

			site.win.on('resize', function () {

				if ((wasDesktop && !window.matchMedia(site.nav.mq).matches) || (!wasDesktop && window.matchMedia(site.nav.mq).matches)) {

					_closeAll();

					wasDesktop = !wasDesktop;

				}

			});

		}



	},



	isLockedOut: function () {

		return site.html.hasClass('lockout');

	},



	isTouch: function () {

		return "ontouchstart" in document || window.DocumentTouch && document instanceof DocumentTouch;

	},



	addFeatureClasses: function () {



		if (site.isTouch()) {



			site.html.addClass('touchevents');



		} else {



			site.html.addClass('no-touchevents');



		}



		var browserInfo = utils.getBrowser();



		if (browserInfo.name === 'Safari') {



			site.html.addClass('is-safari');



		}



	}



};



$(function () {

	site.init();

	site.doc.ajaxComplete(function () {

		site.init();

	});

});

var accordion = {



	speed: $('html').hasClass('prefers-reduce-motion') ? 0 : 300,



	init: function () {



		$('.js-accordion:not(.js-accordion-done)').each(function () {

			var wrapper = $(this);

			var allow = true;

			var titles = wrapper.find('.js-accordion-title');



			// init

			wrapper.find('.js-accordion-group').each(function () {

				var currentGroupElement = $(this);

				if (currentGroupElement.attr('data-accordion-open-onload') !== 'true') {

					currentGroupElement.find('.js-accordion-title').removeClass('expanded').attr('aria-expanded', 'false');

					currentGroupElement.find('.js-accordion-panel').hide().attr('aria-hidden', 'true');

				}

			});



			// toggle

			titles.off('click').on('click', 

				function () {

					if (!allow) return false;

					allow = true;



					var title = $(this);

					var panel = title.closest('.js-accordion-group').find('.js-accordion-panel');

					var isOpen = title.is('.expanded');



					if (isOpen) {

						accordion.closeAccordion(title, panel);

					}

					else {

						accordion.openAccordion(title, panel);

					}



					return false;



				});



			$('.js-accordion-all-toggle').on('click', function () {

				var container = $(this).closest('.js-accordion');

				var title = container.find('.js-accordion-title');

				var panel = container.find('.js-accordion-panel');



				var shouldOpen = $(this).attr('data-accordion-open-all') === 'true';



				if (shouldOpen) {

					accordion.openAccordion(title, panel);

				} else {

					accordion.closeAccordion(title, panel);

				}



			});

			

			// done

			wrapper.addClass('js-accordion-done');



			accordion.setAllToggleButton($(this)[0]);

		});



	},



	openAccordion: function (title, panel) {

		title.addClass('expanded');

		panel.slideDown(accordion.speed, function () {

			title.attr('aria-expanded', 'true');

			panel.attr('aria-hidden', 'false');

			allow = true;

			isOpen = true;

			setTimeout(function () {

				accordion.setAllToggleButton(title.closest('.js-accordion')[0]);

			}, accordion.speed + 25);

		});



	},



	closeAccordion: function (title, panel) {

		title.removeClass('expanded');

		panel.slideUp(accordion.speed, function () {

			title.attr('aria-expanded', 'false');

			panel.attr('aria-hidden', 'true');

			allow = true;

			isOpen = false;

			setTimeout(function () {

				accordion.setAllToggleButton(title.closest('.js-accordion')[0]);

			}, accordion.speed + 25);

		});

	},



	setAllToggleButton: function (containerElement) {



		var toggleAllButtonElement = containerElement.querySelector('.js-accordion-all-toggle');



		if (!toggleAllButtonElement) {

			return;

		}



		var hasOpenAccordion = false;

		var accordionTitleElements = containerElement.querySelectorAll('.js-accordion-title');



		for (var i = 0; i < accordionTitleElements.length; i++) {

			var currentPanel = accordionTitleElements[i];

			if (currentPanel.getAttribute('aria-expanded') === 'true') {

				hasOpenAccordion = true;

				break;

			}

		}



		var toggleText = containerElement.querySelector('.js-accordion-all-toggle');

		var showText = toggleAllButtonElement.getAttribute('data-accordion-toggle-show-text');

		var hideText = toggleAllButtonElement.getAttribute('data-accordion-toggle-hide-text');

		toggleText.textContent = hasOpenAccordion ? hideText : showText;

		toggleText.setAttribute('data-accordion-open-all', !hasOpenAccordion);



	}



};



$(function () {

	accordion.init();

});
var alternatingFeatureBlocks = {

	isIE11: !!window.MSInputMethodContext && !!document.documentMode,

	elements: $('.js-alternating-feature-block'),

	minimumHeight: 300, // matches value in CSS

	updateUrlParams: function (input, keys, values) {

		var output = input;

		if (keys.length === values.length) {

			var separator = output.indexOf('?') !== -1 ? "&" : "?";

			$.each(keys, function (index) {

				var re = new RegExp("([?&])" + keys[index] + "=.*?(&|$)", "i");
				if (output.match(re)) { output = output.replace(re, '$1' + keys[index] + "=" + values[index] + '$2'); } else { output = output + separator + keys[index] + "=" + values[index]; }

			});

		}

		return output;

	},

	getHeight: function (contentHeight, maxHeight) {

		if (contentHeight > alternatingFeatureBlocks.minimumHeight) {

			if (contentHeight > maxHeight) { return maxHeight; } else { return contentHeight; }

		}

		return alternatingFeatureBlocks.minimumHeight;

	},

	updateSourceSet: function (picture, width, height) {

		if (!picture.length) {
			return null
		}

		if (!alternatingFeatureBlocks.isIE11) {

			var desktopSource = picture.find('source[media="(min-width: ' + site.bp.desktop + 'px)"]'),
			desktopSrcSet = desktopSource.attr('srcset'),
			desktopSrcSetParts = desktopSrcSet.split(' 2x, ');

			var desktopSrcSetUpdated = alternatingFeatureBlocks.updateUrlParams(desktopSrcSetParts[0], ['width', 'height'], [width, height]);
			desktopSrcSetUpdated += ', ' + alternatingFeatureBlocks.updateUrlParams(desktopSrcSetParts[0], ['width', 'height'], [(width * 2), (height * 2)]) + ' 2x';

			desktopSource.attr('srcset', desktopSrcSetUpdated);

		}

		return picture;

	},

	init: function () {

		if (alternatingFeatureBlocks.elements.length) {

			alternatingFeatureBlocks.elements.each(function () {

				var target = $(this),
				pictureWrapper = target.find('.js-alternating-feature-block-picture-wrapper'),
				content = target.find('.js-alternating-feature-block-content'),
				contentHeight = content.height(),
				maxWidth = pictureWrapper.width();
				maxHeight = pictureWrapper.width();

				var calculatedHeight = alternatingFeatureBlocks.getHeight(contentHeight, maxHeight);

				var picture = target.find('.js-alternating-feature-block-picture');

				if (!picture.length) {
					return;
				}

				if (window.matchMedia('(min-width: ' + site.bp.desktop + 'px)').matches) {

					picture.height(calculatedHeight);

					if (!target.is('.js-alternating-feature-block-changed')) {

						picture = alternatingFeatureBlocks.updateSourceSet(picture, maxWidth, calculatedHeight);
						target.addClass('js-alternating-feature-block-changed');

					}

				} else {

					picture.removeAttr('style');

				}

				picture.css('opacity', 1);

			});

		}

	}

};

$(function () {
	alternatingFeatureBlocks.init();

	var timer;

	site.win.resize(function () {
		if (timer) { window.clearTimeout(timer); }
		timer = window.setTimeout(function () {
			alternatingFeatureBlocks.init();
		}, 500);
	});
});
var cookieNotice = function () {

  var publicMethods = {};

  var wrapper;
  var cookie = getCookie('cookieNotice');
  var activeStageClass = 'c-cookie-notice__stage--active';
  var showClass = 'c-cookie-notice--show';
  var formButtonClass = ' form-button form-button--tiny';
  var formButtonSecondaryClass = ' form-button--secondary';

  publicMethods.init = function() {

    if (cookie) {

      appendScripts(cookie);

    } else {

      appendNotice();

    }

  };

  function hideCookieNotice() {

    wrapper.classList.remove(showClass);
    setTimeout(function() { wrapper.remove(); }, 750);

  };

  function buttonAllowClick() {
    
    var categories = getAllowedCategories(true);
    
    appendScripts(categories);
    setCookie('cookieNotice', categories, 30);
    hideCookieNotice();

    };

    function buttonRejectClick() {

        var categories = getAllowedCategories(false);

        appendScripts(categories);
        setCookie('cookieNotice', categories, 30);
        hideCookieNotice()
    };

  function buttonSaveClick() {
    
    var categories = getAllowedCategories(false);
    
    appendScripts(categories);
    setCookie('cookieNotice', categories, 30);
    hideCookieNotice();
    
  };
  
  function buttonManageClick() {
    
    document.querySelector('[data-cookie-notice-stage="one"]').classList.remove(activeStageClass);
    document.querySelector('[data-cookie-notice-stage="two"]').classList.add(activeStageClass);

    trapFocus(wrapper, '[data-cookie-notice-stage="one"]');

    var elementsToFocusOn = document.querySelectorAll('[data-cookie-notice-checkbox]:not([disabled])');
    if (elementsToFocusOn.length) elementsToFocusOn[0].focus();
    
  };

  function appendNotice() {
    
    if (!canAppendNotice()) return;
    
    var categoryHtml = getCategoryHtml();

    var noticeHtml =
    '<div class="c-cookie-notice" data-cookie-notice role="dialog" aria-labelledby="cookie-notice-title" aria-describedby="cookie-notice-description">' +
      '<div class="c-cookie-notice__inner">' +
        '<div class="c-cookie-notice__inner__inner">' +
          '<p class="c-cookie-notice__title" id="cookie-notice-title">' + cookieNoticeSettings.title + '</p>' +
          '<div class="c-cookie-notice__description">' +
            '<p id="cookie-notice-description">' + cookieNoticeSettings.content + ' <a href="' + cookieNoticeSettings.infoLink + '" aria-label="' + cookieNoticeSettings.infoLinkAriaLabel + '">' + cookieNoticeSettings.infoLinkText + '</a></p>' +
          '</div>' +
          '<div class="c-cookie-notice__stage c-cookie-notice__stage--active" data-cookie-notice-stage="one">' +
            '<div class="c-cookie-notice__actions">' +
        '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="allow" aria-label="' + cookieNoticeSettings.allowAllAriaLabel + '">' + cookieNoticeSettings.allowAllText + '</button></p>' +
        '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-reject-button="reject" aria-label="' + cookieNoticeSettings.rejectAllAriaLabel + '">' + cookieNoticeSettings.rejectAllText + '</button></p>' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + formButtonSecondaryClass + '" data-cookie-notice-button="manage" aria-controls="cookie-notice-manage" aria-expanded="false" aria-label="' + cookieNoticeSettings.manageAriaLabel + '">' + cookieNoticeSettings.manageText + '</button></p>' +
            '</div>' +
          '</div>' +
          '<div class="c-cookie-notice__stage" data-cookie-notice-stage="two" id="cookie-notice-manage">' +
            '<div class="c-cookie-notice__actions">' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + '" data-cookie-notice-button="allow" aria-label="' + cookieNoticeSettings.allowAllAriaLabel + '">' + cookieNoticeSettings.allowAllText + '</button></p>' +
            '</div>' +
            categoryHtml +
            '<div class="c-cookie-notice__actions">' +
              '<p class="c-cookie-notice__action"><button type="button" class="c-cookie-notice__button' + formButtonClass + formButtonSecondaryClass + '" data-cookie-notice-button="save" aria-label="' + cookieNoticeSettings.saveAriaLabel + '">' + cookieNoticeSettings.saveText + '</button></p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    document.body.insertAdjacentHTML('afterbegin', noticeHtml);

    wrapper = document.querySelector('[data-cookie-notice]');
      var allowButtons = document.querySelectorAll('[data-cookie-notice-button="allow"]');
      var rejectButton = document.querySelector('[data-cookie-notice-reject-button="reject"]');
    var manageButton = document.querySelector('[data-cookie-notice-button="manage"]');
    var saveButton = document.querySelector('[data-cookie-notice-button="save"]');



    manageButton.addEventListener('click', function () {

      buttonManageClick();
      manageButton.setAttribute('aria-expanded', 'true');

    });

    
    saveButton.addEventListener('click', buttonSaveClick);
    scopedLoop(allowButtons, function (button, i, context) { button.addEventListener('click', buttonAllowClick); }, this);
      rejectButton.addEventListener('click', buttonRejectClick);
    wrapper.classList.add(showClass);

    trapFocus(wrapper, '[data-cookie-notice-stage="two"]');

  };
  
  function getCategoryHtml() {
    
    var html = '<ul class="c-cookie-notice__categories">';
    
    scopedLoop(cookieNoticeSettings.categories, function (category, i, context) {
      
      var forceAcceptanceMarkUp = category.forceAcceptance ? 'checked disabled ' : '';
      var forceAcceptanceClass = category.forceAcceptance ? ' is-disabled' : '';
      var checkboxId = 'cookie-notice-checkbox-' + i;
      
      html +=
      '<li class="c-cookie-notice__categories__item">' +
        '<div class="c-cookie-notice__categories__title">' +
          '<input type="checkbox" class="c-cookie-notice__categories__title__checkbox" id="' + checkboxId + '" value="' + category.category + '"' + forceAcceptanceMarkUp + ' data-cookie-notice-checkbox="' + i + '"/>' +
          '<label class="c-cookie-notice__categories__title__label' + forceAcceptanceClass + '" for="' + checkboxId + '">' +
            '<span class="c-cookie-notice__categories__title__text">' + category.title + '</span>' +
          '</label>' +
        '</div>' +
        '<div class="c-cookie-notice__categories__description">' +
          '<p>' + category.description + '</p>' +
        '</div>' +
      '</li>';
      
    }, this);
    
    html += '</ul>';
    
    return html;
    
  };
  
  function canAppendNotice() {
    
    var result = true;
    
    if (cookieNoticeSettings.infoLink) {
      
     var currentUrl = window.location.href.toLowerCase();
     if (currentUrl.indexOf(cookieNoticeSettings.infoLink.toLowerCase()) !== -1) { result = false; }
      
    }
    
    return result;
    
  };
  
  function getAllowedCategories(getAll) {
    
    var categories = [];
    
    var checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
    
    scopedLoop(checkboxes, function (checkbox, i, context) {
      
      var isChecked = checkbox.checked || getAll;
      var data = {};
      data[checkbox.value] = isChecked; 
      categories.push(data);
      
    }, this);
    
    return JSON.stringify(categories);
    
  };

  function appendScripts(categories) {

    cookieNoticeSettings.loadScriptsByCategory(categories);

  };

  function trapFocus(element, parentIgnoreSelector) {

    var potentiallyFocusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');

    var focusableEls = [];

    if (parentIgnoreSelector) {

      scopedLoop(potentiallyFocusableElements, function (focusableEl, i, context) {

        if (!focusableEl.closest(parentIgnoreSelector)) focusableEls.push(focusableEl);

      }, this);

    } else {

      focusableEls = potentiallyFocusableElements;

    }

    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {

      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) { // if shift key pressed for shift + tab combination

        if (document.activeElement === firstFocusableEl) {

          lastFocusableEl.focus();
          e.preventDefault();

        }

      } else { // if tab key is pressed

        if (document.activeElement === lastFocusableEl) {

          firstFocusableEl.focus();
          e.preventDefault();

        }

      }

    });

  };

  function scopedLoop(items, fn, context) {

    for (var i = 0; i < items.length; i++) { (function (i) { fn(items[i], i, context); }).call(this, i); }

  };

  function setCookie(n, t, i) {

    var r = new Date, u;
    r.setDate(r.getDate() + i);
    u = escape(t) + (i === null ? "" : ";  expires=" + r.toUTCString() + ";path=/");
    document.cookie = n + "=" + u;

  };

  function getCookie(n) {

    var t = document.cookie, i = t.indexOf(" " + n + "="), r;
    return i === -1 && (i = t.indexOf(n + "=")), i == -1 ? t = null : (i = t.indexOf("=", i) + 1, r = t.indexOf(";", i), r == -1 && (r = t.length), t = unescape(t.substring(i, r))), t;

  };

  return publicMethods;

}();

cookieNotice.init();

var external = {

	init: function () {
		$('a.js-external:not(.js-external-done)').each(function () {
			var link = $(this);
			// click
			link.off('click').on('click', function () {
				if (site.isTouch() || site.win.width() < 640) return true;
				var w = typeof link.attr('data-width') !== 'undefined' ? parseInt(link.attr('data-width'), 10) : 640;
				var h = typeof link.attr('data-height') !== 'undefined' ? parseInt(link.attr('data-height'), 10) : 480;
				var l = Math.round((site.win.width() - w) / 2);
				var t = Math.round((site.win.height() - h) / 2);
				window.open(link.attr('href'), 'Popup', 'width=' + w + ',height=' + h + ',left=' + l + ',top=' + t + ',toolbar=no,scrollbar=yes');
				return false;
			});
			// done
			link.addClass('js-external-done');
		});
	}

};

$(function () {
	external.init();
	site.doc.ajaxComplete(function () {
		external.init();
	});
});
var featureBlockCtaOverlay = {

	links: $('[data-cta-overlay-link]'),

	dropdowns: $('[data-cta-overlay-dropdown]'),

	buttons: $('[data-cta-overlay-button]'),

	init: function () {

		if (featureBlockCtaOverlay.links.length) {
			featureBlockCtaOverlay.attachCtaEvents();
		}

		if (featureBlockCtaOverlay.dropdowns.length) {
			featureBlockCtaOverlay.attachDropdownEvents();
			
			featureBlockCtaOverlay.dropdowns.each(function (e) {
				featureBlockCtaOverlay.checkDropdownState($(this));
			});
		}

	},

	attachCtaEvents: function () {

		featureBlockCtaOverlay.links.on('click', function (e) {
			e.preventDefault();

			var target = $(this);

			$.magnificPopup.open({
				items: {
					src: target.attr('href'),
					type: 'inline'
				},
				mainClass: 'mfp-zoom-in mfp-no-close-text'
			});

		});

	},

	attachDropdownEvents: function () {

		featureBlockCtaOverlay.dropdowns.on('change', function (e) {
			featureBlockCtaOverlay.checkDropdownState($(this));
		});

	},

	checkDropdownState: function (dropdownElement) {
		var url = dropdownElement.val();
		if (url !== '') {
			featureBlockCtaOverlay.showButtonForDropdown(dropdownElement, url);
			featureBlockCtaOverlay.attachButtonEvents();
		} else {
			featureBlockCtaOverlay.hideButtonForDropdown(dropdownElement);
		}
	},

	attachButtonEvents: function () {
		featureBlockCtaOverlay.buttons.off('click').on('click', function (e) {
			e.preventDefault();
			var urlToGoTo = $(this).closest('[data-cta-overlay-dropdown-container]').find('[data-cta-overlay-dropdown]').val();
			window.location.href = urlToGoTo;
		});
	},

	showButtonForDropdown: function (dropdownElement, url) {
		featureBlockCtaOverlay.getButtonContainerForDropdown(dropdownElement).slideDown('fast').attr('aria-hidden', 'false');
		dropdownElement.closest('[data-cta-overlay-dropdown-container]').find('[data-cta-overlay-button]').attr('href', url);
	},

	hideButtonForDropdown: function (dropdownElement) {
		featureBlockCtaOverlay.getButtonContainerForDropdown(dropdownElement).slideUp('fast').attr('aria-hidden', 'true');
	},

	getButtonContainerForDropdown: function (dropdownElement) {
		return dropdownElement.closest('[data-cta-overlay-dropdown-container]').find('[data-cta-overlay-button-container]');
	}

};


$(function () {
	featureBlockCtaOverlay.init();
});
// documentation: http://dimsemenov.com/plugins/magnific-popup/documentation.html

var popups = {

	instance: $.magnificPopup.instance,

	delay: 200,
	useVideoAutoplay: true,

	scroll: {

		lock: function (filters) {

			var scrollWidth = site.getScrollWidth();

			$('.l-header').css('margin-right', scrollWidth);
			$('.sticky-filters--in').css('padding-right', scrollWidth);
			$('.l-page').css('padding-right', scrollWidth);
			
			if (filters) $('.m-filters__title, .m-filters__action, .m-filters__close').css('padding-right', scrollWidth);

			site.enableLockout();

		},

		unlock: function () {

			$('.l-header').css('margin-right', 0);
			$('[data-sticky-filters]').css('padding-right', 0);
			$('.l-page').css('padding-right', 0);

			site.disableLockout();

		}

	},

	closeLinks: function () {

		$('.js-popup-close:not(.js-popup-close-done)').each(function () {
			var link = $(this);
			link.off('click').on('click', function () { popups.close(); });
			link.addClass('js-popup-close-done');
		});

	},

	preInit: function () {

		var closeText = site.translations['settingsTranslationClose'] || 'Close';
		var loadingText = site.translations['settingsTranslationLoading'] || 'Loading...';

		// default settings
		$.extend(true, $.magnificPopup.defaults, {
			tClose: closeText,
			tLoading: loadingText,
			midClick: true,
			removalDelay: popups.delay,
			mainClass: 'mfp-zoom-in',
			closeMarkup: '<button type="button" class="mfp-close t-overlay-close" aria-label="' + closeText + '"><span class="offscreen">' + closeText + '</span></button>',
			callbacks: {
				open: function () {
					popups.closeLinks();
					popups.scroll.lock();
				},
				close: function () {
					if (typeof globalMap !== 'undefined') { globalMap.clear(); }
					popups.scroll.unlock();
				}
			}
		});

		// continue
		popups.init();
	},

	init: function () {

		// launch
		$('a.js-popup-launch:not(.js-popup-launch-done)').each(function () {
			var link = $(this);
			// open
			popups.launch(link);
			// done
			link.addClass('js-popup-launch-done');
		});

		// youtube
		$('a.video-popup[href*="youtube.com/watch?v="]:not(.js-popup-video-done), a.video-popup[href*="youtube.com/embed/"]:not(.js-popup-video-done)').each(function () {
			var link = $(this);
			// open
			popups.video(link);
			// done
			link.addClass('js-popup-video-done');
		});

		// vimeo
		$('a.video-popup[href^="https://vimeo.com/"]:not(.js-popup-video-done)').each(function () {
			var link = $(this);
			// open
			popups.video(link);
			// done
			link.addClass('js-popup-video-done');
		});

		// confirm
		$('a.js-popup-confirm:not(.js-popup-confirm-done)').each(function () {
			var link = $(this);
			var templateId = $('#popupConfirmTemplate');
			if (!templateId.length) return;
			// get template
			var template = Hogan.compile(templateId.html()).render({
				title: site.translations['contentConfirmTitle'] || 'Confirm',
				text: site.translations['contentConfrimText'] || 'Are you sure? This cannot be undone.',
				close: site.translations['settingsTranslationClose'] || 'Close',
				url: link.attr('href'),
				isNotice: true,
				confirm: site.translations['contentConfrimYes'] || 'Confirm',
				cancel: site.translations['contentConfrimNo'] || 'Cancel'
			});
			// open
			popups.inline(link, template, true);
			// done
			link.addClass('js-popup-confirm-done');
		});

		// share
		$('a.js-popup-share:not(.js-popup-share-done)').each(function () {
			var link = $(this);
			var templateId = $('#popupShareTemplate');
			if (!templateId.length) return;
			// get template
			var template = Hogan.compile(templateId.html()).render({
				title: site.translations['settingsTranslationShareTitle'] || 'Share',
				close: site.translations['settingsTranslationClose'] || 'Close',
				shareTitle: encodeURIComponent($('meta[property="og:title"]:first').attr('content')),
				shareUrl: encodeURIComponent($('meta[property="og:url"]:first').attr('content')),
				shareImage: encodeURIComponent($('meta[property="og:image"]:first').attr('content'))
			});
			// open
			popups.inline(link, template, false);
			// done
			link.addClass('js-popup-share-done');
		});

		// follow
		$('a.js-popup-follow:not(.js-popup-follow-done)').each(function () {
			var link = $(this);
			var templateId = $('#popupFollowTemplate');
			if (!templateId.length) return;
			// get template
			var template = Hogan.compile(templateId.html()).render({
				title: site.translations['settingsTranslationFollowTitle'] || 'Share',
				close: site.translations['settingsTranslationClose'] || 'Close'
			});
			// open
			popups.inline(link, template, false);
			// done
			link.addClass('js-popup-follow-done');
		});

		// close
		$('.js-popup-close:not(.js-popup-close-done)').each(function () {
			var link = $(this);
			// close
			link.off('click').on('click', function () {
				popups.close();
			});
			// done
			link.addClass('js-popup-close-done');
		});

		// bespoke popups
		popups.searchOverlay();
		popups.languageSelector.init();
		popups.earlyCareersLocationListLightbox.init();
		popups.filtersOverlay.init();

	},

	searchOverlay: function () {

		// search overlay
		$('.js-search-overlay:not(.js-search-overlay-done)').each(function () {
			var link = $(this);
			var templateId = $('#searchOverlayTemplate');
			if (!templateId.length) return;
			console.log(site);
			// get template
			var template = Hogan.compile(templateId.html()).render({
				close: site.translations['settingsTranslationClose'] || 'Close',
				searchResultsUrl: dysonCareersSettings.searchResultsUrl,
				placeholder: site.translations['settingsTranslationSearchPlaceholder'] || 'Close',
				button: site.translations['settingsTranslationSearchButton'] || 'Search'
			});

			// open
			link.magnificPopup({
				mainClass: 'mfp-search-overlay mfp-flush mfp-fade-in mfp-close-alt mfp-close-no-text t-search-overlay',
				items: {
					src: template,
					type: 'inline'
				},
				focus: '#search-overlay-query',
				callbacks: {
					open: function () {
						searchAutocomplete.init();
						popups.scroll.lock();
					},
					close: function () {
						popups.scroll.unlock();
					}
				}
			});

			// done
			link.addClass('js-search-overlay-done');
		});

		// takeovers
		$('.js-search-overlay-takeover:not(.js-search-overlay-takeover-done)').each(function () {
			var wrapper = $(this);

			// show takeover
			wrapper.find('.js-search-overlay-takeover-overlay').show();

			// disable text / button
			wrapper.find('.js-search-overlay-takeover-text, .js-search-overlay-takeover-button').attr('tabindex', '-1');

			// done
			wrapper.addClass('js-search-overlay-takeover-done');
		});

	},

	languageSelector: {

		endpoint: '/' + site.html.attr('lang') + '/api/languages?',

		init: function () {

			// language selector
			$('.js-language-selector:not(.js-language-selector-done)').each(function () {
				var link = $(this);
				var templateId = $('#languageSelectorTemplate');
				if (!templateId.length) return;

				// ajax
				link.magnificPopup({
					mainClass: 'mfp-language-selector mfp-flush',
					items: {
						type: 'ajax'
					},
					ajax: {
						settings: {
							url: popups.languageSelector.endpoint,
							data: {
								id: site.body.attr('data-node-id'),
								jobId: site.body.attr('data-job-id')
							}
						}
					},
					closeMarkup: '<div class="m-language-selector__close"><div class="max-page-width max-width-90"><a class="mfp-close" href="javascript:void(0)" aria-label="' + popups.filtersOverlay.closeText + '">' + popups.filtersOverlay.closeText + '</a></div></div>',
					callbacks: {
						parseAjax: function (response) {

							response.data = Hogan.compile(templateId.html()).render(response.data);

						},
						ajaxContentAdded: function () {

							var scrollWidth = site.getScrollWidth();
							$('.m-language-selector__title, .m-language-selector__close').css('padding-right', scrollWidth);

						}
					}
				});

				// done
				link.addClass('js-language-selector-done');
			});

		}

	},

	earlyCareersLocationListLightbox: {

		endpoint: '/' + site.html.attr('lang') + '/api/earlycareers/location',

		init: function () {

			// language selector
			$('.js-early-careers-location-list-trigger:not(.js-early-careers-location-list-trigger-done)').each(function () {
				var buttonElement = $(this);
				var templateId = $('#earlyCareersLocationListLightboxTemplate');
				if (!templateId.length) return;

				var contentId = buttonElement.attr('data-early-careers-location-list-content-id');
				var countryId = buttonElement.attr('data-early-careers-location-list-country-id');

				// ajax
				buttonElement.magnificPopup({
					mainClass: 'mfp-zoom-in',
					items: {
						type: 'ajax'
					},
					ajax: {
						settings: {
							url: popups.earlyCareersLocationListLightbox.endpoint,
							data: {
								contentid: contentId,
								countryid: countryId
							}
						}
					},
					closeMarkup: '<div class="m-early-careers-location-list-lightbox__close"><div class="max-page-width max-width-90"><button class="mfp-close t-early-careers-location-list-close" type="button" aria-label="' + popups.filtersOverlay.closeText + '"><span class="offscreen">' + popups.filtersOverlay.closeText + '</span></button></div></div>',
					callbacks: {
						open: function () {
							popups.scroll.lock();
						},
						close: function () {
							popups.scroll.unlock();
						},
						parseAjax: function (response) {
							response.data = Hogan.compile(templateId.html()).render(response.data);
						}
					}
				});

				// done
				buttonElement.addClass('js-early-careers-location-list-trigger');
			});

		}

	},

	filtersOverlay: {

		closeText: site.translations['settingsTranslationClose'] || 'Close',

		init: function () {

			$('.js-filters-overlay:not(.js-filters-overlay-done)').each(function () {
				var link = $(this);

				link.off('click').on('click', function () {

					var popName = $(this).attr('data-popup-name');

					$.magnificPopup.open({
						items: {
							src: popName
						},
						type: 'inline',
						mainClass: 'mfp-filters-overlay mfp-flush t-filters-overlay',
						autoFocusLast: false,
						alignTop: true,
						closeOnBgClick: false,
						fixedContentPos: false,
						closeMarkup: '<div class="m-filters__close"><div class="max-page-width max-width-90"><button type="button" class="mfp-close boom t-filter-overlay-close" aria-label="' + popups.filtersOverlay.closeText + '">' + popups.filtersOverlay.closeText + '</button></div></div>',
						callbacks: {
							beforeOpen: function () {
								// set flag to restore
								search.state.should_restore = true;
								// save form state
								search.state.save();
							},
							open: function () {
								popups.closeLinks();
								popups.scroll.lock(true);
							},
							close: function () {
								// restore form state
								search.state.restore();
								// disable lockout
								popups.scroll.unlock();
							}
						}
					});

				});

				// done
				link.addClass('js-filters-overlay-done');
			});

		}

	},

	close: function () {
		$.magnificPopup.close();
	},

	launch: function (link) {
		var templateId = $('#popupLaunchTemplate');
		if (!templateId.length) return;
		link.magnificPopup({
			type: 'ajax',
			alignTop: true,
			callbacks: {
				parseAjax: function (response) {
					response.data = Hogan.compile(templateId.html()).render({
						content: $(response.data).find('#popup-content-wrapper').html()
					});
				}
			}
		});
	},

	video: function (link) {

		var transcriptUrl = link.attr('data-video-transcript-url');
		var transcriptTarget = link.attr('data-video-transcript-target');
		var transcriptAltLabel = link.attr('data-video-transcript-alt-label');
		var transcriptCTA = link.attr('data-video-transcript-cta');

		link.magnificPopup({
			mainClass: 'mfp-zoom-in mfp-close-alt mfp-close-no-text mfp-video',
			type: 'iframe',
			srcAction: 'iframe_src',
			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close t-overlay-close" href="javascript:void(0)" aria-label="Close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
					'</div>' +
					generateTranscriptMarkup()
			} 
		});

		function generateTranscriptMarkup() {
			if (!transcriptUrl) {
				return '';
			}
			return '<a href="' + transcriptUrl + '" class="mfp-footer-link form-button form-button--small" target="' + transcriptTarget + '" aria-label="' + transcriptAltLabel + '">' +
			transcriptCTA +
			'</a >';
		}
	},

	inline: function (link, template, modal) {
		link.magnificPopup({
			items: {
				src: template,
				type: 'inline'
			},
			modal: modal
		});
	}

};

$(function () {
	popups.preInit();
	site.doc.ajaxComplete(function () {
		popups.init();
	});
});
var searchAutocomplete = function () {

  var publicMethods = {};

  var url = '/' + site.html.attr('lang') + '/api/search/autocomplete';

  publicMethods.init = function () {

    var elements = document.querySelectorAll('[data-autocomplete]:not([data-autocomplete="initialised"]');
    if (!elements.length) return;
    utils.each(elements, function (element, i, context) { setup(element); }, this);

  }

  function setup(element) {

		element.setAttribute('data-autocomplete', 'initialised');

		var form = element.closest('form');
		var appendContainer = element.closest('[data-autocomplete-container]');
		var autoCompleteAbortController;

		autocomplete({
			input: element,
			debounceWaitMs: 200,
			minLength: 2,
			disableAutoSelect: true,
			fetch: function (text, update) {

				var fetchUrl = url + '?q=' + text;

				if (autoCompleteAbortController) autoCompleteAbortController.abort();
				autoCompleteAbortController = new AbortController();
				var signal = autoCompleteAbortController.signal;

				fetch(fetchUrl, {
					signal: signal
				}).then(function (response) {

					if (response.ok) {

						return response.json();

					}

				}).then(function (data) {

					var items = data.items.map(function (item) {
						return {
							label: item.title,
							value: cleanValue(item.title),
							link: false,
							clickable: true
						};
					});

					if (data.fullSearchResultsSuccess) {

						items.unshift({
							label: data.fullSearchResultsText,
							value: text,
							link: true,
							clickable: data.fullSearchResultsCount > 0
						});

					}

					update(items);

				});
				
			},
			render: function (item, currentValue) {

				var button = document.createElement('button');
				var classToAdd = 'autocomplete__item';
				if (!item.clickable) classToAdd += ' autocomplete__item--disabled';

				button.setAttribute('aria-label', item.value);
				button.setAttribute('class', classToAdd);
				button.setAttribute('type', 'button');
				button.setAttribute('tabindex', '-1');
				button.innerHTML = item.label;
				return button;

			},
			onSelect: function (item) {

				if (item.clickable) {

					element.value = item.value;
					if (form) form.submit();

				}

			},
			customize: function (input, inputRect, container, maxHeight) {

				if (appendContainer) appendContainer.appendChild(container);

			}
		});

	}

	function cleanValue(input) {

		var div = document.createElement('div');
		div.innerHTML = input;

		var output = div.innerText;
		return output.replace(/"/g, "'");

	}

	return publicMethods;

}();

searchAutocomplete.init();
var statusBanner = {

	statusBanner: document.querySelector('.js-status-banner'),

	hideButton: document.querySelector('.js-status-banner-hide'),

	init: function () {

		if (statusBanner.statusBanner && statusBanner.hideButton) {

			statusBanner.hideButton.addEventListener('click', function () {
				var cookieName = statusBanner.hideButton.getAttribute('data-cookie-name');
				var cookieContent = statusBanner.hideButton.getAttribute('data-cookie-content');
				var cookieLength = statusBanner.hideButton.getAttribute('data-cookie-length');
				setCookie(cookieName, cookieContent, cookieLength);
				statusBanner.statusBanner.classList.add('is-hidden');
			});

		}

	}

};

statusBanner.init();
var tabs = function () {

	var tabTriggers = document.querySelectorAll('.js-tab');

	function init() {

		if (!tabTriggers.length) {
			return;
		}

		attachEvents();

		setContainerWidth();

		var debouncedResizeEvent = utils.debounce(function () {
			setContainerWidth();
		}, 150);
		window.addEventListener('resize', debouncedResizeEvent);

		setTimeout(function () {
			setContainerWidth();
		}, 1000);

	}

	function attachEvents() {
		for (var i = 0; i < tabTriggers.length; i++) {
			attachToggleEvent(tabTriggers[i]);
		}
	}

	function attachToggleEvent(trigger) {
		trigger.addEventListener('click', function (e) {

			var targetElement = e.currentTarget.getAttribute('aria-controls');

			setOtherTabs();
			e.currentTarget.classList.add('is-active');
			document.querySelector('#' + targetElement).setAttribute('aria-hidden', 'false');

			e.preventDefault();
		});
	}

	function setOtherTabs() {

		for (var i = 0; i < tabTriggers.length; i++) {
			var currentTabElement = tabTriggers[i];
			currentTabElement.classList.remove('is-active');
			var targetElement = currentTabElement.getAttribute('aria-controls');
			document.querySelector('#' + targetElement).setAttribute('aria-hidden', 'true');
		}

	}


	function setContainerWidth() {
		var tabList = document.querySelector('.js-tabs-list');
		tabList.style.width = '1500px';
		var tabListItem = document.querySelectorAll('.js-tabs-list-item');
		var widthToSet = 0;
		for (var i = 0; i < tabListItem.length; i++) {
			widthToSet += tabListItem[i].clientWidth;
		}
		tabList.style.width = widthToSet + 'px';
	}

	return {
		init: init
	};

}();

if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
	tabs.init();
} else {
	window.addEventListener('load', function () {
		tabs.init();
	});
}
var takeoverLink = {

	init: function () {

		$('.js-takeover-link:not(.js-takeover-link-done)').each(function () {
			var link = $(this);
			var id = $('a' + link.attr('data-takeover-id'));

			if (!id.length) return false;

			// click
			link.off('click').on('click', function () {
				// click
				id.click();
				// scroll to
				if (link.attr('data-takeover-scroll')) {
					site.scrollTo($(link.attr('data-takeover-scroll')).offset().top);
				}				
				return false;
			});

			// done
			link.addClass('js-takeover-link-done');
		});

	}

};

$(function () {
	takeoverLink.init();
	site.doc.ajaxComplete(function () {
		takeoverLink.init();
	});
});
var backgroundImage = function () {

  var publicMethods = {};

  var intersectionIsSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
  var hasIntersectedAttribute = 'data-background-image-has-intersected';

  publicMethods.init = function () {

    var elements = document.querySelectorAll('[data-background-image]:not([data-background-image="loaded"])');

    if (!elements.length) return;

    if (intersectionIsSupported) {

      var observer = new IntersectionObserver(function (entries) {

        utils.each(entries, function (entry, i, context) {

          if (entry.isIntersecting) {

            entry.target.setAttribute(hasIntersectedAttribute, 'true');
            setup(entry.target);

          }

        }, this);

      }, { threshold: 0.25 });

      utils.each(elements, function (element, i, context) { observer.observe(element); }, this);

    } else {

      utils.each(elements, function (element, i, context) { setup(element); }, this);

		}

  };

  function setup(element) {

    if (intersectionIsSupported && !element.hasAttribute(hasIntersectedAttribute)) return;

    var imageUrl = element.getAttribute('data-background-image-url');

    element.style.backgroundImage = 'url(' + imageUrl + ')';
    element.setAttribute('data-background-image', 'loaded');

  };

  return publicMethods;

}();

$(function () {
  backgroundImage.init(true);
  site.doc.ajaxComplete(function () {
    backgroundImage.init();
  });
});
var share = function () {

  var publicMethods = {};

  var attributeName = 'data-share';

  var elements = document.querySelectorAll('[' + attributeName + ']');

  publicMethods.init = function () {

    if (!elements.length || !navigator.share) return;

    utils.each(elements, function (element, i, context) {

      render(element);

    }, this);

  };

  function render(element) {

    element.setAttribute(attributeName, 'initialised');

    var shareTitle = element.getAttribute(attributeName + '-title');
    var title = element.querySelector('[' + attributeName + '-title' + ']').innerHTML;
    var url = element.getAttribute(attributeName + '-url');
    var icon = getIcon();
    var inner = element.querySelector('[data-share-inner]');

    inner.insertAdjacentHTML('beforeend', '<button type="button" class="form-button form-button--secondary form-button--share" ' + attributeName + '-button><span class="form-button--share__text">' + title + '</span>' + icon + '</button>');

    var button = element.querySelector('[' + attributeName + '-button' + ']');

    button.addEventListener('click', function () {

      navigator.share({
        title: shareTitle,
        url: url
      }).then(function () {

      }).catch(function () {

      });

    });

  }

  function getIcon() {

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var iconName = 'icon-share';
    iconName = isIOS ? iconName + '-ios' : iconName;
    var additionalClassName = isIOS ? ' form-button--share__icon--ios' : '';

    return '<svg class="form-button--share__icon' + additionalClassName + '"><use xlink:href="#' + iconName + '"></use></svg>';

  }

  return publicMethods;

}();

share.init();
